export const phenotype_information = ["17 alpha hydroxylase/17,20 lyase deficiency",
"17,20 lyase deficiency, isolated",
"2 aminoadipic 2 oxoadipic aciduria",
"2 methylbutyrylglycinuria",
"2,4 dienoyl coa reductase deficiency",
"2-aminoadipic 2-oxoadipic aciduria  mondo:0008774",
"2-methylbutyryl-coa dehydrogenase deficiency  mondo:0012392",
"3 hydroxyacyl coa dehydrogenase deficiency",
"3 hydroxyisobutryl coa hydrolase deficiency",
"3 m syndrome 1",
"3 m syndrome 2",
"3 m syndrome 3",
"3 methylcrotonyl coa carboxylase 1 deficiency",
"3 methylcrotonyl coa carboxylase 2 deficiency",
"3 methylglutaconic aciduria with deafness, encephalopathy, and leigh like syndrome",
"3 methylglutaconic aciduria, type i",
"3 methylglutaconic aciduria, type iii",
"3 methylglutaconic aciduria, type ix",
"3 methylglutaconic aciduria, type v",
"3 methylglutaconic aciduria, type vii, with cataracts, neurologic involvement and neutropenia",
"3 methylglutaconic aciduria, type viii",
"3-hydroxy-3-methylglutaric aciduria  mondo:0009520",
"3-hydroxy-3-methylglutaryl-coa synthase deficiency  mondo:0011614",
"3-hydroxyisobutyric aciduria  mondo:0009371",
"3-hydroxyisobutyryl-coa hydrolase deficiency  mondo:0009603",
"3-methylcrotonyl-coa carboxylase deficiency  mondo:0018950",
"3-methylglutaconic aciduria type 1  mondo:0009610",
"3-methylglutaconic aciduria type 5  mondo:0012435",
"3-methylglutaconic aciduria type 8  mondo:0044723",
"3-methylglutaconic aciduria type 9  mondo:0044724",
"3mc syndrome 1",
"3mc syndrome 2",
"3mc syndrome 3",
"46, xx sex reversal 4",
"46, xy sex reversal 11",
"46,xx sex reversal 5",
"46xx sex reversal 1",
"46xy gonadal dysgenesis with minifascicular neuropathy",
"46xy sex reversal 1",
"46xy sex reversal 2, dosage sensitive",
"46xy sex reversal 3",
"46xy sex reversal 5",
"46xy sex reversal 6",
"46xy sex reversal 7",
"46xy sex reversal 8",
"46xy sex reversal 8, modifier of",
"46xy sex reversal 9",
"5 fluorouracil toxicity",
"5 oxoprolinase deficiency",
":immunodeficiency due to defect in mapbp interacting protein",
"aarskog scott syndrome",
"aarskog-scott syndrome, x-linked  mondo:0010589",
"abacavir hypersensitivity, susceptibility to",
"abca4-related retinopathy  mondo:0800406",
"abcd syndrome",
"abdominal obesity metabolic syndrome 3",
"abdominal obesity metabolic syndrome 4",
"abetalipoproteinemia",
"ablepharon macrostomia syndrome",
"abnormal hair, joint laxity, and developmental delay",
"abruzzo erickson syndrome",
"acampomelic campomelic dysplasia",
"acat2 deficiency",
"acatalasemia",
"acatalasia  mondo:0013571",
"accelerated tumor formation, susceptibility to",
"acces syndrome  mondo:0859262",
"acd-related short telomere syndrome  mondo:0100569",
"acetyl coa carboxylase deficiency",
"acetyl-coa acetyltransferase-2 deficiency  mondo:0013548",
"acetylation, slow",
"achalasia addisonianism alacrimia syndrome",
"acheiropody",
"achondrogenesis ib",
"achondrogenesis type ib  mondo:0010966",
"achondrogenesis type ii  mondo:0008702",
"achondrogenesis, type ia",
"achondrogenesis, type ii or hypochondrogenesis",
"achondroplasia",
"achondroplasia  mondo:0007037",
"achromatopsia  mondo:0018852",
"achromatopsia 2",
"achromatopsia 3",
"achromatopsia 4",
"achromatopsia 6",
"achromatopsia 7",
"acid labile subunit, deficiency of",
"acid sphingomyelinase deficiency  mondo:0100464",
"acne inversa, familial, 1",
"acne inversa, familial, 2, with or without dowling degos disease",
"acne inversa, familial, 3",
"acrocallosal syndrome",
"acrocapitofemoral dysplasia",
"acrodermatitis enteropathica",
"acrodysostosis 1, with or without hormone resistance",
"acrodysostosis 2, with or without hormone resistance",
"acrofacial dysostosis 1, nager type",
"acrofacial dysostosis, cincinnati type",
"acrokeratosis verruciformis",
"acromelic frontonasal dysostosis",
"acromesomelic dysplasia, demirhan type",
"acromesomelic dysplasia, hunter thompson type",
"acromesomelic dysplasia, maroteaux type",
"acromicric dysplasia",
"actb-associated syndromic thrombocytopenia  mondo:0100433",
"acth independent macronodular adrenal hyperplasia",
"acth independent macronodular adrenal hyperplasia 2",
"actl6a-related bafopathy  mondo:0700121",
"acute intermittent porphyria  mondo:0008294",
"acute myeloid leukemia  mondo:0018874",
"acute myeloid leukemia, somatic",
"acyl coa dehydrogenase, medium chain, deficiency of",
"acyl coa dehydrogenase, short chain, deficiency of",
"acyl-coa binding domain containing protein 5 deficiency  mondo:0100112",
"acyl-coa dehydrogenase 9 deficiency  mondo:0012624",
"adam9-related retinopathy  mondo:0800398",
"adams oliver syndrome 1",
"adams oliver syndrome 2",
"adams oliver syndrome 3",
"adams oliver syndrome 4",
"adams oliver syndrome 5",
"adams oliver syndrome 6",
"adams-oliver syndrome  mondo:0007034",
"adar-related type 1 interferonopathy  mondo:0700261",
"adenine phosphoribosyltransferase deficiency",
"adenocarcinoma of lung, response to tyrosine kinase inhibitor in",
"adenocarcinoma of lung, somatic",
"adenocarcinoma, colonic, somatic",
"adenoma, periampullary, somatic",
"adenomas, multiple colorectal",
"adenomas, salivary gland pleomorphic, somatic",
"adenomatous polyposis coli",
"adenosine deaminase deficiency, partial",
"adenosine kinase deficiency  mondo:0100255",
"adenosine triphosphate, elevated, of erythrocytes",
"adenylosuccinase deficiency",
"adenylosuccinate lyase deficiency  mondo:0007068",
"adermatoglyphia",
"adiponectin deficiency",
"adnp-related multiple congenital anomalies - intellectual disability - autism spectrum disorder  mondo:0014379",
"adrenal adenoma, somatic",
"adrenal hyperplasia, congenital, due to 11 beta hydroxylase deficiency",
"adrenal hyperplasia, congenital, due to 21 hydroxylase deficiency",
"adrenal hyperplasia, congenital, due to 3 beta hydroxysteroid dehydrogenase 2 deficiency",
"adrenal hypoplasia, congenital",
"adrenal insufficiency, congenital, with 46xy sex reversal, partial or complete",
"adrenocortical carcinoma, pediatric",
"adrenocortical insufficiency",
"adrenocortical tumor, somatic",
"adrenocorticotropic hormone deficiency",
"adrenoleukodystrophy",
"adrenoleukodystrophy  mondo:0018544",
"adrenomyeloneuropathy, adult",
"adult hypophosphatasia  obsolete termmondo:0007798",
"adult i phenotype without cataract",
"adult neuronal ceroid lipofuscinosis  mondo:0019260",
"adult syndrome",
"advanced sleep phase syndrome, familial, 1",
"advanced sleep phase syndrome, familial, 2",
"advanced sleep phase syndrome, familial, 3",
"aerodigestive tract cancer, squamous cell, alcohol related, protection against",
"afibrinogenemia, congenital",
"agammaglobulinemia  mondo:0015977",
"agammaglobulinemia 10, autosomal dominant  mondo:0030529",
"agammaglobulinemia 2",
"agammaglobulinemia 2, autosomal recessive  mondo:0013287",
"agammaglobulinemia 3",
"agammaglobulinemia 3, autosomal recessive  mondo:0013288",
"agammaglobulinemia 4",
"agammaglobulinemia 4, autosomal recessive  mondo:0013289",
"agammaglobulinemia 5",
"agammaglobulinemia 6",
"agammaglobulinemia 6, autosomal recessive  mondo:0012987",
"agammaglobulinemia 7, autosomal recessive",
"agammaglobulinemia 7, autosomal recessive  mondo:0014083",
"agammaglobulinemia 8, autosomal dominant",
"agammaglobulinemia, x linked 1",
"agat deficiency  mondo:0012996",
"agenesis of corpus callosum, cardiac, ocular, and genital syndrome",
"agenesis of the corpus callosum with peripheral neuropathy",
"agnathia otocephaly complex",
"ahdc1-related intellectual disability - obstructive sleep apnea - mild dysmorphism syndrome  mondo:0014358",
"aica ribosiduria due to atic deficiency",
"aicardi goutieres syndrome 1, dominant and recessive",
"aicardi goutieres syndrome 2",
"aicardi goutieres syndrome 3",
"aicardi goutieres syndrome 4",
"aicardi goutieres syndrome 5",
"aicardi goutieres syndrome 6",
"aicardi goutieres syndrome 7",
"aids, delayed/rapid progression to",
"aids, rapid progression to",
"aids, resistance to",
"aids, slow progression to",
"aipl1-related retinopathy  mondo:0100438",
"al gazali bakalinova syndrome",
"al gazali syndrome",
"al kaissi syndrome",
"al raqad syndrome",
"alacrima, achalasia, and intellectual disability syndrome  mondo:0014219",
"alacrima, achalasia, and mental retardation syndrome",
"alagille syndrome 1",
"alagille syndrome 2",
"aland island eye disease",
"alanine glyoxylate aminotransferase deficiency  mondo:0100278",
"alazami syndrome",
"alazami yuan syndrome",
"albinism, brown oculocutaneous",
"albinism, oculocutaneous, type ia",
"albinism, oculocutaneous, type ib",
"albinism, oculocutaneous, type ii",
"albinism, oculocutaneous, type ii, modifier of",
"albinism, oculocutaneous, type iii",
"albinism, oculocutaneous, type iv",
"albinism, oculocutaneous, type vi",
"albinism, oculocutaneous, type vii",
"alcohol dependence, protection against",
"alcohol dependence, susceptibility to",
"alcohol sensitivity, acute",
"aldosterone to renin ratio raised",
"aldosteronism, glucocorticoid remediable",
"alexander disease",
"alexander disease  mondo:0008752",
"alg1-congenital disorder of glycosylation  mondo:0012052",
"alg11-congenital disorder of glycosylation  mondo:0013349",
"alg12-congenital disorder of glycosylation  mondo:0011783",
"alg2-congenital disorder of glycosylation  mondo:0011933",
"alg3-congenital disorder of glycosylation  mondo:0010998",
"alg6-congenital disorder of glycosylation 1c  mondo:0011291",
"alg9-associated autosomal dominant polycystic kidney disease  mondo:0700000",
"alkaptonuria",
"alkaptonuria  mondo:0008753",
"alkylglycerone-phosphate synthase deficiency  mondo:0100274",
"allan herndon dudley syndrome",
"allan-herndon-dudley syndrome  mondo:0010354",
"allergic rhinitis, susceptibility to",
"alopecia mental retardation syndrome 1",
"alopecia mental retardation syndrome 4",
"alopecia universalis",
"alopecia, neurologic defects, and endocrinopathy syndrome",
"alpha 1 antichymotrypsin deficiency",
"alpha 2 plasmin inhibitor deficiency",
"alpha actinin 3 deficiency",
"alpha fetoprotein deficiency",
"alpha ketoglutarate dehydrogenase deficiency",
"alpha methylacetoacetic aciduria",
"alpha methylacyl coa racemase deficiency",
"alpha thalassemia  mondo:0011399",
"alpha thalassemia myelodysplasia syndrome, somatic",
"alpha thalassemia/mental retardation syndrome",
"alpha-2-plasmin inhibitor deficiency  mondo:0009883",
"alpha-actinopathy  mondo:0100084",
"alpha-mannosidosis  mondo:0009561",
"alpha-methylacyl-coa racemase deficiency  mondo:0013681",
"alpha-n-acetylgalactosaminidase deficiency  mondo:0017779",
"alpha/beta t cell lymphopenia with gamma/delta t cell expansion, severe cytomegalovirus infection, and autoimmunity",
"alport syndrome  mondo:0018965",
"alport syndrome 1, x linked",
"alport syndrome 2, autosomal recessive",
"alport syndrome 3, autosomal dominant",
"als2-related motor neuron disease  mondo:0100227",
"alstrom syndrome",
"alstrom syndrome  mondo:0008763",
"alternating hemiplegia of childhood 1",
"alternating hemiplegia of childhood 2",
"alveolar capillary dysplasia with misalignment of pulmonary veins",
"alveolar soft part sarcoma",
"alzahrani-kuwahara syndrome  mondo:0859136",
"alzheimer disease 1, familial",
"alzheimer disease 18, susceptibility to",
"alzheimer disease 2",
"alzheimer disease 4",
"alzheimer disease 9, susceptibility to",
"alzheimer disease, late onset, susceptibility to",
"alzheimer disease, protection against, due to apoe3 christchurch",
"alzheimer disease, susceptibility to",
"alzheimer disease, type 3",
"alzheimer disease, type 3, with spastic paraparesis and apraxia",
"alzheimer disease, type 3, with spastic paraparesis and unusual plaques",
"amed syndrome, digenic",
"amelia, posterior, with pelvic and pulmonary hypoplasia syndrome",
"amelocerebrohypohidrotic syndrome  mondo:0009185",
"amelogenesis imperfecta  mondo:0019507",
"amelogenesis imperfecta, hypomaturation type",
"amelogenesis imperfecta, type 1e",
"amelogenesis imperfecta, type ia",
"amelogenesis imperfecta, type ib",
"amelogenesis imperfecta, type ic",
"amelogenesis imperfecta, type if",
"amelogenesis imperfecta, type ig enamel renal syndrome",
"amelogenesis imperfecta, type ih",
"amelogenesis imperfecta, type iia1",
"amelogenesis imperfecta, type iia2",
"amelogenesis imperfecta, type iia3",
"amelogenesis imperfecta, type iia4",
"amelogenesis imperfecta, type iia5",
"amelogenesis imperfecta, type iiia",
"amelogenesis imperfecta, type iiib",
"amelogenesis imperfecta, type iiic",
"amelogenesis imperfecta, type ij",
"amelogenesis imperfecta, type iv",
"aminoacylase 1 deficiency",
"aminoacylase 1 deficiency  mondo:0012368",
"amp deaminase deficiency, erythrocytic",
"amyloidosis, 3 or more types",
"amyloidosis, familial visceral",
"amyloidosis, finnish type",
"amyloidosis, hereditary, transthyretin related",
"amyloidosis, primary localized cutaneous, 1",
"amyloidosis, primary localized cutaneous, 2",
"amyloidosis, primary localized cutaneous, 3",
"amyloidosis, renal",
"amyloidosis, secondary, susceptibility to",
"amyotrophic lateral sclerosis  mondo:0004976",
"amyotrophic lateral sclerosis 1",
"amyotrophic lateral sclerosis 10, with or without ftd",
"amyotrophic lateral sclerosis 11",
"amyotrophic lateral sclerosis 12 with or without frontotemporal dementia",
"amyotrophic lateral sclerosis 15, with or without frontotemporal dementia",
"amyotrophic lateral sclerosis 16, juvenile",
"amyotrophic lateral sclerosis 18",
"amyotrophic lateral sclerosis 19",
"amyotrophic lateral sclerosis 2, juvenile",
"amyotrophic lateral sclerosis 20",
"amyotrophic lateral sclerosis 21",
"amyotrophic lateral sclerosis 22 with or without frontotemporal dementia",
"amyotrophic lateral sclerosis 26 with or without frontotemporal dementia",
"amyotrophic lateral sclerosis 26 with or without frontotemporal dementia  mondo:0030885",
"amyotrophic lateral sclerosis 4, juvenile",
"amyotrophic lateral sclerosis 5, juvenile",
"amyotrophic lateral sclerosis 6, with or without frontotemporal dementia",
"amyotrophic lateral sclerosis 8",
"amyotrophic lateral sclerosis 9",
"amyotrophic lateral sclerosis parkinsonism/dementia complex, susceptibility to",
"amyotrophic lateral sclerosis type 1  mondo:0007103",
"amyotrophic lateral sclerosis type 10  mondo:0012790",
"amyotrophic lateral sclerosis type 11  mondo:0012945",
"amyotrophic lateral sclerosis type 12  mondo:0013264",
"amyotrophic lateral sclerosis type 15  mondo:0010459",
"amyotrophic lateral sclerosis type 18  mondo:0013891",
"amyotrophic lateral sclerosis type 19  mondo:0014223",
"amyotrophic lateral sclerosis type 20  mondo:0014181",
"amyotrophic lateral sclerosis type 22  mondo:0014531",
"amyotrophic lateral sclerosis type 23  mondo:0027694",
"amyotrophic lateral sclerosis type 6  mondo:0011951",
"amyotrophic lateral sclerosis type 8  mondo:0012077",
"amyotrophic lateral sclerosis type 9  mondo:0012753",
"amyotrophic lateral sclerosis, susceptibility to",
"amyotrophic lateral sclerosis, susceptibility to, 13",
"amyotrophic lateral sclerosis, susceptibility to, 24",
"amyotrophic lateral sclerosis, susceptibility to, 24  mondo:0054750",
"amyotrophic lateral sclerosis, susceptibility to, 25",
"amyotrophic lateral sclerosis, susceptibility to, 25  mondo:0060670",
"amyotrophy, hereditary neuralgic",
"amytrophic lateral sclerosis 23",
"analbuminemia",
"analgesia from kappa opioid receptor agonist, female specific",
"anauxetic dysplasia 1",
"anauxetic dysplasia 2",
"anauxetic dysplasia 3",
"andersen syndrome",
"androgen insensitivity",
"androgen insensitivity, partial, with or without breast cancer",
"anemia, hemolytic, due to umph1 deficiency",
"anemia, hemolytic, rh null, regulator type",
"anemia, hypochromic microcytic, with iron overload 1",
"anemia, hypochromic microcytic, with iron overload 2",
"anemia, neonatal hemolytic, fatal or near fatal",
"anemia, nonspherocytic hemolytic, due to g6pd deficiency  mondo:0010480",
"anemia, sideroblastic, 1",
"anemia, sideroblastic, 2, pyridoxine refractory",
"anemia, sideroblastic, 3, pyridoxine refractory",
"anemia, sideroblastic, 4",
"anemia, sideroblastic, with ataxia",
"anemia, x linked, with/without neutropenia and/or platelet abnormalities",
"anencephaly",
"aneurysm, intracranial berry, 12",
"aneurysm-osteoarthritis syndrome  mondo:0013426",
"angelman syndrome",
"angelman syndrome  mondo:0007113",
"angioedema induced by ace inhibitors, susceptibility to",
"angioedema, hereditary, type iii",
"angioedema, hereditary, types i and ii",
"angiofibroma, somatic",
"angiopathy, hereditary, with nephropathy, aneurysms, and muscle cramps",
"angiotensin i converting enzyme, benign serum increase",
"anhaptoglobinemia",
"anhidrosis, isolated, with normal sweat glands",
"aniridia",
"aniridia  mondo:0019172",
"aniridia 2",
"aniridia 3",
"aniridia 3  mondo:0014938",
"aniridia-cerebellar ataxia-intellectual disability syndrome  mondo:0008795",
"anonychia congenita",
"anorexia nervosa, susceptibility to",
"antecubital pterygium syndrome  mondo:0008339",
"anterior segment anomalies with or without cataract",
"anterior segment dysgenesis 1, multiple subtypes",
"anterior segment dysgenesis 2, multiple subtypes",
"anterior segment dysgenesis 3  mondo:0024456",
"anterior segment dysgenesis 3, multiple subtypes",
"anterior segment dysgenesis 4",
"anterior segment dysgenesis 5, multiple subtypes",
"anterior segment dysgenesis 6, multiple subtypes",
"anterior segment dysgenesis 7  mondo:0010015",
"anterior segment dysgenesis 7, with sclerocornea",
"anterior segment dysgenesis 8",
"anterior segment dysgenesis 8  mondo:0015017",
"antisocial behavior",
"antley bixler syndrome with genital anomalies and disordered steroidogenesis",
"antley bixler syndrome without genital anomalies or disordered steroidogenesis",
"antley-bixler syndrome with genital anomalies and disordered steroidogenesis  mondo:0008726",
"anxiety related personality traits",
"aortic aneurysm, familial thoracic 10",
"aortic aneurysm, familial thoracic 11, susceptibility to",
"aortic aneurysm, familial thoracic 4",
"aortic aneurysm, familial thoracic 6",
"aortic aneurysm, familial thoracic 7",
"aortic aneurysm, familial thoracic 8",
"aortic aneurysm, familial thoracic 9",
"aortic valve disease 1",
"aortic valve disease 2",
"aortic valve disease 3",
"ap-4 deficiency syndrome  mondo:0100176",
"apert syndrome",
"apert syndrome  mondo:0007041",
"aphasia, primary progressive",
"aplasia cutis congenita, nonsyndromic",
"aplasia of lacrimal and salivary glands",
"aplastic anemia",
"aplastic anemia, susceptibility to",
"apnea, postanesthetic, susceptibility to, due to bche deficiency",
"apoa i and apoc iii deficiency, combined",
"apolipoprotein a ii deficiency",
"apolipoprotein c iii deficiency",
"apparent mineralocorticoid excess",
"apparent mineralocorticoid excess  mondo:0009025",
"aquaporin 1 deficiency",
"arboleda tham syndrome",
"argininemia",
"argininosuccinic aciduria",
"argininosuccinic aciduria  mondo:0008815",
"arhinia, choanal atresia, and microphthalmia  mondo:0011323",
"aromatase deficiency",
"aromatase excess syndrome",
"aromatic l amino acid decarboxylase deficiency",
"aromatic l-amino acid decarboxylase deficiency  mondo:0012084",
"arrhythmogenic cardiomyopathy with wooly hair and keratoderma  mondo:0011581",
"arrhythmogenic right ventricular cardiomyopathy  mondo:0016587",
"arrhythmogenic right ventricular dysplasia 1",
"arrhythmogenic right ventricular dysplasia 10",
"arrhythmogenic right ventricular dysplasia 11",
"arrhythmogenic right ventricular dysplasia 11 with mild palmoplantar keratoderma and woolly hair",
"arrhythmogenic right ventricular dysplasia 12",
"arrhythmogenic right ventricular dysplasia 2",
"arrhythmogenic right ventricular dysplasia 5",
"arrhythmogenic right ventricular dysplasia 5  mondo:0011459",
"arrhythmogenic right ventricular dysplasia 8",
"arrhythmogenic right ventricular dysplasia 9",
"arrhythmogenic right ventricular dysplasia, familial, 13",
"arrhythmogenic right ventricular dysplasia, familial, 14",
"arterial calcification, generalized, of infancy, 1",
"arterial calcification, generalized, of infancy, 1  mondo:0008817",
"arterial calcification, generalized, of infancy, 2",
"arterial tortuosity syndrome",
"arterial tortuosity syndrome  mondo:0008818",
"arteriovenous malformation of the brain, somatic",
"arthrogryposis multiplex congenita  mondo:0015168",
"arthrogryposis multiplex congenita 1, neurogenic, with myelin defect",
"arthrogryposis multiplex congenita 2, neurogenic type",
"arthrogryposis multiplex congenita 3, myogenic type",
"arthrogryposis multiplex congenita 4, neurogenic, with agenesis of the corpus callosum",
"arthrogryposis multiplex congenita 5",
"arthrogryposis syndrome  mondo:0015225",
"arthrogryposis, cleft palate, craniosynostosis, and impaired intellectual development",
"arthrogryposis, distal, type 1a",
"arthrogryposis, distal, type 1b",
"arthrogryposis, distal, type 2a freeman sheldon",
"arthrogryposis, distal, type 2b1",
"arthrogryposis, distal, type 2b2",
"arthrogryposis, distal, type 2b3 sheldon hall",
"arthrogryposis, distal, type 2b4",
"arthrogryposis, distal, type 3",
"arthrogryposis, distal, type 5",
"arthrogryposis, distal, type 5d",
"arthrogryposis, distal, with impaired proprioception and touch",
"arthrogryposis, mental retardation, and seizures",
"arthrogryposis, perthes disease, and upward gaze palsy",
"arthrogryposis, renal dysfunction, and cholestasis 1",
"arthrogryposis, renal dysfunction, and cholestasis 1  mondo:0008822",
"arthrogryposis, renal dysfunction, and cholestasis 2",
"arthrogryposis, renal dysfunction, and cholestasis 2  mondo:0013255",
"arts syndrome",
"asah1-related sphingolipidosis  mondo:0100524",
"asparagine synthetase deficiency",
"aspartate aminotransferase, serum level of, qtl1",
"aspartylglucosaminuria",
"aspartylglucosaminuria  mondo:0008830",
"asperger syndrome susceptibility, x linked 1",
"asperger syndrome susceptibility, x linked 2",
"aspergillosis, susceptibility to",
"asplenia, isolated congenital",
"asthma and nasal polyps",
"asthma related traits, susceptibility to, 7",
"asthma susceptibility 5",
"asthma, aspirin induced, susceptibility to",
"asthma, diminished response to antileukotriene treatment in",
"asthma, nocturnal, susceptibility to",
"asthma, protection against",
"asthma, susceptibility to",
"asthma, susceptibility to, 1",
"asthma, susceptibility to, 2",
"ataxia oculomotor apraxia 3",
"ataxia oculomotor apraxia 4",
"ataxia pancytopenia syndrome",
"ataxia telangiectasia",
"ataxia telangiectasia  mondo:0008840",
"ataxia telangiectasia like disorder 1",
"ataxia telangiectasia like disorder 2",
"ataxia with isolated vitamin e deficiency",
"ataxia, cerebellar, cayman type",
"ataxia, combined cerebellar and peripheral, with hearing loss and diabetes mellitus",
"ataxia, early onset, with oculomotor apraxia and hypoalbuminemia",
"ataxia, posterior column, with retinitis pigmentosa",
"ataxia, sensory, 1, autosomal dominant",
"atelosteogenesis type ii  mondo:0009727",
"atelosteogenesis, type i",
"atelosteogenesis, type ii",
"atelosteogenesis, type iii",
"atf6-related retinopathy  mondo:0100447",
"athabaskan brainstem dysgenesis syndrome",
"atherosclerosis, susceptibility to",
"atopy, susceptibility to",
"atp1a3-associated neurological disorder  mondo:0700002",
"atp6ap2-related disorder  mondo:0100146",
"atr-x-related syndrome  mondo:0016980",
"atransferrinemia",
"atrial fibrillation 15",
"atrial fibrillation, familial, 10",
"atrial fibrillation, familial, 11",
"atrial fibrillation, familial, 12",
"atrial fibrillation, familial, 13",
"atrial fibrillation, familial, 14",
"atrial fibrillation, familial, 16",
"atrial fibrillation, familial, 17",
"atrial fibrillation, familial, 18",
"atrial fibrillation, familial, 3",
"atrial fibrillation, familial, 4",
"atrial fibrillation, familial, 6",
"atrial fibrillation, familial, 7",
"atrial fibrillation, familial, 9",
"atrial septal defect 2",
"atrial septal defect 3",
"atrial septal defect 4",
"atrial septal defect 5",
"atrial septal defect 6",
"atrial septal defect 7, with or without av conduction defects",
"atrial septal defect 8",
"atrial septal defect 9",
"atrial standstill 2",
"atrial standstill, digenic gja5/scn5a",
"atrichia with papular lesions",
"atrioventricular septal defect 3",
"atrioventricular septal defect 4",
"atrioventricular septal defect 5",
"atrioventricular septal defect, partial, with heterotaxy syndrome",
"atrioventricular septal defect, susceptibility to, 2",
"attention deficit hyperactivity disorder",
"attention deficit hyperactivity disorder, susceptibility to",
"attention deficit hyperactivity disorder, susceptibility to, 7",
"atypical hemolytic-uremic syndrome  mondo:0016244",
"atypical hemolytic-uremic syndrome with b factor anomaly  mondo:0013042",
"atypical hemolytic-uremic syndrome with c3 anomaly  mondo:0013043",
"au kline syndrome",
"auditory neuropathy  mondo:0021944",
"auditory neuropathy and optic atrophy",
"auditory neuropathy, autosomal dominant, 1",
"auditory neuropathy, autosomal recessive, 1",
"aural atresia, congenital",
"aural atresia, congenital  mondo:0011921",
"auriculocondylar syndrome 1",
"auriculocondylar syndrome 2",
"auriculocondylar syndrome 2  mondo:0013845",
"auriculocondylar syndrome 3",
"autism spectrum disorder  mondo:0005258",
"autism susceptibility 15",
"autism susceptibility 16",
"autism susceptibility 17",
"autism susceptibility, x linked 1",
"autism susceptibility, x linked 2",
"autism susceptibility, x linked 3",
"autism, susceptibility to, 18",
"autism, susceptibility to, 19",
"autism, susceptibility to, 20",
"autism, susceptibility to, x linked 4",
"autism, susceptibility to, x linked 5",
"autism, susceptibility to, x linked 6",
"autoimmune disease  mondo:0007179",
"autoimmune disease, multisystem, infantile onset, 1",
"autoimmune disease, multisystem, infantile onset, 2",
"autoimmune disease, multisystem, with facial dysmorphism",
"autoimmune disease, susceptibility to, 1",
"autoimmune disease, susceptibility to, 6",
"autoimmune interstitial lung, joint, and kidney disease",
"autoimmune lymphoproliferative syndrome",
"autoimmune lymphoproliferative syndrome due to ctla4 haploinsuffiency  mondo:0014493",
"autoimmune lymphoproliferative syndrome type 1  mondo:0011158",
"autoimmune lymphoproliferative syndrome type 2a  mondo:0011383",
"autoimmune lymphoproliferative syndrome, type ia",
"autoimmune lymphoproliferative syndrome, type ib",
"autoimmune lymphoproliferative syndrome, type ii",
"autoimmune lymphoproliferative syndrome, type iib",
"autoimmune lymphoproliferative syndrome, type iii",
"autoimmune lymphoproliferative syndrome, type v",
"autoimmune polyendocrine syndrome type 1  mondo:0009411",
"autoimmune polyendocrinopathy syndrome , type i, with or without reversible metaphyseal dysplasia",
"autoimmune thyroid disease, susceptibility to, 3",
"autoinflammation with arthritis and dyskeratosis",
"autoinflammation with episodic fever and lymphadenopathy",
"autoinflammation with infantile enterocolitis",
"autoinflammation, antibody deficiency, and immune dysregulation syndrome",
"autoinflammation, immune dysregulation, and eosinophilia",
"autoinflammation, panniculitis, and dermatosis syndrome",
"autoinflammatory syndrome, familial, behcet like",
"autonomic nervous system dysfunction",
"autosomal agammaglobulinemia  mondo:0011096",
"autosomal dominant centronuclear myopathy  mondo:0008048",
"autosomal dominant cerebellar ataxia  mondo:0020380",
"autosomal dominant cerebellar ataxia, deafness and narcolepsy  mondo:0011397",
"autosomal dominant epilepsy with auditory features  mondo:0010898",
"autosomal dominant hereditary sensory and autonomic neuropathy  obsolete termmondo:0015365",
"autosomal dominant hypocalcemia 1  mondo:0011013",
"autosomal dominant macrothrombocytopenia  mondo:0015372",
"autosomal dominant medullary cystic kidney disease with or without hyperuricemia  mondo:0008264",
"autosomal dominant nonsyndromic hearing loss  mondo:0019587",
"autosomal dominant osteopetrosis 2  mondo:0008156",
"autosomal dominant polycystic kidney disease  mondo:0004691",
"autosomal dominant pseudohypoaldosteronism type 1  mondo:0008329",
"autosomal dominant robinow syndrome  mondo:0008389",
"autosomal dominant slowed nerve conduction velocity  mondo:0011998",
"autosomal recessive agammaglobulinemia 1  mondo:0020729",
"autosomal recessive cutis laxa type 2a  mondo:0018163",
"autosomal recessive cutis laxa type 2b  mondo:0013051",
"autosomal recessive cutis laxa type 2c  mondo:0027462",
"autosomal recessive cutis laxa type 2d  mondo:0027451",
"autosomal recessive hereditary demyelinating motor and sensory neuropathy  obsolete termmondo:0015361",
"autosomal recessive limb-girdle muscular dystrophy  mondo:0015152",
"autosomal recessive nonsyndromic hearing loss 102  mondo:0014428",
"autosomal recessive nonsyndromic hearing loss 63  mondo:0012670",
"autosomal recessive nonsyndromic hearing loss 7  mondo:0010967",
"autosomal recessive nonsyndromic hearing loss 9  mondo:0010986",
"autosomal recessive osteopetrosis 1  mondo:0009815",
"autosomal recessive osteopetrosis 3  mondo:0009818",
"autosomal recessive osteopetrosis 4  mondo:0012676",
"autosomal recessive osteopetrosis 5  mondo:0009817",
"autosomal recessive osteopetrosis 6  mondo:0012679",
"autosomal recessive osteopetrosis 8  mondo:0014040",
"autosomal recessive polycystic kidney disease  mondo:0009889",
"autosomal recessive primary microcephaly  mondo:0016660",
"autosomal recessive pseudohypoaldosteronism type 1  mondo:0009917",
"autosomal recessive severe congenital neutropenia due to g6pc3 deficiency  mondo:0012930",
"autosomal recessive spinocerebellar ataxia 20  mondo:0014601",
"autosomal systemic lupus erythematosus type 16  mondo:0013743",
"avascular necrosis of femoral head, primary, 2",
"avascular necrosis of the femoral head",
"axenfeld rieger syndrome, type 1",
"axenfeld rieger syndrome, type 3",
"axillary odor, variation in",
"axonal hereditary motor and sensory neuropathy  obsolete termmondo:0018775",
"ayme gripp syndrome",
"azoospermia, obstructive, with nephrolithiasis",
"b cell expansion with nfkb and t cell anergy",
"b cell non hodgkin lymphoma, high grade",
"b-cell immunodeficiency, distal limb anomalies, and urogenital malformations  mondo:0012243",
"bachmann bupp syndrome",
"bacteremia, protection against",
"bacteremia, susceptibility to",
"bailey-bloch congenital myopathy  mondo:0009722",
"bainbridge ropers syndrome",
"baker gordon syndrome",
"baller gerold syndrome",
"bamforth lazarus syndrome",
"bamforth-lazarus syndrome  mondo:0009437",
"band heterotopia",
"bap1-related tumor predisposition syndrome  mondo:0013692",
"baraitser winter syndrome 1",
"baraitser winter syndrome 2",
"baraitser-winter cerebrofrontofacial syndrome  mondo:0017579",
"baraitser-winter syndrome 2  mondo:0013812",
"baralle macken syndrome",
"barber say syndrome",
"bard1-related cancer predisposition  mondo:0700267",
"bardet biedl syndrome 1",
"bardet biedl syndrome 1, modifier of",
"bardet biedl syndrome 10",
"bardet biedl syndrome 11",
"bardet biedl syndrome 12",
"bardet biedl syndrome 13",
"bardet biedl syndrome 14",
"bardet biedl syndrome 14, modifier of",
"bardet biedl syndrome 15",
"bardet biedl syndrome 16",
"bardet biedl syndrome 17",
"bardet biedl syndrome 18",
"bardet biedl syndrome 19",
"bardet biedl syndrome 2",
"bardet biedl syndrome 20",
"bardet biedl syndrome 3",
"bardet biedl syndrome 4",
"bardet biedl syndrome 5",
"bardet biedl syndrome 6",
"bardet biedl syndrome 7",
"bardet biedl syndrome 8",
"bardet biedl syndrome 9",
"bardet-biedl syndrome 15  mondo:0014443",
"bardet-biedl syndrome 16  mondo:0014444",
"bardet-biedl syndrome 21  mondo:0044308",
"bare lymphocyte syndrome, type i",
"bare lymphocyte syndrome, type i, due to tap2 deficiency",
"bare lymphocyte syndrome, type ii, complementation group a",
"bare lymphocyte syndrome, type ii, complementation group c",
"bare lymphocyte syndrome, type ii, complementation group d",
"bare lymphocyte syndrome, type ii, complementation group e",
"barrett esophagus/esophageal adenocarcinoma",
"bart pumphrey syndrome",
"barth syndrome",
"barth syndrome  mondo:0010543",
"bartsocas-papas syndrome 2  mondo:0859154",
"bartter disease type 4a  mondo:0011242",
"bartter syndrome, type 1",
"bartter syndrome, type 2",
"bartter syndrome, type 3",
"bartter syndrome, type 4a",
"bartter syndrome, type 4b, digenic",
"bartter syndrome, type 5, antenatal, transient",
"basal cell carcinoma 7",
"basal cell carcinoma, somatic",
"basal cell nevus syndrome",
"basal ganglia calcification, idiopathic, 1",
"basal ganglia calcification, idiopathic, 4",
"basal ganglia calcification, idiopathic, 5",
"basal ganglia calcification, idiopathic, 6",
"basal ganglia calcification, idiopathic, 7, autosomal recessive",
"basal ganglia calcification, idiopathic, 8, autosomal recessive",
"basal laminar drusen",
"basan syndrome",
"basel vanagait smirin yosef syndrome",
"basilicata akhtar syndrome",
"basilicata-akhtar syndrome  mondo:0026730",
"beare stevenson cutis gyrata syndrome",
"beare-stevenson cutis gyrata syndrome  mondo:0007412",
"beaulieu boycott innes syndrome",
"beck fahrner syndrome",
"beck-fahrner syndrome  mondo:0032922",
"becker muscular dystrophy",
"beckwith wiedemann syndrome",
"behr syndrome",
"benign familial infantile epilepsy  mondo:0017615",
"bent bone dysplasia syndrome",
"benta disease  mondo:0014645",
"benzene toxicity, susceptibility to",
"bernard soulier syndrome, type a1 recessive",
"bernard soulier syndrome, type a2 dominant",
"bernard soulier syndrome, type b",
"bernard soulier syndrome, type c",
"bernard-soulier syndrome  mondo:0009276",
"beryllium disease, chronic, susceptibility to",
"bestrophinopathy, autosomal recessive",
"beta 2 adrenoreceptor agonist, reduced response to",
"beta aminoisobutyric acid, urinary excretion of",
"beta glycopyranoside tasting, 3 alcohol dependence, susceptibility to",
"beta ureidopropionase deficiency",
"beta-ketothiolase deficiency  mondo:0008760",
"beta-mannosidosis  mondo:0009562",
"beta-thalassemia hbb/lcrb  mondo:0013517",
"bethlem myopathy 1",
"bethlem myopathy 2",
"bh4-deficient hyperphenylalaninemia a  mondo:0009863",
"bietti crystalline corneoretinal dystrophy",
"bietti crystalline corneoretinal dystrophy  mondo:0008865",
"bifid nose with or without anorectal and renal anomalies",
"bilateral frontoparietal polymicrogyria  mondo:0011738",
"bile acid coa:amino acid n-acyltransferase deficiency  mondo:0100305",
"bile acid conjugation defect 1",
"bile acid malabsorption, primary",
"bile acid synthesis defect, congenital, 1",
"bile acid synthesis defect, congenital, 2",
"bile acid synthesis defect, congenital, 3",
"bile acid synthesis defect, congenital, 4",
"bile acid synthesis defect, congenital, 5",
"bile acid synthesis defect, congenital, 6",
"bilirubin, serum level of, qtl1",
"biotinidase deficiency",
"biotinidase deficiency  mondo:0009665",
"birbeck granule deficiency",
"birk barel syndrome",
"birk landau perez syndrome",
"birt hogg dube syndrome",
"birt-hogg-dube syndrome  obsolete termmondo:0007607",
"bjornstad syndrome",
"bjornstad syndrome  mondo:0009872",
"bladder cancer, somatic",
"bladder dysfunction, autonomic, with impaired pupillary reflex and secondary cakut",
"blau syndrome",
"blau syndrome  mondo:0008523",
"bleeding disorder, platelet type, 11",
"bleeding disorder, platelet type, 13, susceptibility to",
"bleeding disorder, platelet type, 15",
"bleeding disorder, platelet type, 16, autosomal dominant",
"bleeding disorder, platelet type, 17",
"bleeding disorder, platelet type, 18",
"bleeding disorder, platelet type, 19",
"bleeding disorder, platelet type, 20",
"bleeding disorder, platelet type, 21",
"bleeding disorder, platelet type, 22",
"bleeding disorder, platelet type, 24, autosomal dominant",
"bleeding disorder, platelet type, 8",
"bleeding disorder, platelet-type, 21  mondo:0054577",
"bleeding disorder, platelet-type, 22  mondo:0032765",
"blepharocheilodontic syndrome 1",
"blepharocheilodontic syndrome 2",
"blepharocheilodontic syndrome 2  mondo:0040503",
"blepharophimosis, epicanthus inversus, and ptosis, type 1",
"blepharophimosis, epicanthus inversus, and ptosis, type 2",
"blepharospasm, primary benign",
"blistering, acantholytic, of oral and laryngeal mucosa",
"blood group",
"blood group  lutheran inhibitor",
"blood group cromer",
"blood group gil",
"blood group, abo system",
"blood group, auberger system",
"blood group, colton",
"blood group, diego",
"blood group, dombrock",
"blood group, duffy system",
"blood group, froese",
"blood group, gerbich",
"blood group, globoside system",
"blood group, john milton hagen system",
"blood group, kell",
"blood group, kidd",
"blood group, knops system",
"blood group, landsteiner wiener",
"blood group, langereis system",
"blood group, lewis",
"blood group, lutheran null",
"blood group, lutheran system",
"blood group, mnss system",
"blood group, ok",
"blood group, p1pk system, p phenotype",
"blood group, p1pk system, p2 phenotype",
"blood group, p1pk system, pk phenotype",
"blood group, radin",
"blood group, raph",
"blood group, rhesus",
"blood group, rodgers",
"blood group, scianna system",
"blood group, ss",
"blood group, swann",
"blood group, vel system",
"blood group, waldner",
"blood group, wright",
"blood group, xg system",
"blood group, yt system",
"blood pressure regulation qtl",
"bloom syndrome",
"bloom syndrome  mondo:0008876",
"blue cone monochromacy",
"bohring opitz syndrome",
"bohring-opitz syndrome  mondo:0011510",
"bombay phenotype",
"bombay phenotype, digenic",
"bone marrow failure syndrome 1",
"bone marrow failure syndrome 2",
"bone marrow failure syndrome 3",
"bone marrow failure syndrome 4",
"bone marrow failure syndrome 4  mondo:0020856",
"bone marrow failure syndrome 5",
"bone marrow failure syndrome 6",
"bone mineral density qtl 12, osteoporosis",
"bone mineral density qtl 15",
"bone mineral density qtl18, osteoporosis",
"bone mineral density variability 1",
"bone mineral density variation qtl, osteoporosis",
"bone mineral density, low, susceptibility to",
"boomerang dysplasia",
"borjeson forssman lehmann syndrome",
"borjeson-forssman-lehmann syndrome  mondo:0010537",
"bosch boonstra schaaf optic atrophy syndrome",
"bosch-boonstra-schaaf optic atrophy syndrome  mondo:0014320",
"bosley salih alorainy syndrome",
"bosma arhinia microphthalmia syndrome",
"bothnia retinal dystrophy",
"boucher neuhauser syndrome",
"bowen conradi syndrome",
"brachycephaly, trichomegaly, and developmental delay",
"brachydactyly syndactyly syndrome",
"brachydactyly, type a1",
"brachydactyly, type a1, c",
"brachydactyly, type a1, d",
"brachydactyly, type a2",
"brachydactyly, type b1",
"brachydactyly, type b2",
"brachydactyly, type c",
"brachydactyly, type d",
"brachydactyly, type e",
"brachydactyly, type e2",
"brachyolmia 4 with mild epiphyseal and metaphyseal changes",
"brachyolmia type 3",
"bradyopsia",
"bradyopsia  mondo:0012033",
"brain abnormalities, neurodegeneration, and dysosteosclerosis",
"brain dopamine-serotonin vesicular transport disease  mondo:0018130",
"brain malformations with or without urinary tract defects",
"brain malformations with or without urinary tract defects  mondo:0100478",
"brain small vessel disease 2",
"brain small vessel disease 3",
"brain small vessel disease with or without ocular anomalies",
"brain tumor polyposis syndrome 2",
"branched chain ketoacid dehydrogenase kinase deficiency",
"branched-chain keto acid dehydrogenase kinase deficiency  mondo:0013970",
"branchio-oto-renal syndrome  mondo:0007029",
"branchiooculofacial syndrome",
"branchiootic syndrome 1",
"branchiootic syndrome 3",
"branchiootorenal syndrome 1, with or without cataracts",
"branchiootorenal syndrome 2",
"brca1-related cancer predisposition  mondo:0700268",
"brca2-related cancer predisposition  mondo:0700269",
"breast and colorectal cancer, susceptibility to",
"breast cancer susceptibility",
"breast cancer, early onset, susceptibility to",
"breast cancer, invasive ductal",
"breast cancer, lobular",
"breast cancer, male, susceptibility to",
"breast cancer, poor survival after chemotherapy for",
"breast cancer, protection against",
"breast cancer, somatic",
"breast cancer, susceptibility to",
"breast ovarian cancer, familial, 1",
"breast ovarian cancer, familial, 2",
"breast ovarian cancer, familial, susceptibility to, 3",
"breast ovarian cancer, familial, susceptibility to, 4",
"breasts and/or nipples, aplasia or hypoplasia of, 2",
"brittle cornea syndrome 1",
"brittle cornea syndrome 2",
"brody myopathy",
"bronchiectasis with or without elevated sweat chloride 1",
"bronchiectasis with or without elevated sweat chloride 1, modifier of",
"bronchiectasis with or without elevated sweat chloride 2",
"bronchiectasis with or without elevated sweat chloride 3",
"brooke spiegler syndrome",
"brooke-spiegler syndrome  mondo:0011512",
"brown vialetto van laere syndrome 1",
"brown vialetto van laere syndrome 2",
"brown-vialetto-van laere syndrome 1  mondo:0024537",
"brown-vialetto-van laere syndrome 2  mondo:0013867",
"bruck syndrome 1",
"bruck syndrome 2",
"brugada syndrome  mondo:0015263",
"brugada syndrome 1",
"brugada syndrome 1  mondo:0011001",
"brugada syndrome 2",
"brugada syndrome 3",
"brugada syndrome 4",
"brugada syndrome 5",
"brugada syndrome 6",
"brugada syndrome 7",
"brugada syndrome 8",
"brugada syndrome 9",
"brunner syndrome",
"brunner syndrome  mondo:0010379",
"bruton-type agammaglobulinemia  mondo:0010421",
"bryant-li-bhoj neurodevelopmental syndrome 1  mondo:0030606",
"budd chiari syndrome",
"budd chiari syndrome, somatic",
"burkitt lymphoma, somatic",
"burn mckeown syndrome",
"buruli ulcer, susceptibility to",
"buschke ollendorff syndrome",
"butyrylcholinesterase deficiency",
"c syndrome",
"c1q deficiency",
"c1q deficiency  mondo:0013343",
"c1s deficiency",
"c2 deficiency",
"c3 deficiency",
"c3 glomerulonephritis  mondo:0013892",
"c3hex, ability to smell",
"c4a deficiency",
"c4b deficiency",
"c5 deficiency",
"c6 deficiency",
"c7 deficiency",
"c8 deficiency, type i",
"c8 deficiency, type ii",
"c9 deficiency",
"caffey disease",
"caffey disease  mondo:0007244",
"calcification of joints and arteries",
"calvarial doughnut lesions with bone fragility with or without spondylometaphyseal dysplasia",
"campomelic dysplasia",
"campomelic dysplasia  mondo:0007251",
"campomelic dysplasia with autosomal sex reversal",
"camptodactyly arthropathy coxa vara pericarditis syndrome",
"camptodactyly-arthropathy-coxa vara-pericarditis syndrome  mondo:0008828",
"camptodactyly-tall stature-scoliosis-hearing loss syndrome  mondo:0012504",
"camptosynpolydactyly, complex",
"camurati engelmann disease",
"canavan disease",
"canavan disease  mondo:0010079",
"cancer progression/metastasis",
"cancer, alopecia, pigment dyscrasia, onychodystrophy, and keratoderma",
"candidiasis, familial, 2, autosomal recessive",
"candidiasis, familial, 4, autosomal recessive",
"candidiasis, familial, 6, autosomal dominant",
"candidiasis, familial, 8",
"candidiasis, familial, 9",
"cap myopathy 1",
"cap myopathy 2",
"capillary malformation arteriovenous malformation 1",
"capillary malformation arteriovenous malformation 2",
"capillary malformations, congenital, 1, somatic, mosaic",
"capn5-related vitreoretinopathy  mondo:0100450",
"capos syndrome",
"carasil syndrome",
"carbamoyl phosphate synthetase i deficiency disease  mondo:0009376",
"carbamoylphosphate synthetase i deficiency",
"carboxypeptidase n deficiency",
"carcinoid tumor of lung",
"cardiac arrhythmia, ankyrin b related",
"cardiac conduction defect, nonspecific",
"cardiac conduction defect, susceptibility to",
"cardiac conduction disease with or without dilated cardiomyopathy",
"cardiac urogenital syndrome",
"cardiac valvular defect, developmental",
"cardiac valvular dysplasia, x linked",
"cardiac, facial, and digital anomalies with developmental delay",
"cardioacrofacial dysplasia 1",
"cardioacrofacial dysplasia 2",
"cardiofaciocutaneous syndrome",
"cardiofaciocutaneous syndrome  mondo:0015280",
"cardiofaciocutaneous syndrome 2",
"cardiofaciocutaneous syndrome 3",
"cardiofaciocutaneous syndrome 4",
"cardiofacioneurodevelopmental syndrome",
"cardiomyopathy, dilated, 1a",
"cardiomyopathy, dilated, 1aa, with or without lvnc",
"cardiomyopathy, dilated, 1bb",
"cardiomyopathy, dilated, 1c, with or without lvnc",
"cardiomyopathy, dilated, 1cc",
"cardiomyopathy, dilated, 1d",
"cardiomyopathy, dilated, 1dd",
"cardiomyopathy, dilated, 1e",
"cardiomyopathy, dilated, 1ee",
"cardiomyopathy, dilated, 1ff",
"cardiomyopathy, dilated, 1g",
"cardiomyopathy, dilated, 1gg",
"cardiomyopathy, dilated, 1hh",
"cardiomyopathy, dilated, 1i",
"cardiomyopathy, dilated, 1ii",
"cardiomyopathy, dilated, 1j",
"cardiomyopathy, dilated, 1jj",
"cardiomyopathy, dilated, 1kk",
"cardiomyopathy, dilated, 1l",
"cardiomyopathy, dilated, 1ll",
"cardiomyopathy, dilated, 1m",
"cardiomyopathy, dilated, 1mm",
"cardiomyopathy, dilated, 1nn",
"cardiomyopathy, dilated, 1o",
"cardiomyopathy, dilated, 1p",
"cardiomyopathy, dilated, 1r",
"cardiomyopathy, dilated, 1s",
"cardiomyopathy, dilated, 1u",
"cardiomyopathy, dilated, 1v",
"cardiomyopathy, dilated, 1w",
"cardiomyopathy, dilated, 1x",
"cardiomyopathy, dilated, 1y",
"cardiomyopathy, dilated, 1z",
"cardiomyopathy, dilated, 2a",
"cardiomyopathy, dilated, 2b",
"cardiomyopathy, dilated, 2c",
"cardiomyopathy, dilated, 3b",
"cardiomyopathy, dilated, with woolly hair and keratoderma",
"cardiomyopathy, familial hypertrophic",
"cardiomyopathy, familial hypertrophic 27",
"cardiomyopathy, familial hypertrophic, 26",
"cardiomyopathy, familial hypertrophic, 9",
"cardiomyopathy, familial restrictive 5",
"cardiomyopathy, familial restrictive, 1",
"cardiomyopathy, familial restrictive, 3",
"cardiomyopathy, familial restrictive, 4",
"cardiomyopathy, hypertrophic 6",
"cardiomyopathy, hypertrophic, 1",
"cardiomyopathy, hypertrophic, 1, digenic",
"cardiomyopathy, hypertrophic, 10",
"cardiomyopathy, hypertrophic, 11",
"cardiomyopathy, hypertrophic, 12",
"cardiomyopathy, hypertrophic, 13",
"cardiomyopathy, hypertrophic, 14",
"cardiomyopathy, hypertrophic, 15",
"cardiomyopathy, hypertrophic, 16",
"cardiomyopathy, hypertrophic, 17",
"cardiomyopathy, hypertrophic, 18",
"cardiomyopathy, hypertrophic, 2",
"cardiomyopathy, hypertrophic, 20",
"cardiomyopathy, hypertrophic, 22",
"cardiomyopathy, hypertrophic, 23, with or without lvnc",
"cardiomyopathy, hypertrophic, 24",
"cardiomyopathy, hypertrophic, 25",
"cardiomyopathy, hypertrophic, 3",
"cardiomyopathy, hypertrophic, 4",
"cardiomyopathy, hypertrophic, 7",
"cardiomyopathy, hypertrophic, 8",
"cardiospondylocarpofacial syndrome",
"carey fineman ziter syndrome",
"carey fineman ziter syndrome 2",
"carey-fineman-ziter syndrome  obsolete termmondo:0009700",
"carney complex variant",
"carney complex, type 1",
"carney complex, type 1  mondo:0008057",
"carnitine acylcarnitine translocase deficiency",
"carnitine deficiency, systemic primary",
"carnitine palmitoyl transferase 1a deficiency  mondo:0009705",
"carnitine palmitoyltransferase ii deficiency  mondo:0015515",
"carnitine-acylcarnitine translocase deficiency  mondo:0008918",
"carotid intimal medial thickness 1",
"carpal tunnel syndrome 2",
"carpal tunnel syndrome, familial",
"carpenter syndrome",
"carpenter syndrome 2",
"cartilage hair hypoplasia",
"cartilage-hair hypoplasia  mondo:0009595",
"cataract 1, multiple types",
"cataract 10, multiple types",
"cataract 11, multiple types",
"cataract 11, syndromic, autosomal recessive",
"cataract 12, multiple types",
"cataract 13 with adult i phenotype",
"cataract 14, multiple types",
"cataract 15, multiple types",
"cataract 16, multiple types",
"cataract 17, multiple types",
"cataract 18, autosomal recessive",
"cataract 19, multiple types",
"cataract 2, multiple types",
"cataract 20, multiple types",
"cataract 21, multiple types",
"cataract 22",
"cataract 23",
"cataract 3, multiple types",
"cataract 30, pulverulent",
"cataract 31, multiple types",
"cataract 33, multiple types",
"cataract 34, multiple types",
"cataract 36",
"cataract 38, autosomal recessive",
"cataract 39, multiple types, autosomal dominant",
"cataract 4, multiple types",
"cataract 40, x linked",
"cataract 41",
"cataract 42",
"cataract 43",
"cataract 44",
"cataract 45",
"cataract 46, juvenile onset",
"cataract 47, juvenile, with microcornea",
"cataract 48",
"cataract 5, multiple types",
"cataract 6, multiple types",
"cataract 9, multiple types",
"cataract with late onset corneal dystrophy",
"cataracts, growth hormone deficiency, sensory neuropathy, sensorineural hearing loss, and skeletal dysplasia",
"catecholaminergic polymorphic ventricular tachycardia  mondo:0017990",
"catel manzke syndrome",
"catifa syndrome",
"catshl syndrome",
"caudal duplication anomaly",
"caudal regression syndrome",
"caveolinopathy  mondo:0016146",
"cavernous malformations of cns and retina",
"cavitary optic disc anomalies",
"cbl-related disorder  mondo:0013308",
"ccdc115-cdg  mondo:0014789",
"cd8 deficiency, familial",
"cdh1-related diffuse gastric and lobular breast cancer syndrome  mondo:0100488",
"cdkl5 disorder  mondo:0100039",
"cebalid syndrome",
"celiac disease, susceptibility to",
"celiac disease, susceptibility to, 3",
"celiac disease, susceptibility to, 4",
"cenani lenz syndactyly syndrome",
"cenani-lenz syndactyly syndrome  mondo:0008931",
"central core disease",
"central hypoventilation syndrome",
"central hypoventilation syndrome, congenital",
"central hypoventilation syndrome, congenital, 1, with or without hirschsprung disease  mondo:0800026",
"central hypoventilation syndrome, congenital, with or without hirschsprung disease",
"centronuclear myopathy  mondo:0018947",
"centronuclear myopathy 1",
"centronuclear myopathy 2",
"centronuclear myopathy 4",
"centronuclear myopathy 5",
"centronuclear myopathy 6 with fiber type disproportion",
"centronuclear myopathy, autosomal, modifier of",
"cep290-related ciliopathy  mondo:0100451",
"cerebellar ataxia",
"cerebellar ataxia  mondo:0000437",
"cerebellar ataxia and hypogonadotropic hypogonadism",
"cerebellar ataxia and mental retardation with or without quadrupedal locomotion 3",
"cerebellar ataxia with neuropathy and bilateral vestibular areflexia syndrome  mondo:0044720",
"cerebellar ataxia, deafness, and narcolepsy, autosomal dominant",
"cerebellar ataxia, intellectual disability, and dysequilibrium syndrome 1  mondo:0024542",
"cerebellar ataxia, mental retardation, and dysequilibrium syndrome 2",
"cerebellar ataxia, mental retardation, and dysequilibrium syndrome 4",
"cerebellar ataxia, neuropathy, and vestibular areflexia syndrome",
"cerebellar ataxia, nonprogressive, with mental retardation",
"cerebellar atrophy with seizures and variable developmental delay",
"cerebellar atrophy, developmental delay, and seizures",
"cerebellar atrophy, visual impairment, and psychomotor retardation",
"cerebellar dysfunction with variable cognitive and behavioral abnormalities  mondo:0013886",
"cerebellar hypoplasia and mental retardation with or without quadrupedal locomotion 1",
"cerebellar hypoplasia/atrophy, epilepsy, and global developmental delay",
"cerebellar, ocular, craniofacial, and genital syndrome",
"cerebellar, ocular, craniofacial, and genital syndrome  mondo:0032774",
"cerebellofaciodental syndrome",
"cerebral amyloid angiopathy",
"cerebral amyloid angiopathy, dutch",
"cerebral amyloid angiopathy, prnp related",
"cerebral arteriopathy with subcortical infarcts and leukoencephalopathy 1",
"cerebral arteriopathy, autosomal dominant, with subcortical infarcts and leukoencephalopathy, type 2",
"cerebral cavernous malformations 1",
"cerebral cavernous malformations 2",
"cerebral cavernous malformations 3",
"cerebral creatine deficiency syndrome 1",
"cerebral creatine deficiency syndrome 2",
"cerebral creatine deficiency syndrome 3",
"cerebral dysgenesis, neuropathy, ichthyosis, and palmoplantar keratoderma syndrome",
"cerebral infarction, susceptibility to",
"cerebral palsy, spastic quadriplegic, 1",
"cerebral palsy, spastic quadriplegic, 2",
"cerebral palsy, spastic quadriplegic, 3",
"cerebrocostomandibular syndrome",
"cerebrooculofacioskeletal syndrome 1",
"cerebrooculofacioskeletal syndrome 2",
"cerebrooculofacioskeletal syndrome 3",
"cerebrooculofacioskeletal syndrome 4",
"cerebroretinal microangiopathy with calcifications and cysts",
"cerebroretinal microangiopathy with calcifications and cysts 2",
"cerebrotendinous xanthomatosis",
"cerebrotendinous xanthomatosis  mondo:0008948",
"cerebrovascular disease, occlusive",
"cerkl-related retinopathy  mondo:0800401",
"cernunnos-xlf deficiency  mondo:0012650",
"ceroid lipofuscinosis, neuronal, 1",
"ceroid lipofuscinosis, neuronal, 10",
"ceroid lipofuscinosis, neuronal, 11",
"ceroid lipofuscinosis, neuronal, 13, kufs type",
"ceroid lipofuscinosis, neuronal, 2",
"ceroid lipofuscinosis, neuronal, 3",
"ceroid lipofuscinosis, neuronal, 4, parry type",
"ceroid lipofuscinosis, neuronal, 5",
"ceroid lipofuscinosis, neuronal, 6",
"ceroid lipofuscinosis, neuronal, 7",
"ceroid lipofuscinosis, neuronal, 8",
"ceroid lipofuscinosis, neuronal, 8, northern epilepsy variant",
"ceroid lipofuscinosis, neuronal, kufs type, adult onset",
"cervical cancer, somatic",
"chanarin dorfman syndrome",
"chand syndrome",
"char syndrome",
"charcot marie tooth disease, axonal type 2m",
"charcot marie tooth disease, axonal, autosomal dominant, type 2k",
"charcot marie tooth disease, axonal, type 20",
"charcot marie tooth disease, axonal, type 2a2a",
"charcot marie tooth disease, axonal, type 2a2b",
"charcot marie tooth disease, axonal, type 2cc",
"charcot marie tooth disease, axonal, type 2dd",
"charcot marie tooth disease, axonal, type 2ee",
"charcot marie tooth disease, axonal, type 2f",
"charcot marie tooth disease, axonal, type 2k",
"charcot marie tooth disease, axonal, type 2l",
"charcot marie tooth disease, axonal, type 2n",
"charcot marie tooth disease, axonal, type 2p",
"charcot marie tooth disease, axonal, type 2q",
"charcot marie tooth disease, axonal, type 2s",
"charcot marie tooth disease, axonal, type 2t",
"charcot marie tooth disease, axonal, type 2u",
"charcot marie tooth disease, axonal, type 2v",
"charcot marie tooth disease, axonal, type 2w",
"charcot marie tooth disease, axonal, type 2x",
"charcot marie tooth disease, axonal, type 2z",
"charcot marie tooth disease, axonal, with vocal cord paresis",
"charcot marie tooth disease, demyelinating, type 1g",
"charcot marie tooth disease, dominant intermediate b",
"charcot marie tooth disease, dominant intermediate c",
"charcot marie tooth disease, dominant intermediate d",
"charcot marie tooth disease, dominant intermediate e",
"charcot marie tooth disease, dominant intermediate f",
"charcot marie tooth disease, dominant intermediate g",
"charcot marie tooth disease, foot deformity of",
"charcot marie tooth disease, recessive intermediate c",
"charcot marie tooth disease, recessive intermediate d",
"charcot marie tooth disease, recessive intermediate, a",
"charcot marie tooth disease, recessive intermediate, b",
"charcot marie tooth disease, type 1a",
"charcot marie tooth disease, type 1b",
"charcot marie tooth disease, type 1c",
"charcot marie tooth disease, type 1d",
"charcot marie tooth disease, type 1e",
"charcot marie tooth disease, type 1f",
"charcot marie tooth disease, type 2a1",
"charcot marie tooth disease, type 2b",
"charcot marie tooth disease, type 2b1",
"charcot marie tooth disease, type 2b2",
"charcot marie tooth disease, type 2d",
"charcot marie tooth disease, type 2e",
"charcot marie tooth disease, type 2i",
"charcot marie tooth disease, type 2j",
"charcot marie tooth disease, type 2r",
"charcot marie tooth disease, type 2y",
"charcot marie tooth disease, type 4a",
"charcot marie tooth disease, type 4b1",
"charcot marie tooth disease, type 4b2",
"charcot marie tooth disease, type 4b3",
"charcot marie tooth disease, type 4c",
"charcot marie tooth disease, type 4d",
"charcot marie tooth disease, type 4f",
"charcot marie tooth disease, type 4h",
"charcot marie tooth disease, type 4j",
"charcot marie tooth disease, type 4k",
"charcot marie tooth disease, x linked dominant, 6",
"charcot marie tooth disease, x linked recessive, 5",
"charcot marie tooth neuropathy, x linked dominant, 1",
"charcot-marie-tooth disease  mondo:0015626",
"charcot-marie-tooth disease axonal type 2cc  mondo:0014836",
"charcot-marie-tooth disease axonal type 2f  mondo:0011687",
"charcot-marie-tooth disease axonal type 2n  mondo:0013212",
"charcot-marie-tooth disease axonal type 2p  mondo:0013753",
"charcot-marie-tooth disease axonal type 2t  mondo:0014866",
"charcot-marie-tooth disease axonal type 2z  mondo:0014736",
"charcot-marie-tooth disease dominant intermediate e  mondo:0013758",
"charcot-marie-tooth disease type 1a  mondo:0007309",
"charcot-marie-tooth disease type 2  mondo:0018993",
"charcot-marie-tooth disease type 2a1  mondo:0007308",
"charcot-marie-tooth disease type 2b2  mondo:0011570",
"charcot-marie-tooth disease type 2d  mondo:0011091",
"charcot-marie-tooth disease type 4  mondo:0018995",
"charcot-marie-tooth disease type 4b2  mondo:0011475",
"charcot-marie-tooth disease type 4b3  mondo:0014117",
"charcot-marie-tooth disease x-linked dominant 1  mondo:0010549",
"charcot-marie-tooth disease x-linked dominant 6  mondo:0010479",
"charcot-marie-tooth disease, axonal, type 2dd  mondo:0054833",
"charge syndrome",
"charge syndrome  mondo:0008965",
"chediak higashi syndrome",
"chediak-higashi syndrome  mondo:0008963",
"chek2-related cancer predisposition  mondo:0700271",
"cherubism",
"chilblain lupus",
"chilblain lupus 2",
"child syndrome",
"childhood hypophosphatasia  obsolete termmondo:0009428",
"childhood-onset epilepsy syndrome  mondo:0020072",
"childhood-onset motor and cognitive regression syndrome with extrapyramidal movement disorder  mondo:0044701",
"chime syndrome",
"chitayat syndrome",
"chitotriosidase deficiency",
"choanal atresia and lymphedema",
"choanal atresia-hearing loss-cardiac defects-craniofacial dysmorphism syndrome  mondo:0012064",
"cholestasis, benign recurrent intrahepatic",
"cholestasis, benign recurrent intrahepatic, 2",
"cholestasis, intrahepatic, of pregnancy, 1",
"cholestasis, intrahepatic, of pregnancy, 3",
"cholestasis, progressive familial intrahepatic 1",
"cholestasis, progressive familial intrahepatic 2",
"cholestasis, progressive familial intrahepatic 3",
"cholestasis, progressive familial intrahepatic 4",
"cholestasis, progressive familial intrahepatic, 5",
"cholestasis, progressive familial intrahepatic, 9",
"cholesteryl ester storage disease",
"chondrocalcinosis 2",
"chondrodysplasia punctata, x linked dominant",
"chondrodysplasia punctata, x linked recessive",
"chondrodysplasia with joint dislocations, gpapp type",
"chondrodysplasia with joint dislocations, gpapp type  mondo:0013561",
"chondrodysplasia with platyspondyly, distinctive brachydactyly, hydrocephaly, and microphthalmia",
"chondrodysplasia, blomstrand type",
"chondrodysplasia, grebe type",
"chondrosarcoma",
"chondrosarcoma, extraskeletal myxoid",
"chops syndrome",
"chorea, childhood onset, with psychomotor retardation",
"chorea, hereditary benign",
"choreoacanthocytosis",
"choreoathetosis, hypothyroidism, and neonatal respiratory distress",
"choroid plexus papilloma",
"choroidal dystrophy, central areolar 1",
"choroidal dystrophy, central areolar 2",
"choroideremia",
"choroideremia  mondo:0010557",
"christianson syndrome  mondo:0010278",
"chrng-associated hypo-akinesia disorder of prenatal onset  mondo:0100158",
"chromosome 5q14.3 deletion syndrome",
"chronic atrial and intestinal dysrhythmia",
"chronic granulomatous disease 1, autosomal recessive",
"chronic granulomatous disease 2, autosomal recessive",
"chronic granulomatous disease 3, autosomal recessive",
"chronic granulomatous disease 4, autosomal recessive",
"chronic granulomatous disease 5, autosomal recessive",
"chronic granulomatous disease, x linked",
"chronic infections, due to mbl deficiency",
"chudley mccullough syndrome",
"chudley-mccullough syndrome  mondo:0011411",
"chung jansen syndrome",
"chylomicron retention disease",
"ciliary dyskinesia, primary, 1, with or without situs inversus",
"ciliary dyskinesia, primary, 10",
"ciliary dyskinesia, primary, 11",
"ciliary dyskinesia, primary, 12",
"ciliary dyskinesia, primary, 13",
"ciliary dyskinesia, primary, 14",
"ciliary dyskinesia, primary, 15",
"ciliary dyskinesia, primary, 16",
"ciliary dyskinesia, primary, 18",
"ciliary dyskinesia, primary, 19",
"ciliary dyskinesia, primary, 2",
"ciliary dyskinesia, primary, 20",
"ciliary dyskinesia, primary, 21",
"ciliary dyskinesia, primary, 22",
"ciliary dyskinesia, primary, 23",
"ciliary dyskinesia, primary, 24",
"ciliary dyskinesia, primary, 25",
"ciliary dyskinesia, primary, 26",
"ciliary dyskinesia, primary, 27",
"ciliary dyskinesia, primary, 28",
"ciliary dyskinesia, primary, 29",
"ciliary dyskinesia, primary, 3, with or without situs inversus",
"ciliary dyskinesia, primary, 30",
"ciliary dyskinesia, primary, 32",
"ciliary dyskinesia, primary, 33",
"ciliary dyskinesia, primary, 34",
"ciliary dyskinesia, primary, 35",
"ciliary dyskinesia, primary, 36, x linked",
"ciliary dyskinesia, primary, 36, x-linked  mondo:0010517",
"ciliary dyskinesia, primary, 37",
"ciliary dyskinesia, primary, 37  mondo:0033204",
"ciliary dyskinesia, primary, 38",
"ciliary dyskinesia, primary, 38  mondo:0054843",
"ciliary dyskinesia, primary, 39",
"ciliary dyskinesia, primary, 39  mondo:0032637",
"ciliary dyskinesia, primary, 40",
"ciliary dyskinesia, primary, 40  mondo:0032664",
"ciliary dyskinesia, primary, 41",
"ciliary dyskinesia, primary, 41  mondo:0032757",
"ciliary dyskinesia, primary, 42",
"ciliary dyskinesia, primary, 42  mondo:0032872",
"ciliary dyskinesia, primary, 43",
"ciliary dyskinesia, primary, 43  mondo:0032874",
"ciliary dyskinesia, primary, 44",
"ciliary dyskinesia, primary, 44  mondo:0032914",
"ciliary dyskinesia, primary, 45",
"ciliary dyskinesia, primary, 47, and lissencephaly  mondo:0030346",
"ciliary dyskinesia, primary, 48, without situs inversus  mondo:0031054",
"ciliary dyskinesia, primary, 49, without situs inversus",
"ciliary dyskinesia, primary, 5",
"ciliary dyskinesia, primary, 52",
"ciliary dyskinesia, primary, 52  mondo:0957922",
"ciliary dyskinesia, primary, 53",
"ciliary dyskinesia, primary, 6",
"ciliary dyskinesia, primary, 7, with or without situs inversus",
"ciliary dyskinesia, primary, 9, with or without situs inversus",
"ciliopathy  mondo:0005308",
"cinca syndrome",
"cirrhosis, cryptogenic",
"cirrhosis, noncryptogenic, susceptibility to",
"citrin deficiency  mondo:0016602",
"citrullinemia",
"citrullinemia type i  mondo:0008988",
"citrullinemia, adult onset type ii",
"citrullinemia, type ii, neonatal onset",
"ck syndrome",
"ck syndrome  mondo:0010441",
"clapo syndrome, somatic",
"classic homocystinuria  mondo:0009352",
"classic or attenuated familial adenomatous polyposis  mondo:0021057",
"cleft lip/palate ectodermal dysplasia syndrome",
"cleft palate with ankyloglossia",
"cleft palate, cardiac defects, and mental retardation",
"cleft palate, proliferative retinopathy, and developmental delay",
"cleft palate, psychomotor retardation, and distinctive facial features",
"cleidocranial dysplasia",
"cleidocranial dysplasia, forme fruste, dental anomalies only",
"cleidocranial dysplasia, forme fruste, with brachydactyly",
"clopidogrel, impaired responsiveness to",
"clouston syndrome  mondo:0007510",
"clove syndrome, somatic",
"clubfoot, congenital, with or without deficiency of long bones and/or mirror image polydactyly",
"cnga1-related retinopathy  mondo:0800405",
"cnga3-related retinopathy  mondo:0800102",
"cngb1-related retinopathy  mondo:0800403",
"cngb3-related retinopathy  mondo:0100446",
"coach syndrome 1",
"coach syndrome 2",
"coach syndrome 3",
"cobblestone lissencephaly without muscular or ocular involvement  mondo:0014077",
"cockayne spectrum with or without cerebrooculofacioskeletal syndrome  mondo:0100506",
"cockayne syndrome type 1  mondo:0019569",
"cockayne syndrome, type a",
"cockayne syndrome, type b",
"cocoon syndrome",
"codas syndrome",
"codeine sensitivity",
"coenzyme q10 deficiency, primary, 1",
"coenzyme q10 deficiency, primary, 2",
"coenzyme q10 deficiency, primary, 3",
"coenzyme q10 deficiency, primary, 4",
"coenzyme q10 deficiency, primary, 5",
"coenzyme q10 deficiency, primary, 6",
"coenzyme q10 deficiency, primary, 7",
"coenzyme q10 deficiency, primary, 8",
"coenzyme q10 deficiency, primary, 9",
"coffin lowry syndrome",
"coffin siris syndrome 1",
"coffin siris syndrome 10",
"coffin siris syndrome 11",
"coffin siris syndrome 2",
"coffin siris syndrome 3",
"coffin siris syndrome 4",
"coffin siris syndrome 5",
"coffin siris syndrome 6",
"coffin siris syndrome 7",
"coffin siris syndrome 8",
"coffin siris syndrome 9",
"coffin-lowry syndrome  mondo:0010561",
"coffin-siris syndrome  mondo:0015452",
"cog1-congenital disorder of glycosylation  mondo:0012637",
"cog4-congenital disorder of glycosylation  mondo:0013281",
"cognitive impairment with or without cerebellar ataxia",
"cohen gibson syndrome",
"cohen syndrome",
"cohen syndrome  mondo:0008999",
"cohen-gibson syndrome  mondo:0060510",
"colchicine resistance",
"cold induced sweating syndrome 1",
"cold induced sweating syndrome 2",
"cole carpenter syndrome 1",
"cole carpenter syndrome 2",
"cole disease",
"collagen 6-related myopathy  mondo:0100225",
"coloboma of optic nerve",
"coloboma, ocular",
"coloboma, ocular, autosomal recessive",
"coloboma, ocular, with or without hearing impairment, cleft lip/palate, and/or mental retardation",
"colobomatous microphthalmia-rhizomelic dysplasia syndrome  mondo:0014380",
"colon cancer, advanced, somatic",
"colon cancer, somatic",
"colon cancer, susceptibility to",
"colorblindness, deutan",
"colorblindness, protan",
"colorblindness, tritan",
"colorectal cancer",
"colorectal cancer  mondo:0005575",
"colorectal cancer with chromosomal instability, somatic",
"colorectal cancer, hereditary nonpolyposis, type 1",
"colorectal cancer, hereditary nonpolyposis, type 2",
"colorectal cancer, hereditary nonpolyposis, type 4",
"colorectal cancer, hereditary nonpolyposis, type 5",
"colorectal cancer, hereditary nonpolyposis, type 6",
"colorectal cancer, hereditary nonpolyposis, type 7",
"colorectal cancer, hereditary nonpolyposis, type 7  mondo:0013725",
"colorectal cancer, hereditary nonpolyposis, type 8",
"colorectal cancer, somatic",
"colorectal cancer, susceptibility to",
"colorectal cancer, susceptibility to, 1",
"colorectal cancer, susceptibility to, 1  mondo:0012132",
"colorectal cancer, susceptibility to, 10",
"colorectal cancer, susceptibility to, 12",
"colorectal cancer, susceptibility to, 3",
"colostrum secretion, variation in",
"combined c6/c7 deficiency",
"combined cellular and humoral immune defects with granulomas",
"combined d 2  and l 2 hydroxyglutaric aciduria",
"combined factor v and viii deficiency",
"combined hyperlipidemia, familial",
"combined immunodeficiency  mondo:0015131",
"combined immunodeficiency and megaloblastic anemia with or without hyperhomocysteinemia",
"combined immunodeficiency due to cd3gamma deficiency  mondo:0014276",
"combined immunodeficiency due to dock8 deficiency  mondo:0009478",
"combined immunodeficiency due to lrba deficiency  mondo:0013863",
"combined immunodeficiency due to malt1 deficiency  mondo:0014197",
"combined immunodeficiency due to moesin deficiency  mondo:0010514",
"combined immunodeficiency due to ox40 deficiency  mondo:0014268",
"combined immunodeficiency due to rela haploinsufficiency  mondo:0035694",
"combined immunodeficiency due to stk4 deficiency  mondo:0013934",
"combined immunodeficiency due to zap70 deficiency  mondo:0010023",
"combined immunodeficiency, x linked, moderate",
"combined immunodeficiency, x-linked  mondo:0010730",
"combined malonic and methylmalonic acidemia  mondo:0013661",
"combined malonic and methylmalonic aciduria",
"combined osteogenesis imperfecta and ehlers danlos syndrome 1",
"combined osteogenesis imperfecta and ehlers danlos syndrome 2",
"combined osteogenesis imperfecta and ehlers-danlos syndrome 1  mondo:0030854",
"combined osteogenesis imperfecta and ehlers-danlos syndrome 2  mondo:0030855",
"combined oxidative phosphorylation deficiency 1",
"combined oxidative phosphorylation deficiency 10",
"combined oxidative phosphorylation deficiency 11",
"combined oxidative phosphorylation deficiency 12",
"combined oxidative phosphorylation deficiency 13",
"combined oxidative phosphorylation deficiency 14",
"combined oxidative phosphorylation deficiency 15",
"combined oxidative phosphorylation deficiency 16",
"combined oxidative phosphorylation deficiency 17",
"combined oxidative phosphorylation deficiency 18",
"combined oxidative phosphorylation deficiency 19",
"combined oxidative phosphorylation deficiency 2",
"combined oxidative phosphorylation deficiency 20",
"combined oxidative phosphorylation deficiency 21",
"combined oxidative phosphorylation deficiency 22",
"combined oxidative phosphorylation deficiency 23",
"combined oxidative phosphorylation deficiency 24",
"combined oxidative phosphorylation deficiency 25",
"combined oxidative phosphorylation deficiency 26",
"combined oxidative phosphorylation deficiency 27",
"combined oxidative phosphorylation deficiency 28",
"combined oxidative phosphorylation deficiency 29",
"combined oxidative phosphorylation deficiency 3",
"combined oxidative phosphorylation deficiency 30",
"combined oxidative phosphorylation deficiency 31",
"combined oxidative phosphorylation deficiency 32",
"combined oxidative phosphorylation deficiency 33",
"combined oxidative phosphorylation deficiency 34",
"combined oxidative phosphorylation deficiency 35",
"combined oxidative phosphorylation deficiency 36",
"combined oxidative phosphorylation deficiency 37",
"combined oxidative phosphorylation deficiency 38",
"combined oxidative phosphorylation deficiency 39",
"combined oxidative phosphorylation deficiency 4",
"combined oxidative phosphorylation deficiency 40",
"combined oxidative phosphorylation deficiency 41",
"combined oxidative phosphorylation deficiency 42",
"combined oxidative phosphorylation deficiency 43",
"combined oxidative phosphorylation deficiency 44",
"combined oxidative phosphorylation deficiency 45",
"combined oxidative phosphorylation deficiency 47",
"combined oxidative phosphorylation deficiency 48",
"combined oxidative phosphorylation deficiency 49",
"combined oxidative phosphorylation deficiency 5",
"combined oxidative phosphorylation deficiency 50",
"combined oxidative phosphorylation deficiency 51",
"combined oxidative phosphorylation deficiency 6",
"combined oxidative phosphorylation deficiency 7",
"combined oxidative phosphorylation deficiency 8",
"combined oxidative phosphorylation deficiency 9",
"combined oxidative phosphorylation defiency 46",
"combined pituitary hormone deficiencies, genetic form  mondo:0013099",
"combined psap deficiency  mondo:0012719",
"combined sap deficiency",
"commad syndrome",
"common variable immunodeficiency  mondo:0015517",
"complement component 4, partial deficiency of",
"complement factor b deficiency",
"complement factor d deficiency",
"complement factor h deficiency",
"complement factor i deficiency",
"complement hyperactivation, angiopathic thrombosis, and protein losing enteropathy",
"complex cortical dysplasia with other brain malformations  mondo:0000904",
"complex cortical dysplasia with other brain malformations 2  mondo:0014116",
"complex hereditary spastic paraplegia  mondo:0015150",
"complex neurodevelopmental disorder  mondo:0100038",
"complex neurodevelopmental disorder with motor features  mondo:0100516",
"complex neurodevelopmental disorder with or without congenital anomalies  mondo:0100465",
"cone dystrophy 3",
"cone dystrophy 4",
"cone rod dystrophy",
"cone rod dystrophy 10",
"cone rod dystrophy 11",
"cone rod dystrophy 12",
"cone rod dystrophy 13",
"cone rod dystrophy 14",
"cone rod dystrophy 15",
"cone rod dystrophy 18",
"cone rod dystrophy 19",
"cone rod dystrophy 20",
"cone rod dystrophy 21",
"cone rod dystrophy 3",
"cone rod dystrophy 5",
"cone rod dystrophy 6",
"cone rod dystrophy 7",
"cone rod dystrophy 9",
"cone rod dystrophy and hearing loss",
"cone rod dystrophy and hearing loss 2",
"cone rod dystrophy, x linked, 1",
"cone rod dystrophy, x linked, 3",
"cone rod retinal dystrophy 2",
"cone rod synaptic disorder syndrome, congenital nonprogressive",
"cone rod synaptic disorder, congenital nonprogressive",
"cone-rod dystrophy and hearing loss  mondo:0014980",
"congenital amegakaryocytic thrombocytopenia  mondo:0800451",
"congenital amegakaryocytic thrombocytopenia 1  mondo:0800452",
"congenital anomalies of kidney and urinary tract 1",
"congenital anomalies of kidney and urinary tract 2",
"congenital anomalies of kidney and urinary tract 3",
"congenital anomalies of kidney and urinary tract syndrome with or without hearing loss, abnormal ears, or developmental delay",
"congenital anomalies of kidney and urinary tract syndrome with or without hearing loss, abnormal ears, or developmental delay  mondo:0060549",
"congenital anomaly of kidney and urinary tract  mondo:0019719",
"congenital arthrogryposis with anterior horn cell disease",
"congenital bilateral absence of vas deferens",
"congenital bilateral absence of vas deferens, x linked",
"congenital bile acid synthesis defect 1  mondo:0011906",
"congenital bile acid synthesis defect 2  mondo:0009339",
"congenital bile acid synthesis defect 5  mondo:0014564",
"congenital bile acid synthesis defect 6  mondo:0015015",
"congenital brain dysgenesis due to glutamine synthetase deficiency  mondo:0012393",
"congenital cataracts, facial dysmorphism, and neuropathy",
"congenital cataracts, hearing loss, and neurodegeneration",
"congenital contractures of the limbs and face, hypotonia, and developmental delay",
"congenital disorder of deglycosylation",
"congenital disorder of deglycosylation 1  mondo:0800044",
"congenital disorder of glycosylation  mondo:0015286",
"congenital disorder of glycosylation type 1e  mondo:0012123",
"congenital disorder of glycosylation type ii  mondo:0005501",
"congenital disorder of glycosylation with defective fucosylation 1",
"congenital disorder of glycosylation with defective fucosylation 1  mondo:0020775",
"congenital disorder of glycosylation with defective fucosylation 2",
"congenital disorder of glycosylation with defective fucosylation 2  mondo:0020777",
"congenital disorder of glycosylation, type 1aa",
"congenital disorder of glycosylation, type 1bb",
"congenital disorder of glycosylation, type 2v  mondo:0030423",
"congenital disorder of glycosylation, type ia",
"congenital disorder of glycosylation, type ib",
"congenital disorder of glycosylation, type ic",
"congenital disorder of glycosylation, type icc",
"congenital disorder of glycosylation, type id",
"congenital disorder of glycosylation, type ie",
"congenital disorder of glycosylation, type if",
"congenital disorder of glycosylation, type ig",
"congenital disorder of glycosylation, type ih",
"congenital disorder of glycosylation, type ii",
"congenital disorder of glycosylation, type iia",
"congenital disorder of glycosylation, type iib",
"congenital disorder of glycosylation, type iic",
"congenital disorder of glycosylation, type iid",
"congenital disorder of glycosylation, type iie",
"congenital disorder of glycosylation, type iif",
"congenital disorder of glycosylation, type iig",
"congenital disorder of glycosylation, type iih",
"congenital disorder of glycosylation, type iii",
"congenital disorder of glycosylation, type iij",
"congenital disorder of glycosylation, type iik",
"congenital disorder of glycosylation, type iil",
"congenital disorder of glycosylation, type iim",
"congenital disorder of glycosylation, type iin",
"congenital disorder of glycosylation, type iio",
"congenital disorder of glycosylation, type iip",
"congenital disorder of glycosylation, type iiq",
"congenital disorder of glycosylation, type iiq  mondo:0054559",
"congenital disorder of glycosylation, type iir",
"congenital disorder of glycosylation, type iit",
"congenital disorder of glycosylation, type iit  mondo:0030043",
"congenital disorder of glycosylation, type iiz  mondo:0859357",
"congenital disorder of glycosylation, type ij",
"congenital disorder of glycosylation, type ik",
"congenital disorder of glycosylation, type il",
"congenital disorder of glycosylation, type im",
"congenital disorder of glycosylation, type in",
"congenital disorder of glycosylation, type ip",
"congenital disorder of glycosylation, type iq",
"congenital disorder of glycosylation, type ir",
"congenital disorder of glycosylation, type is",
"congenital disorder of glycosylation, type it",
"congenital disorder of glycosylation, type iu",
"congenital disorder of glycosylation, type iw",
"congenital disorder of glycosylation, type ix",
"congenital disorder of glycosylation, type iy",
"congenital dyserythropoietic anemia type 2  mondo:0009134",
"congenital factor v deficiency  mondo:0009210",
"congenital factor x deficiency  mondo:0009212",
"congenital factor xi deficiency  mondo:0012897",
"congenital factor xii deficiency  mondo:0009315",
"congenital fibrinogen deficiency  mondo:0018060",
"congenital fibrosis of extraocular muscles  mondo:0007614",
"congenital heart defects and ectodermal dysplasia",
"congenital heart defects and skeletal malformations syndrome",
"congenital heart defects, dysmorphic facial features, and intellectual developmental disorder",
"congenital heart defects, hamartomas of tongue, and polysyndactyly",
"congenital heart defects, multiple types, 4",
"congenital heart defects, multiple types, 5",
"congenital heart defects, multiple types, 6",
"congenital heart defects, multiple types, 7",
"congenital heart defects, multiple types, 7  mondo:0032913",
"congenital heart defects, nonsyndromic, 1, x linked",
"congenital heart defects, nonsyndromic, 2",
"congenital heart disease  mondo:0005453",
"congenital high-molecular-weight kininogen deficiency  mondo:0009234",
"congenital hypothalamic hamartoma syndrome  mondo:0009436",
"congenital hypotonia, epilepsy, developmental delay, and digital anomalies",
"congenital microcephaly - severe encephalopathy - progressive cerebral atrophy syndrome  mondo:0014258",
"congenital muscular dystrophy with intellectual disability and severe epilepsy  mondo:0014023",
"congenital myasthenic syndrome 12  mondo:0012518",
"congenital myasthenic syndrome 17  mondo:0014578",
"congenital myasthenic syndrome 7  mondo:0014468",
"congenital myopathy  mondo:0019952",
"congenital myopathy with excess of muscle spindles",
"congenital myopathy with myasthenic-like onset  mondo:0018528",
"congenital nephrotic syndrome, finnish type  mondo:0009732",
"congenital nervous system disorder  mondo:0002320",
"congenital plasminogen activator inhibitor type 1 deficiency  mondo:0013227",
"congenital prothrombin deficiency  mondo:0013361",
"congenital short bowel syndrome",
"congenital sideroblastic anemia-b-cell immunodeficiency-periodic fever-developmental delay syndrome  mondo:0014487",
"congenital thrombotic thrombocytopenic purpura  mondo:0010122",
"congestive heart failure and beta blocker response, modifier of",
"conotruncal anomaly face syndrome",
"conotruncal heart malformations",
"conotruncal heart malformations, variable",
"contractural arachnodactyly, congenital",
"contractures, pterygia, and spondylocarpostarsal fusion syndrome 1a",
"contractures, pterygia, and spondylocarpotarsal fusion syndrome 1b",
"convulsions, familial infantile, with paroxysmal choreoathetosis",
"cooks syndrome  mondo:0007134",
"copd, rate of decline of lung function in",
"coproporphyria",
"cornea plana 2, autosomal recessive",
"corneal dystrophy, avellino type",
"corneal dystrophy, congenital stromal",
"corneal dystrophy, epithelial basement membrane",
"corneal dystrophy, fuchs endothelial, 1",
"corneal dystrophy, fuchs endothelial, 3",
"corneal dystrophy, fuchs endothelial, 4",
"corneal dystrophy, fuchs endothelial, 6",
"corneal dystrophy, fuchs endothelial, 8",
"corneal dystrophy, gelatinous drop like",
"corneal dystrophy, groenouw type i",
"corneal dystrophy, lattice type i",
"corneal dystrophy, lattice type iiia",
"corneal dystrophy, posterior polymorphous 2",
"corneal dystrophy, posterior polymorphous, 1",
"corneal dystrophy, posterior polymorphous, 3",
"corneal dystrophy, posterior polymorphous, 4",
"corneal dystrophy, reis bucklers type",
"corneal dystrophy, schnyder type",
"corneal dystrophy, thiel behnke type",
"corneal endothelial dystrophy and perceptive deafness",
"corneal endothelial dystrophy, autosomal recessive",
"corneal fleck dystrophy",
"cornelia de lange syndrome  mondo:0016033",
"cornelia de lange syndrome 1",
"cornelia de lange syndrome 2",
"cornelia de lange syndrome 3",
"cornelia de lange syndrome 4",
"cornelia de lange syndrome 5",
"coronary artery disease, autosomal dominant, 1",
"coronary artery disease, autosomal dominant, 2",
"coronary artery disease, modifier of",
"coronary artery disease, resistance to",
"coronary artery disease, severe, susceptibility to",
"coronary artery disease, susceptibility to",
"coronary artery spasm 1, susceptibility to",
"coronary artery spasm 2, susceptibility to",
"coronary heart disease, susceptibility to, 6",
"coronary heart disease, susceptibility to, 7",
"corpus callosum agenesis-intellectual disability-coloboma-micrognathia syndrome  mondo:0010333",
"corpus callosum, agenesis of, with facial anomalies and cerebellar ataxia",
"corpus callosum, agenesis of, with mental retardation, ocular coloboma and micrognathia",
"corpus callosum, partial agenesis of",
"cortical dysplasia focal epilepsy syndrome",
"cortical dysplasia, complex, with other brain malformations 1",
"cortical dysplasia, complex, with other brain malformations 10",
"cortical dysplasia, complex, with other brain malformations 2",
"cortical dysplasia, complex, with other brain malformations 3",
"cortical dysplasia, complex, with other brain malformations 4",
"cortical dysplasia, complex, with other brain malformations 5",
"cortical dysplasia, complex, with other brain malformations 6",
"cortical dysplasia, complex, with other brain malformations 7",
"cortical dysplasia, complex, with other brain malformations 9",
"cortical malformations, occipital",
"corticosteroid binding globulin deficiency",
"cortisone reductase deficiency 1",
"cortisone reductase deficiency 2",
"costello syndrome",
"costello syndrome  mondo:0009026",
"coumarin resistance",
"cousin syndrome",
"cowchock syndrome",
"cowden syndrome 1",
"cowden syndrome 4",
"cowden syndrome 5",
"cowden syndrome 6",
"cowden syndrome 7",
"cpox-related hereditary coproporphyria  mondo:0800180",
"cpt deficiency, hepatic, type ia",
"cpt ii deficiency, infantile",
"cpt ii deficiency, lethal neonatal",
"cpt ii deficiency, myopathic, stress induced",
"craniodiaphyseal dysplasia, autosomal dominant",
"cranioectodermal dysplasia 1",
"cranioectodermal dysplasia 1  mondo:0021093",
"cranioectodermal dysplasia 2",
"cranioectodermal dysplasia 2  mondo:0013323",
"cranioectodermal dysplasia 3",
"cranioectodermal dysplasia 4",
"craniofacial anomalies and anterior segment dysgenesis syndrome",
"craniofacial deafness hand syndrome",
"craniofacial dysmorphism, skeletal anomalies, and impaired intellectual development syndrome 2",
"craniofacial dysmorphism, skeletal anomalies, and mental retardation syndrome",
"craniofacial skeletal dermatologic dysplasia",
"craniofrontonasal dysplasia",
"craniofrontonasal syndrome  mondo:0010570",
"craniolenticulosutural dysplasia",
"craniometaphyseal dysplasia",
"craniometaphyseal dysplasia, autosomal recessive",
"cranioosteoarthropathy",
"craniosynostosis 1",
"craniosynostosis 2",
"craniosynostosis 2  mondo:0011481",
"craniosynostosis 3",
"craniosynostosis 4",
"craniosynostosis 4  mondo:0010929",
"craniosynostosis 5, susceptibility to",
"craniosynostosis 6",
"craniosynostosis 6  mondo:0014705",
"craniosynostosis 7, susceptibility to",
"craniosynostosis and dental anomalies",
"craniosynostosis and dental anomalies  mondo:0013615",
"craniosynostosis with radiohumeral fusions and other skeletal and craniofacial anomalies",
"craniosynostosis, nonspecific",
"craniotubular dysplasia",
"crash syndrome",
"creatine phosphokinase, elevated serum",
"creatine transporter deficiency  mondo:0010305",
"creutzfeldt jakob disease",
"creutzfeldt jakob disease, variant, resistance to",
"crigler najjar syndrome, type i",
"crigler najjar syndrome, type ii",
"crohn disease associated growth failure",
"crouzon syndrome",
"crouzon syndrome  mondo:0007405",
"crouzon syndrome with acanthosis nigricans",
"crouzon syndrome-acanthosis nigricans syndrome  mondo:0012833",
"cryohydrocytosis",
"cryptophthalmos, unilateral or bilateral, isolated",
"cryptorchidism",
"ctnna1-related diffuse gastric and lobular breast cancer syndrome  mondo:0100256",
"culler jones syndrome",
"currarino syndrome",
"curry jones syndrome, somatic mosaic",
"cushing syndrome, acth independent adrenal, somatic",
"cutaneous porphyria  mondo:0009902",
"cutaneous telangiectasia and cancer syndrome, familial",
"cutis laxa, autosomal dominant",
"cutis laxa, autosomal dominant 1  mondo:0007411",
"cutis laxa, autosomal dominant 2",
"cutis laxa, autosomal dominant 3",
"cutis laxa, autosomal recessive, type 1b  mondo:0013754",
"cutis laxa, autosomal recessive, type ia",
"cutis laxa, autosomal recessive, type ib",
"cutis laxa, autosomal recessive, type ic",
"cutis laxa, autosomal recessive, type iia",
"cutis laxa, autosomal recessive, type iib",
"cutis laxa, autosomal recessive, type iic",
"cutis laxa, autosomal recessive, type iid",
"cutis laxa, autosomal recessive, type iiia",
"cutis laxa, autosomal recessive, type iiib",
"cyanosis, transient neonatal",
"cylindromatosis, familial",
"cyp1b1-related glaucoma with or without anterior segment dysgenesis  mondo:0800472",
"cystathioninuria",
"cystathioninuria  mondo:0009058",
"cystic fibrosis",
"cystic fibrosis lung disease, modifier of",
"cystic kidney disease  mondo:0002473",
"cystinosis  mondo:0016239",
"cystinosis, atypical nephropathic",
"cystinosis, late onset juvenile or adolescent nephropathic",
"cystinosis, nephropathic",
"cystinosis, ocular nonnephropathic",
"cystinuria",
"cystinuria  mondo:0009067",
"cytosolic phospholipase-a2 alpha deficiency associated bleeding disorder  mondo:0018794",
"czech dysplasia",
"d 2 hydroxyglutaric aciduria",
"d 2 hydroxyglutaric aciduria 2",
"d bifunctional protein deficiency",
"d glyceric aciduria",
"d lactic aciduria with susceptibility to gout",
"d-bifunctional protein deficiency  mondo:0009855",
"danon disease",
"danon disease  mondo:0010281",
"darier disease",
"ddost-congenital disorder of glycosylation  mondo:0013789",
"ddx41-related hematologic malignancy predisposition syndrome  mondo:0014809",
"de la chapelle dysplasia",
"de sanctis cacchione syndrome",
"deafness and myopia",
"deafness autosomal recessive 106",
"deafness dystonia syndrome  mondo:0010578",
"deafness with labyrinthine aplasia, microtia, and microdontia  mondo:0012541",
"deafness, autosomal dominant 1, with or without thrombocytopenia",
"deafness, autosomal dominant 10",
"deafness, autosomal dominant 11",
"deafness, autosomal dominant 13",
"deafness, autosomal dominant 15",
"deafness, autosomal dominant 17",
"deafness, autosomal dominant 20/26",
"deafness, autosomal dominant 22",
"deafness, autosomal dominant 22, with hypertrophic cardiomyopathy",
"deafness, autosomal dominant 23",
"deafness, autosomal dominant 25",
"deafness, autosomal dominant 27",
"deafness, autosomal dominant 28",
"deafness, autosomal dominant 2a",
"deafness, autosomal dominant 34, with or without inflammation",
"deafness, autosomal dominant 36",
"deafness, autosomal dominant 37",
"deafness, autosomal dominant 39, with dentinogenesis",
"deafness, autosomal dominant 3a",
"deafness, autosomal dominant 3b",
"deafness, autosomal dominant 40",
"deafness, autosomal dominant 41",
"deafness, autosomal dominant 44",
"deafness, autosomal dominant 4a",
"deafness, autosomal dominant 4b",
"deafness, autosomal dominant 5",
"deafness, autosomal dominant 50",
"deafness, autosomal dominant 56",
"deafness, autosomal dominant 6/14/38",
"deafness, autosomal dominant 64",
"deafness, autosomal dominant 65",
"deafness, autosomal dominant 66",
"deafness, autosomal dominant 67",
"deafness, autosomal dominant 68",
"deafness, autosomal dominant 69, unilateral or asymmetric",
"deafness, autosomal dominant 7",
"deafness, autosomal dominant 70",
"deafness, autosomal dominant 71",
"deafness, autosomal dominant 72",
"deafness, autosomal dominant 73",
"deafness, autosomal dominant 74",
"deafness, autosomal dominant 75",
"deafness, autosomal dominant 76",
"deafness, autosomal dominant 77",
"deafness, autosomal dominant 78",
"deafness, autosomal dominant 79",
"deafness, autosomal dominant 8/12",
"deafness, autosomal dominant 80",
"deafness, autosomal dominant 9",
"deafness, autosomal recessive 100",
"deafness, autosomal recessive 101",
"deafness, autosomal recessive 102",
"deafness, autosomal recessive 103",
"deafness, autosomal recessive 104",
"deafness, autosomal recessive 107",
"deafness, autosomal recessive 108",
"deafness, autosomal recessive 109",
"deafness, autosomal recessive 110",
"deafness, autosomal recessive 111",
"deafness, autosomal recessive 112",
"deafness, autosomal recessive 113",
"deafness, autosomal recessive 114",
"deafness, autosomal recessive 115",
"deafness, autosomal recessive 116",
"deafness, autosomal recessive 117",
"deafness, autosomal recessive 12",
"deafness, autosomal recessive 12, modifier of",
"deafness, autosomal recessive 120",
"deafness, autosomal recessive 15",
"deafness, autosomal recessive 16",
"deafness, autosomal recessive 18a",
"deafness, autosomal recessive 18b",
"deafness, autosomal recessive 1a",
"deafness, autosomal recessive 1b",
"deafness, autosomal recessive 2",
"deafness, autosomal recessive 21",
"deafness, autosomal recessive 22",
"deafness, autosomal recessive 23",
"deafness, autosomal recessive 24",
"deafness, autosomal recessive 25",
"deafness, autosomal recessive 26",
"deafness, autosomal recessive 28",
"deafness, autosomal recessive 29",
"deafness, autosomal recessive 3",
"deafness, autosomal recessive 30",
"deafness, autosomal recessive 31",
"deafness, autosomal recessive 32, with or without immotile sperm",
"deafness, autosomal recessive 35",
"deafness, autosomal recessive 36",
"deafness, autosomal recessive 37",
"deafness, autosomal recessive 39",
"deafness, autosomal recessive 4, with enlarged vestibular aqueduct",
"deafness, autosomal recessive 42",
"deafness, autosomal recessive 44",
"deafness, autosomal recessive 48",
"deafness, autosomal recessive 49",
"deafness, autosomal recessive 53",
"deafness, autosomal recessive 57",
"deafness, autosomal recessive 59",
"deafness, autosomal recessive 6",
"deafness, autosomal recessive 61",
"deafness, autosomal recessive 63",
"deafness, autosomal recessive 66",
"deafness, autosomal recessive 67",
"deafness, autosomal recessive 68",
"deafness, autosomal recessive 7",
"deafness, autosomal recessive 70",
"deafness, autosomal recessive 74",
"deafness, autosomal recessive 76",
"deafness, autosomal recessive 77",
"deafness, autosomal recessive 79",
"deafness, autosomal recessive 8/10",
"deafness, autosomal recessive 84a",
"deafness, autosomal recessive 84b",
"deafness, autosomal recessive 86",
"deafness, autosomal recessive 88",
"deafness, autosomal recessive 89",
"deafness, autosomal recessive 9",
"deafness, autosomal recessive 91",
"deafness, autosomal recessive 93",
"deafness, autosomal recessive 94",
"deafness, autosomal recessive 97",
"deafness, autosomal recessive 98",
"deafness, autosomal recessive 99",
"deafness, congenital heart defects, and posterior embryotoxon",
"deafness, congenital with inner ear agenesis, microtia, and microdontia",
"deafness, congenital, and adult onset progressive leukoencephalopathy",
"deafness, congenital, with onychodystrophy, autosomal dominant",
"deafness, digenic gjb2/gjb6",
"deafness, dystonia, and cerebral hypomyelination",
"deafness, mitochondrial, modifier of",
"deafness, neurosensory, without vestibular involvement, autosomal dominant",
"deafness, x linked 1",
"deafness, x linked 2",
"deafness, x linked 4",
"deafness, x linked 5",
"deafness, x linked 6",
"deafness, x linked 7",
"deafness, y linked 2",
"debrisoquine sensitivity",
"deeah syndrome",
"deep venous thrombosis, protection against",
"deficiency of adenosine deaminase 2  mondo:0100317",
"dehydrated hereditary stomatocytosis 2",
"dehydrated hereditary stomatocytosis with or without pseudohyperkalemia and/or perinatal edema",
"dehydrated hereditary stomatocytosis with or without pseudohyperkalemia and/or perinatal edema  mondo:0008689",
"dejerine sottas disease",
"delayed sleep phase disorder, susceptibility to",
"delpire mcneill syndrome",
"delta beta thalassemia",
"dementia, familial british",
"dementia, familial danish",
"dementia, frontotemporal",
"dementia, frontotemporal, with or without parkinsonism",
"dementia, lewy body",
"dementia, vascular, susceptibility to",
"demyelinating hereditary motor and sensory neuropathy  mondo:0018776",
"dengue fever, protection against",
"dent disease",
"dent disease 2",
"dent disease type 1  mondo:0010225",
"dental anomalies and short stature",
"dentatorubral pallidoluysian atrophy",
"dentin dysplasia, type i, with microdontia and misshapen teeth",
"dentin dysplasia, type ii",
"dentinogenesis imperfecta  mondo:0018849",
"dentinogenesis imperfecta, shields type ii",
"dentinogenesis imperfecta, shields type iii",
"denys drash syndrome",
"denys-drash syndrome  mondo:0008682",
"dermatitis, atopic, susceptibility to, 2",
"dermatofibrosarcoma protuberans",
"dermatopathia pigmentosa reticularis",
"desanto shinawi syndrome",
"desanto-shinawi syndrome  mondo:0018760",
"desbuquois dysplasia 1",
"desbuquois dysplasia 1  mondo:0009629",
"desbuquois dysplasia 2",
"desmoid disease, hereditary",
"desmosterolosis",
"develomental and epileptic encephalopathy 94",
"developemental and epileptic encephalopathy 42",
"developmental and epileptic encephalopathy  mondo:0100062",
"developmental and epileptic encephalopathy 1",
"developmental and epileptic encephalopathy 11",
"developmental and epileptic encephalopathy 12",
"developmental and epileptic encephalopathy 13",
"developmental and epileptic encephalopathy 14",
"developmental and epileptic encephalopathy 15",
"developmental and epileptic encephalopathy 16",
"developmental and epileptic encephalopathy 17",
"developmental and epileptic encephalopathy 18",
"developmental and epileptic encephalopathy 19",
"developmental and epileptic encephalopathy 2",
"developmental and epileptic encephalopathy 21",
"developmental and epileptic encephalopathy 23",
"developmental and epileptic encephalopathy 24",
"developmental and epileptic encephalopathy 25, with amelogenesis imperfecta",
"developmental and epileptic encephalopathy 26",
"developmental and epileptic encephalopathy 27",
"developmental and epileptic encephalopathy 28",
"developmental and epileptic encephalopathy 29",
"developmental and epileptic encephalopathy 3",
"developmental and epileptic encephalopathy 30",
"developmental and epileptic encephalopathy 31",
"developmental and epileptic encephalopathy 32",
"developmental and epileptic encephalopathy 33",
"developmental and epileptic encephalopathy 34",
"developmental and epileptic encephalopathy 35",
"developmental and epileptic encephalopathy 36",
"developmental and epileptic encephalopathy 37",
"developmental and epileptic encephalopathy 38",
"developmental and epileptic encephalopathy 39",
"developmental and epileptic encephalopathy 4",
"developmental and epileptic encephalopathy 40",
"developmental and epileptic encephalopathy 41",
"developmental and epileptic encephalopathy 43",
"developmental and epileptic encephalopathy 44",
"developmental and epileptic encephalopathy 45",
"developmental and epileptic encephalopathy 46",
"developmental and epileptic encephalopathy 47",
"developmental and epileptic encephalopathy 48",
"developmental and epileptic encephalopathy 49",
"developmental and epileptic encephalopathy 5",
"developmental and epileptic encephalopathy 50",
"developmental and epileptic encephalopathy 51",
"developmental and epileptic encephalopathy 52",
"developmental and epileptic encephalopathy 53",
"developmental and epileptic encephalopathy 54",
"developmental and epileptic encephalopathy 55",
"developmental and epileptic encephalopathy 56",
"developmental and epileptic encephalopathy 57",
"developmental and epileptic encephalopathy 58",
"developmental and epileptic encephalopathy 59",
"developmental and epileptic encephalopathy 60",
"developmental and epileptic encephalopathy 61",
"developmental and epileptic encephalopathy 62",
"developmental and epileptic encephalopathy 63",
"developmental and epileptic encephalopathy 64",
"developmental and epileptic encephalopathy 65",
"developmental and epileptic encephalopathy 66",
"developmental and epileptic encephalopathy 67",
"developmental and epileptic encephalopathy 68",
"developmental and epileptic encephalopathy 69",
"developmental and epileptic encephalopathy 7",
"developmental and epileptic encephalopathy 70",
"developmental and epileptic encephalopathy 71",
"developmental and epileptic encephalopathy 72",
"developmental and epileptic encephalopathy 73",
"developmental and epileptic encephalopathy 74",
"developmental and epileptic encephalopathy 75",
"developmental and epileptic encephalopathy 76",
"developmental and epileptic encephalopathy 77",
"developmental and epileptic encephalopathy 78",
"developmental and epileptic encephalopathy 79",
"developmental and epileptic encephalopathy 8",
"developmental and epileptic encephalopathy 80",
"developmental and epileptic encephalopathy 81",
"developmental and epileptic encephalopathy 82",
"developmental and epileptic encephalopathy 83",
"developmental and epileptic encephalopathy 84",
"developmental and epileptic encephalopathy 85, with or without midline brain defects",
"developmental and epileptic encephalopathy 86",
"developmental and epileptic encephalopathy 87",
"developmental and epileptic encephalopathy 88",
"developmental and epileptic encephalopathy 89",
"developmental and epileptic encephalopathy 9",
"developmental and epileptic encephalopathy 90",
"developmental and epileptic encephalopathy 91",
"developmental and epileptic encephalopathy 92",
"developmental and epileptic encephalopathy 93",
"developmental and epileptic encephalopathy, 41  mondo:0014916",
"developmental and epileptic encephalopathy, 50  mondo:0014647",
"developmental delay and seizures with or without movement abnormalities",
"developmental delay with dysmorphic facies and dental anomalies",
"developmental delay with or without dysmorphic facies and autism",
"developmental delay with short stature, dysmorphic facial features, and sparse hair",
"developmental delay with short stature, dysmorphic facial features, and sparse hair  mondo:0031632",
"developmental delay with variable intellectual impairment and behavioral abnormalities",
"developmental delay with variable intellectual impairment and behavioral abnormalities  mondo:0032745",
"developmental delay with variable neurologic and brain abnormalities",
"developmental delay, impaired growth, dysmorphic facies, and axonal neuropathy",
"developmental delay, impaired speech, and behavioral abnormalities  mondo:0859178",
"diabetes insipidus, nephrogenic",
"diabetes insipidus, neurohypophyseal",
"diabetes mellitus, insulin dependent",
"diabetes mellitus, insulin dependent, 12",
"diabetes mellitus, insulin dependent, 2",
"diabetes mellitus, insulin dependent, 20",
"diabetes mellitus, insulin dependent, 22",
"diabetes mellitus, insulin dependent, 5",
"diabetes mellitus, insulin resistant, with acanthosis nigricans",
"diabetes mellitus, ketosis prone, susceptibility to",
"diabetes mellitus, neonatal, with congenital hypothyroidism",
"diabetes mellitus, non insulin dependent, susceptibility to",
"diabetes mellitus, noninsulin dependent",
"diabetes mellitus, noninsulin dependent 1",
"diabetes mellitus, noninsulin dependent, 2",
"diabetes mellitus, noninsulin dependent, 5",
"diabetes mellitus, noninsulin dependent, association with",
"diabetes mellitus, noninsulin dependent, late onset",
"diabetes mellitus, noninsulin dependent, susceptibility to",
"diabetes mellitus, permanent neonatal 1",
"diabetes mellitus, permanent neonatal 3, with or without neurologic features",
"diabetes mellitus, permanent neonatal 4",
"diabetes mellitus, transient neonatal 1",
"diabetes mellitus, transient neonatal 2",
"diabetes mellitus, transient neonatal 3",
"diabetes mellitus, type 2",
"diabetes mellitus, type 2, susceptibility to",
"diabetes mellitus, type ii",
"diabetes mellitus, type ii, susceptibility to",
"diabetes, mellitus, insulin dependent, susceptibility to, 10",
"diabetes, permanent neonatal 2, with or without neurologic features",
"diabetes, type 1, susceptibility to",
"diabetes, type 2",
"diamond blackfan anemia 1",
"diamond blackfan anemia 10",
"diamond blackfan anemia 11",
"diamond blackfan anemia 12",
"diamond blackfan anemia 13",
"diamond blackfan anemia 14 with mandibulofacial dysostosis",
"diamond blackfan anemia 15 with mandibulofacial dysostosis",
"diamond blackfan anemia 16",
"diamond blackfan anemia 17",
"diamond blackfan anemia 18",
"diamond blackfan anemia 19",
"diamond blackfan anemia 20",
"diamond blackfan anemia 3",
"diamond blackfan anemia 4",
"diamond blackfan anemia 5",
"diamond blackfan anemia 6",
"diamond blackfan anemia 7",
"diamond blackfan anemia 8",
"diamond blackfan anemia 9",
"diamond blackfan anemia like",
"diamond-blackfan anemia  mondo:0015253",
"diamond-blackfan anemia 6  mondo:0012937",
"diaph1-related sensorineural hearing loss-thrombocytopenia syndrome  mondo:0044635",
"diaphanospondylodysostosis",
"diaphragmatic hernia 3",
"diaphyseal medullary stenosis with malignant fibrous histiocytoma",
"diaphyseal medullary stenosis-bone malignancy syndrome  mondo:0007205",
"diarrhea 1, secretory chloride, congenital",
"diarrhea 10, protein losing enteropathy type",
"diarrhea 11, malabsorptive, congenital",
"diarrhea 3, secretory sodium, congenital, syndromic",
"diarrhea 4, malabsorptive, congenital",
"diarrhea 5, with tufting enteropathy, congenital",
"diarrhea 6",
"diarrhea 7, protein losing enteropathy type",
"diarrhea 8, secretory sodium, congenital",
"diarrhea 9",
"dias logan syndrome",
"dias-logan syndrome  mondo:0014914",
"diastrophic dysplasia",
"diastrophic dysplasia  mondo:0009107",
"diastrophic dysplasia, broad bone platyspondylic variant",
"dicarboxylic aminoaciduria",
"dicarboxylic aminoaciduria  mondo:0009110",
"dicer1-related tumor predisposition  mondo:0100216",
"diencephalic mesencephalic junction dysplasia syndrome 1",
"diencephalic mesencephalic junction dysplasia syndrome 2",
"diencephalic-mesencephalic junction dysplasia syndrome 2  mondo:0020762",
"diets jongmans syndrome",
"diffuse cerebral and cerebellar atrophy - intractable seizures - progressive microcephaly syndrome  mondo:0014335",
"digeorge syndrome",
"digital arthropathy brachydactyly, familial",
"digital clubbing, isolated congenital",
"dihydrolipoamide dehydrogenase deficiency",
"dihydropteridine reductase deficiency  mondo:0009862",
"dihydropyrimidine dehydrogenase deficiency",
"dihydropyrimidinuria",
"dilated cardiomyopathy  mondo:0005021",
"dilated cardiomyopathy 1j  mondo:0011541",
"dilated cardiomyopathy with woolly hair, keratoderma, and tooth agenesis",
"dimethylglycine dehydrogenase deficiency",
"dimethylglycine dehydrogenase deficiency  mondo:0011610",
"diphtheria, susceptibility to",
"disordered steroidogenesis due to cytochrome p450 oxidoreductase",
"distal hereditary motor neuropathy  mondo:0018894",
"distal myopathy with vocal cord weakness  mondo:0018951",
"distal renal tubular acidosis 1",
"distal renal tubular acidosis 2 with progressive sensorineural hearing loss",
"distal renal tubular acidosis 3, with or without sensorineural hearing loss",
"distal renal tubular acidosis 4 with hemolytic anemia",
"dk1-congenital disorder of glycosylation  mondo:0012556",
"dkc1-related disorder  mondo:0100152",
"dna ligase iv deficiency  mondo:0011686",
"dna topoisomerase i, camptothecin resistant",
"dna topoisomerase ii, resistance to inhibition of, by amsacrine",
"dock2 deficiency  mondo:0014637",
"dominant beta-thalassemia  mondo:0011381",
"donnai barrow syndrome",
"doors syndrome",
"doors syndrome  mondo:0009079",
"dopa-responsive dystonia due to sepiapterin reductase deficiency  mondo:0012994",
"dorfman-chanarin disease  mondo:0010155",
"dowling degos disease 1",
"dowling degos disease 2",
"dowling degos disease 4",
"doyne honeycomb degeneration of retina",
"doyne honeycomb retinal dystrophy  mondo:0007471",
"dpagt1-congenital disorder of glycosylation  mondo:0011964",
"dpm3-congenital disorder of glycosylation  mondo:0013049",
"dravet syndrome",
"dravet syndrome  mondo:0100135",
"drug addiction, susceptibility to",
"drug induced liver injury due to flucloxacillin",
"drug metabolism, altered, ces1 related",
"drug metabolism, altered, cyp2c8 related",
"du pan syndrome",
"duane radial ray syndrome",
"duane retraction syndrome 2",
"duane retraction syndrome 2  mondo:0011444",
"duane retraction syndrome 3",
"dubin johnson syndrome",
"duchenne muscular dystrophy",
"dursun syndrome",
"dyggve melchior clausen disease",
"dysalbuminemic hyperthyroxinemia",
"dysautonomia, familial",
"dyschromatosis symmetrica hereditaria",
"dyschromatosis universalis hereditaria 1",
"dyschromatosis universalis hereditaria 3",
"dyschromatosis universalis hereditaria 3  mondo:0014169",
"dyserythropoietic anemia, congenital, type ia",
"dyserythropoietic anemia, congenital, type ib",
"dyserythropoietic anemia, congenital, type ii",
"dyserythropoietic anemia, congenital, type iv",
"dysfibrinogenemia, congenital",
"dyskeratosis congenita  mondo:0015780",
"dyskeratosis congenita, autosomal dominant 1",
"dyskeratosis congenita, autosomal dominant 1  mondo:0007485",
"dyskeratosis congenita, autosomal dominant 2",
"dyskeratosis congenita, autosomal dominant 2  mondo:0013521",
"dyskeratosis congenita, autosomal dominant 3",
"dyskeratosis congenita, autosomal dominant 4",
"dyskeratosis congenita, autosomal dominant 6",
"dyskeratosis congenita, autosomal recessive 1",
"dyskeratosis congenita, autosomal recessive 2",
"dyskeratosis congenita, autosomal recessive 3",
"dyskeratosis congenita, autosomal recessive 4",
"dyskeratosis congenita, autosomal recessive 5",
"dyskeratosis congenita, autosomal recessive 6",
"dyskeratosis congenita, autosomal recessive 7",
"dyskeratosis congenita, x linked",
"dyskeratosis congenita, x-linked  mondo:0010584",
"dyskinesia, familial, with facial myokymia",
"dyskinesia, limb and orofacial, infantile onset",
"dyslexia, susceptibility to, 1",
"dysosteosclerosis  mondo:0009138",
"dysostosis multiplex, ain naz type",
"dysplasia of the proximal femoral epiphyses  mondo:1030002",
"dysplasminogenemia",
"dysprothrombinemia",
"dyssegmental dysplasia, silverman handmaker type",
"dystonia 1, modifier of",
"dystonia 1, torsion",
"dystonia 11, myoclonic",
"dystonia 12",
"dystonia 16",
"dystonia 2, torsion, autosomal recessive",
"dystonia 24",
"dystonia 25",
"dystonia 26, myoclonic",
"dystonia 27",
"dystonia 27  mondo:0014627",
"dystonia 28, childhood onset",
"dystonia 31",
"dystonia 4, torsion, autosomal dominant",
"dystonia 6, torsion",
"dystonia 9",
"dystonia parkinsonism, x linked",
"dystonia, childhood onset, with optic atrophy and basal ganglia abnormalities",
"dystonia, dopa responsive, due to sepiapterin reductase deficiency",
"dystonia, dopa responsive, with or without hyperphenylalaninemia",
"dystonia, juvenile onset",
"dystransthyretinemic hyperthyroxinemia",
"early infantile epileptic encephalopathy  obsolete termmondo:0016021",
"early-onset parkinsonism-intellectual disability syndrome  mondo:0010709",
"earwax, wet/dry",
"east syndrome  mondo:0013005",
"ebd inversa",
"ebd, bart type",
"ebd, localisata variant",
"ectodermal dysplasia 1, hypohidrotic, x linked",
"ectodermal dysplasia 10a, hypohidrotic/hair/nail type, autosomal dominant",
"ectodermal dysplasia 10b, hypohidrotic/hair/tooth type, autosomal recessive",
"ectodermal dysplasia 11a, hypohidrotic/hair/tooth type, autosomal dominant",
"ectodermal dysplasia 11b, hypohidrotic/hair/tooth type, autosomal recessive",
"ectodermal dysplasia 12, hypohidrotic/hair/tooth/nail type",
"ectodermal dysplasia 13, hair/tooth type",
"ectodermal dysplasia 14, hair/tooth type with or without hypohidrosis",
"ectodermal dysplasia 15, hypohidrotic/hair type",
"ectodermal dysplasia 2, clouston type",
"ectodermal dysplasia 3, witkop type",
"ectodermal dysplasia 4, hair/nail type",
"ectodermal dysplasia 7, hair/nail type",
"ectodermal dysplasia 9, hair/nail type",
"ectodermal dysplasia and immunodeficiency 1",
"ectodermal dysplasia and immunodeficiency 2",
"ectodermal dysplasia syndactyly syndrome 1",
"ectodermal dysplasia with facial dysmorphism and acral, ocular, and brain anomalies, somatic mosaic",
"ectodermal dysplasia wnt10a related  mondo:0100358",
"ectodermal dysplasia, ectrodactyly, and macular dystrophy",
"ectodermal dysplasia/short stature syndrome",
"ectodermal dysplasia/skin fragility syndrome",
"ectopia lentis et pupillae",
"ectopia lentis, familial",
"ectopia lentis, isolated, autosomal recessive",
"ectrodactyly, ectodermal dysplasia, and cleft lip/palate syndrome 3",
"eculizumab, poor response to",
"edict syndrome",
"eem syndrome  mondo:0009155",
"efavirenz central nervous system toxicity, susceptibility to",
"efavirenz, poor metabolism of",
"ehlers danlos syndrome, arthrochalasia type, 1",
"ehlers danlos syndrome, arthrochalasia type, 2",
"ehlers danlos syndrome, cardiac valvular type",
"ehlers danlos syndrome, classic like, 1",
"ehlers danlos syndrome, classic like, 2",
"ehlers danlos syndrome, classic type, 1",
"ehlers danlos syndrome, classic type, 2",
"ehlers danlos syndrome, dermatosparaxis type",
"ehlers danlos syndrome, kyphoscoliotic type, 1",
"ehlers danlos syndrome, kyphoscoliotic type, 2",
"ehlers danlos syndrome, musculocontractural type 1",
"ehlers danlos syndrome, musculocontractural type 2",
"ehlers danlos syndrome, periodontal type, 1",
"ehlers danlos syndrome, periodontal type, 2",
"ehlers danlos syndrome, spondylodysplastic type, 1",
"ehlers danlos syndrome, spondylodysplastic type, 2",
"ehlers danlos syndrome, spondylodysplastic type, 3",
"ehlers danlos syndrome, vascular type",
"ehlers-danlos syndrome, arthrochalasia type  mondo:0007525",
"ehlers-danlos syndrome, cardiac valvular type  mondo:0009159",
"ehlers-danlos syndrome, classic type  mondo:0007522",
"ehlers-danlos syndrome, classic type, 1  mondo:0019567",
"ehlers-danlos syndrome, vascular type  mondo:0017314",
"eiken syndrome",
"elliptocytosis 1",
"elliptocytosis 2",
"elliptocytosis 3",
"ellis van creveld syndrome",
"elsahy waters syndrome",
"elsahy-waters syndrome  mondo:0008885",
"emberger syndrome",
"emery dreifuss muscular dystrophy 1, x linked",
"emery dreifuss muscular dystrophy 2, autosomal dominant",
"emery dreifuss muscular dystrophy 3, autosomal recessive",
"emery dreifuss muscular dystrophy 4, autosomal dominant",
"emery dreifuss muscular dystrophy 5, autosomal dominant",
"emery dreifuss muscular dystrophy 6, x linked",
"emery dreifuss muscular dystrophy 7, ad",
"emphysema cirrhosis, due to aat deficiency",
"emphysema due to aat deficiency",
"encephalitis/encephalopathy, mild, with reversible myelin vacuolization",
"encephalocraniocutaneous lipomatosis, somatic mosaic",
"encephalopathy due to defective mitochondrial and peroxisomal fission 2",
"encephalopathy due to mitochondrial and peroxisomal fission defect  mondo:0054865",
"encephalopathy, acute, infection induced herpes specific, susceptibility to, 1",
"encephalopathy, acute, infection induced herpes specific, susceptibility to, 10",
"encephalopathy, acute, infection induced herpes specific, susceptibility to, 2",
"encephalopathy, acute, infection induced herpes specific, susceptibility to, 5",
"encephalopathy, acute, infection induced herpes specific, susceptibility to, 6",
"encephalopathy, acute, infection induced herpes specific, susceptibility to, 7",
"encephalopathy, acute, infection induced herpes specific, susceptibility to, 8",
"encephalopathy, acute, infection induced, 3, susceptibility to",
"encephalopathy, acute, infection induced, 4, susceptibility to",
"encephalopathy, acute, infection induced, susceptibility to, 9",
"encephalopathy, familial, with neuroserpin inclusion bodies",
"encephalopathy, lethal, due to defective mitochondrial peroxisomal fission 1",
"encephalopathy, neonatal severe",
"encephalopathy, neonatal severe, with lactic acidosis and brain abnormalities",
"encephalopathy, progressive, early onset, with brain atrophy and spasticity",
"encephalopathy, progressive, early onset, with brain atrophy and thin corpus callosum",
"encephalopathy, progressive, early onset, with brain edema and/or leukoencephalopathy",
"encephalopathy, progressive, early onset, with brain edema and/or leukoencephalopathy, 2",
"encephalopathy, progressive, early onset, with episodic rhabdomyolysis",
"encephalopathy, progressive, with amyotrophy and optic atrophy",
"encephalopathy, progressive, with or without lipodystrophy",
"end stage renal disease, nondiabetic, susceptibility to",
"endocrine cerebroosteodysplasia",
"endometrial cancer, familial",
"endometrial cancer, susceptibility to",
"endometrial carcinoma, somatic",
"endove syndrome, limb brain type",
"enhanced s cone syndrome",
"enlarged vestibular aqueduct",
"enlarged vestibular aqueduct syndrome  mondo:0023069",
"enlarged vestibular aqueduct, digenic",
"enolase deficiency",
"enterokinase deficiency",
"eosinophil peroxidase deficiency",
"ephb4-associated vascular malformation spectrum  mondo:0700080",
"epidermal nevus, somatic",
"epidermodysplasia verruciformis",
"epidermodysplasia verruciformis 2",
"epidermodysplasia verruciformis 3",
"epidermodysplasia verruciformis, susceptibility to, 4",
"epidermodysplasia verruciformis, susceptibility to, 4  mondo:0032666",
"epidermodysplasia verruciformis, susceptibility to, 5",
"epidermolysis bullosa dystrophica, ad",
"epidermolysis bullosa dystrophica, ar",
"epidermolysis bullosa dystrophica, autosomal recessive, modifier of",
"epidermolysis bullosa of hands and feet",
"epidermolysis bullosa pruriginosa",
"epidermolysis bullosa simplex mcr",
"epidermolysis bullosa simplex mp",
"epidermolysis bullosa simplex with muscular dystrophy",
"epidermolysis bullosa simplex with nail dystrophy",
"epidermolysis bullosa simplex with pyloric atresia",
"epidermolysis bullosa simplex, autosomal recessive 2",
"epidermolysis bullosa simplex, dowling meara type",
"epidermolysis bullosa simplex, generalized, with scarring and hair loss",
"epidermolysis bullosa simplex, koebner type",
"epidermolysis bullosa simplex, ogna type",
"epidermolysis bullosa simplex, recessive 1",
"epidermolysis bullosa simplex, weber cockayne type",
"epidermolysis bullosa, generalized atrophic benign",
"epidermolysis bullosa, junctional, herlitz type",
"epidermolysis bullosa, junctional, localisata variant",
"epidermolysis bullosa, junctional, non herlitz type",
"epidermolysis bullosa, junctional, with pyloric atresia",
"epidermolysis bullosa, junctional, with pyloric stenosis",
"epidermolysis bullosa, lethal acantholytic",
"epidermolysis bullosa, nonspecific, autosomal recessive",
"epidermolysis bullosa, pretibial",
"epidermolytic hyperkeratosis",
"epilepsy  mondo:0005027",
"epilepsy idiopathic generalized, susceptibility to, 8",
"epilepsy nocturnal frontal lobe, 5",
"epilepsy, childhood absence, susceptibility to, 4",
"epilepsy, childhood absence, susceptibility to, 5",
"epilepsy, childhood absence, susceptibility to, 6",
"epilepsy, early onset, vitamin b6 dependent",
"epilepsy, early onset, with or without developmental delay",
"epilepsy, familial adult myoclonic, 1",
"epilepsy, familial adult myoclonic, 2",
"epilepsy, familial adult myoclonic, 3",
"epilepsy, familial adult myoclonic, 6",
"epilepsy, familial adult myoclonic, 7",
"epilepsy, familial focal, with variable foci 1",
"epilepsy, familial focal, with variable foci 2",
"epilepsy, familial focal, with variable foci 3",
"epilepsy, familial focal, with variable foci 4",
"epilepsy, familial temporal lobe, 1",
"epilepsy, familial temporal lobe, 5",
"epilepsy, familial temporal lobe, 7",
"epilepsy, familial temporal lobe, 8",
"epilepsy, focal, with speech disorder and with or without mental retardation",
"epilepsy, generalized, with febrile seizures plus, type 1",
"epilepsy, generalized, with febrile seizures plus, type 2",
"epilepsy, generalized, with febrile seizures plus, type 3",
"epilepsy, generalized, with febrile seizures plus, type 5, susceptibility to",
"epilepsy, idiopathic generalized, 10",
"epilepsy, idiopathic generalized, susceptibility to, 11",
"epilepsy, idiopathic generalized, susceptibility to, 12",
"epilepsy, idiopathic generalized, susceptibility to, 14",
"epilepsy, idiopathic generalized, susceptibility to, 15",
"epilepsy, idiopathic generalized, susceptibility to, 16",
"epilepsy, idiopathic generalized, susceptibility to, 6",
"epilepsy, idiopathic generalized, susceptibility to, 9",
"epilepsy, juvenile absence, susceptibility to, 1",
"epilepsy, juvenile absence, susceptibility to, 2",
"epilepsy, juvenile myoclonic, susceptibility to",
"epilepsy, juvenile myoclonic, susceptibility to, 10",
"epilepsy, juvenile myoclonic, susceptibility to, 5",
"epilepsy, juvenile myoclonic, susceptibility to, 6",
"epilepsy, juvenile myoclonic, susceptibility to, 8",
"epilepsy, myoclonic, familial adult, 4",
"epilepsy, myoclonic, familial adult, 5",
"epilepsy, nocturnal frontal lobe, 1",
"epilepsy, nocturnal frontal lobe, 3",
"epilepsy, nocturnal frontal lobe, type 4",
"epilepsy, progressive myoclonic 1a unverricht and lundborg",
"epilepsy, progressive myoclonic 1b",
"epilepsy, progressive myoclonic 2a lafora",
"epilepsy, progressive myoclonic 2b lafora",
"epilepsy, progressive myoclonic 3, with or without intracellular inclusions",
"epilepsy, progressive myoclonic 4, with or without renal failure",
"epilepsy, progressive myoclonic 6",
"epilepsy, progressive myoclonic 7",
"epilepsy, progressive myoclonic, 10",
"epilepsy, progressive myoclonic, 11",
"epilepsy, progressive myoclonic, 12",
"epilepsy, progressive myoclonic, 8",
"epilepsy, progressive myoclonic, 9",
"epilepsy, pyridoxine dependent",
"epilepsy, rolandic, with proxysmal exercise induce dystonia and writers cramp",
"epilepsy, x linked, with variable learning disabilities and behavior disorders",
"epiphyseal chondrodysplasia, miura type",
"epiphyseal dysplasia, multiple, 1",
"epiphyseal dysplasia, multiple, 2",
"epiphyseal dysplasia, multiple, 3, with or without myopathy",
"epiphyseal dysplasia, multiple, 4",
"epiphyseal dysplasia, multiple, 5",
"epiphyseal dysplasia, multiple, 6",
"epiphyseal dysplasia, multiple, 7",
"epiphyseal dysplasia, multiple, with myopia and deafness",
"episodic ataxia type 1  mondo:0008047",
"episodic ataxia type 6  mondo:0012982",
"episodic ataxia, type 2",
"episodic ataxia, type 5",
"episodic ataxia, type 6",
"episodic ataxia, type 9",
"episodic ataxia/myokymia syndrome",
"episodic kinesigenic dyskinesia 1",
"episodic kinesigenic dyskinesia 3",
"episodic pain syndrome, familial, 1",
"episodic pain syndrome, familial, 2",
"episodic pain syndrome, familial, 3",
"epithelial recurrent erosion dystrophy",
"erythermalgia, primary",
"erythrocyte lactate transporter defect",
"erythrocytosis 6",
"erythrocytosis 7",
"erythrocytosis, familial, 1",
"erythrocytosis, familial, 2",
"erythrocytosis, familial, 3",
"erythrocytosis, familial, 4",
"erythrocytosis, familial, 5",
"erythrocytosis, familial, 6  mondo:0054801",
"erythrocytosis, familial, 7  mondo:0054802",
"erythrocytosis, familial, 8",
"erythrocytosis, somatic",
"erythroderma, congenital, with palmoplantar keratoderma, hypotrichosis, and hyper ige",
"erythrokeratodermia variabilis  mondo:0017851",
"erythrokeratodermia variabilis et progressiva 2",
"erythrokeratodermia variabilis et progressiva 3",
"erythrokeratodermia variabilis et progressiva 4",
"erythrokeratodermia variabilis et progressiva 4  mondo:0033014",
"erythrokeratodermia variabilis et progressiva 5",
"erythrokeratodermia variabilis et progressiva 7",
"erythrokeratodermia veriabilis et progressiva 6",
"erythroleukemia, familial, susceptibility to",
"escobar syndrome",
"esophageal cancer, alcohol related, susceptibility to",
"esophageal cancer, somatic",
"esophageal carcinoma, somatic",
"esophageal squamous cell carcinoma, somatic",
"essential tremor, hereditary, 1",
"essential tremor, hereditary, 4",
"essential tremor, hereditary, 5",
"estrogen resistance",
"ethylmalonic encephalopathy",
"even plus syndrome",
"ewing sarcoma",
"exercise intolerance, riboflavin responsive",
"exfoliation syndrome, susceptibility to",
"exocrine pancreatic insufficiency, dyserythropoietic anemia, and calvarial hyperostosis",
"exostoses, multiple, type 1",
"exostoses, multiple, type 1  mondo:0007585",
"exostoses, multiple, type 2",
"exostoses, multiple, type 2  mondo:0007586",
"extraoral halitosis due to methanethiol oxidase deficiency  mondo:0029144",
"extraoral halitosis due to mto deficiency",
"exudative vitreoretinopathy  mondo:0019516",
"exudative vitreoretinopathy 1",
"exudative vitreoretinopathy 2, x linked",
"exudative vitreoretinopathy 4",
"exudative vitreoretinopathy 5",
"exudative vitreoretinopathy 6",
"exudative vitreoretinopathy 7",
"eys-related retinopathy  mondo:0800391",
"ezetimibe, nonresponse to",
"fabry disease",
"fabry disease  mondo:0010526",
"fabry disease, cardiac variant",
"facial clefting, oblique, 1",
"facial dysmorphism, hypertrichosis, epilepsy, intellectual/developmental delay, and gingival overgrowth syndrome",
"facial palsy, congenitla, with ptosis and velopharyngeal dysfunction",
"facial paresis, hereditary congenital, 3",
"factor 5 and factor viii, combined deficiency of, 2  mondo:0013331",
"factor v and factor viii, combined deficiency of",
"factor v and factor viii, combined deficiency of, type 1  mondo:0009206",
"factor v deficiency",
"factor vii deficiency",
"factor vii deficiency  mondo:0002244",
"factor x deficiency",
"factor xi deficiency, autosomal dominant",
"factor xi deficiency, autosomal recessive",
"factor xii deficiency",
"factor xiii, a subunit, deficiency of  mondo:0013187",
"factor xiii, b subunit, deficiency of  mondo:0013190",
"factor xiiia deficiency",
"factor xiiib deficiency",
"failure of tooth eruption, primary",
"familial acute necrotizing encephalopathy  mondo:0011953",
"familial adenomatous polyposis 2  mondo:0012041",
"familial adenomatous polyposis 3",
"familial adenomatous polyposis 4",
"familial adenomatous polyposis 4  mondo:0044300",
"familial cold autoinflammatory syndrome 2",
"familial cold autoinflammatory syndrome 3",
"familial cold autoinflammatory syndrome 4",
"familial cold inflammatory syndrome 1",
"familial hemiplegic migraine  mondo:0000700",
"familial hemophagocytic lymphohistiocytosis 2  mondo:0011337",
"familial hemophagocytic lymphohistiocytosis 3  mondo:0012146",
"familial hemophagocytic lymphohistiocytosis 4  mondo:0011336",
"familial hemophagocytic lymphohistiocytosis 5  mondo:0013135",
"familial hyperreninemic hypoaldosteronism type 2  mondo:0011754",
"familial hypertryptophanemia  mondo:0010907",
"familial hypobetalipoproteinemia 1  mondo:0014252",
"familial hypobetalipoproteinemia 2  mondo:0011505",
"familial hypocalciuric hypercalcemia 1  mondo:0007791",
"familial isolated arrhythmogenic right ventricular dysplasia  mondo:0016342",
"familial juvenile hyperuricemic nephropathy type 2  mondo:0013128",
"familial long qt syndrome  mondo:0019171",
"familial mediterranean fever  mondo:0018088",
"familial mediterranean fever, ad",
"familial mediterranean fever, ar",
"familial meningioma  mondo:0011789",
"familial ovarian cancer  mondo:0016248",
"familial thoracic aortic aneurysm and aortic dissection  mondo:0019625",
"fanconi anemia complementation group a  mondo:0009215",
"fanconi anemia complementation group b  mondo:0010351",
"fanconi anemia complementation group c  mondo:0009213",
"fanconi anemia complementation group d1  mondo:0011584",
"fanconi anemia complementation group d2  mondo:0009214",
"fanconi anemia complementation group e  mondo:0010953",
"fanconi anemia complementation group f  mondo:0011325",
"fanconi anemia complementation group g  mondo:0013565",
"fanconi anemia complementation group i  mondo:0012186",
"fanconi anemia complementation group j  mondo:0012187",
"fanconi anemia complementation group l  mondo:0013566",
"fanconi anemia complementation group n  mondo:0012565",
"fanconi anemia complementation group o  mondo:0013248",
"fanconi anemia complementation group p  mondo:0013499",
"fanconi anemia complementation group u  mondo:0014987",
"fanconi anemia, complementation group a",
"fanconi anemia, complementation group b",
"fanconi anemia, complementation group c",
"fanconi anemia, complementation group d1",
"fanconi anemia, complementation group d2",
"fanconi anemia, complementation group e",
"fanconi anemia, complementation group f",
"fanconi anemia, complementation group g",
"fanconi anemia, complementation group i",
"fanconi anemia, complementation group j",
"fanconi anemia, complementation group l",
"fanconi anemia, complementation group n",
"fanconi anemia, complementation group o",
"fanconi anemia, complementation group p",
"fanconi anemia, complementation group q",
"fanconi anemia, complementation group r",
"fanconi anemia, complementation group s",
"fanconi anemia, complementation group s  mondo:0054748",
"fanconi anemia, complementation group t",
"fanconi anemia, complementation group u",
"fanconi anemia, complementation group v",
"fanconi anemia, complementation group w",
"fanconi bickel syndrome",
"fanconi renotubular syndrome 1",
"fanconi renotubular syndrome 2",
"fanconi renotubular syndrome 2  mondo:0013247",
"fanconi renotubular syndrome 3",
"fanconi renotubular syndrome 3  mondo:0014275",
"fanconi renotubular syndrome 4, with maturity onset diabetes of the young",
"fanconi renotubular syndrome 5",
"farber lipogranulomatosis",
"fascioscapulohumeral muscular dystrophy 2, digenic",
"fasting plasma glucose level qtl 5",
"fatty acyl-coa reductase 1 deficiency  mondo:0014510",
"fatty acyl-coa reductase 1 upregulation  mondo:0100230",
"fatty liver, acute, of pregnancy",
"fazio londe disease",
"febrile seizures, familial, 11",
"febrile seizures, familial, 3a",
"febrile seizures, familial, 4",
"febrile seizures, familial, 8",
"feingold syndrome 1",
"fetal akinesia deformation sequence 1",
"fetal akinesia deformation sequence 2",
"fetal akinesia deformation sequence 3",
"fetal akinesia deformation sequence 4",
"fetal hemoglobin quantitative trait locus 1",
"fg syndrome 2",
"fg syndrome 4",
"fibrocalculous pancreatic diabetes, susceptibility to",
"fibrochondrogenesis 1",
"fibrochondrogenesis 2",
"fibrodysplasia ossificans progressiva",
"fibrodysplasia ossificans progressiva  mondo:0007606",
"fibromatosis, gingival, 1",
"fibromatosis, gingival, 5",
"fibrosis of extraocular muscles, congenital, 1",
"fibrosis of extraocular muscles, congenital, 2",
"fibrosis of extraocular muscles, congenital, 3a",
"fibrosis of extraocular muscles, congenital, 3b",
"fibrosis of extraocular muscles, congenital, 5",
"filippi syndrome",
"fils syndrome",
"finca syndrome",
"fish eye disease",
"fleck retina, familial benign",
"fletcher factor prekallikrein deficiency",
"floating harbor syndrome",
"floating-harbor syndrome  mondo:0007621",
"flvcr1-related retinopathy with or without ataxia  mondo:0100449",
"fnip1-associated syndrome  mondo:0100432",
"focal cortical dysplasia, type ii, somatic",
"focal dermal hypoplasia",
"focal dermal hypoplasia  mondo:0010592",
"focal epilepsy  mondo:0005384",
"focal facial dermal dysplasia 3, setleis type",
"focal facial dermal dysplasia 4",
"focal segmental glomerulosclerosis 10",
"focal segmental glomerulosclerosis 3, susceptibility to  mondo:0011917",
"focal segmental glomerulosclerosis 4, susceptibility to  mondo:0012931",
"focal segmental glomerulosclerosis 7  mondo:0014451",
"focal segmental glomerulosclerosis 8",
"focal segmental glomerulosclerosis 9",
"focal segmental glomerulosclerosis 9  mondo:0014539",
"focal segmental glomerulosclerosis and neurodevelopmental syndrome  mondo:0100111",
"folate malabsorption, hereditary",
"fontaine progeroid syndrome",
"forebrain defects",
"foveal hypoplasia - optic nerve decussation defect - anterior segment dysgenesis syndrome  mondo:0012216",
"foveal hypoplasia 1",
"foveal hypoplasia 2, with or without optic nerve misrouting and/or anterior segment dysgenesis",
"foxg1 disorder  mondo:0100040",
"fragile x syndrome",
"fragile x syndrome  mondo:0010383",
"fragile x tremor/ataxia syndrome",
"frank ter haar syndrome",
"frank-ter haar syndrome  mondo:0009579",
"fraser syndrome  mondo:0009046",
"fraser syndrome 1",
"fraser syndrome 2",
"fraser syndrome 3",
"fraser syndrome 3  mondo:0054739",
"frasier syndrome",
"free sialic acid storage disease  mondo:0019366",
"friedreich ataxia",
"friedreich ataxia  mondo:0100339",
"friedreich ataxia with retained reflexes",
"frontometaphyseal dysplasia 1",
"frontometaphyseal dysplasia 2",
"frontonasal dysplasia - severe microphthalmia - severe facial clefting syndrome  mondo:0013271",
"frontonasal dysplasia 1",
"frontonasal dysplasia 2",
"frontonasal dysplasia 3",
"frontorhiny  mondo:0007636",
"frontotemporal dementia and/or amyotrophic lateral sclerosis  mondo:0030923",
"frontotemporal dementia and/or amyotrophic lateral sclerosis 1",
"frontotemporal dementia and/or amyotrophic lateral sclerosis 1  mondo:0007105",
"frontotemporal dementia and/or amyotrophic lateral sclerosis 2",
"frontotemporal dementia and/or amyotrophic lateral sclerosis 2  mondo:0014395",
"frontotemporal dementia and/or amyotrophic lateral sclerosis 3",
"frontotemporal dementia and/or amyotrophic lateral sclerosis 3  mondo:0014640",
"frontotemporal dementia and/or amyotrophic lateral sclerosis 4",
"frontotemporal dementia and/or amyotrophic lateral sclerosis 4  mondo:0014641",
"frontotemporal dementia and/or amyotrophic lateral sclerosis 5",
"frontotemporal dementia and/or amyotrophic lateral sclerosis 5  mondo:0030875",
"frontotemporal dementia and/or amyotrophic lateral sclerosis 6",
"frontotemporal dementia and/or amyotrophic lateral sclerosis 7  mondo:0010936",
"frontotemporal dementia and/or amyotrophic lateral sclerosis 8  mondo:0030872",
"frontotemporal dementia and/or amytrophic lateral sclerosis 7",
"frontotemporal dementia and/or amytrophic lateral sclerosis 8",
"frontotemporal lobar degeneration with ubiquitin positive inclusions",
"frontotemporal lobar degeneration, tardbp related",
"fructose 1,6 bisphosphatase deficiency",
"fructose intolerance, hereditary",
"fructosuria",
"fucosidosis",
"fucosidosis  mondo:0009254",
"fucosyltransferase 6 deficiency",
"fuhrmann syndrome",
"fumarase deficiency",
"fundus albipunctatus",
"fundus flavimaculatus",
"g6pd deficiency  mondo:0005775",
"gaba transaminase deficiency",
"gabriele de vries syndrome",
"galactokinase deficiency  mondo:0009255",
"galactokinase deficiency with cataracts",
"galactose epimerase deficiency",
"galactose epimerase deficiency  mondo:0009257",
"galactosemia",
"galactosemia  mondo:0018116",
"galactosemia 4  mondo:0030105",
"galactosemia iv",
"galactosialidosis",
"galactosialidosis  mondo:0009737",
"gallbladder disease 1",
"gallbladder disease 4",
"galloway mowat syndrome 1",
"galloway mowat syndrome 2, x linked",
"galloway mowat syndrome 3",
"galloway mowat syndrome 4",
"galloway mowat syndrome 5",
"galloway mowat syndrome 6",
"galloway mowat syndrome 7",
"galloway mowat syndrome 8",
"gand syndrome",
"gapo syndrome",
"gardner syndrome",
"gastric adenocarcinoma and proximal polyposis of the stomach",
"gastric adenocarcinoma and proximal polyposis of the stomach  mondo:0017790",
"gastric cancer risk after h. pylori infection",
"gastric cancer, hereditary diffuse, with or without cleft lip and/or palate",
"gastric cancer, somatic",
"gastrointestinal defects and immunodeficiency syndrome",
"gastrointestinal stromal tumor",
"gastrointestinal stromal tumor  mondo:0011719",
"gastrointestinal stromal tumor, familial",
"gastrointestinal stromal tumor/gist plus syndrome, somatic or familial",
"gastrointestinal ulceration, recurrent, with dysfunctional platelets",
"gata1-related x-linked cytopenia  mondo:0100089",
"gata2 deficiency with susceptibility to mds/aml  mondo:0042982",
"gata6-related congenital heart disease with or without pancreatic agenesis or neonatal diabetes  mondo:0100540",
"gaucher disease  mondo:0018150",
"gaucher disease due to saposin c deficiency  mondo:0012517",
"gaucher disease, atypical",
"gaze palsy, familial horizontal, with progressive scoliosis 1  mondo:0020790",
"gaze palsy, familial horizontal, with progressive scoliosis, 1",
"gaze palsy, familial horizontal, with progressive scoliosis, 2",
"geleophysic dysplasia 1",
"geleophysic dysplasia 2",
"geleophysic dysplasia 3",
"generalized epilepsy with febrile seizures plus  mondo:0018214",
"generalized epilepsy with febrile seizures plus, type 10",
"generalized epilepsy with febrile seizures plus, type 9",
"generalized epilepsy-paroxysmal dyskinesia syndrome  mondo:0012276",
"genitopatellar syndrome",
"genitourinary and/or brain malformation syndrome  mondo:0032934",
"genitourinary and/or/brain malformation syndrome",
"germ cell tumors, somatic",
"geroderma osteodysplasticum",
"gerstmann straussler disease",
"ghosal hematodiaphyseal dysplasia  mondo:0009274",
"ghosal hematodiaphyseal syndrome",
"giant axonal neuropathy 1",
"giant axonal neuropathy 1  mondo:0009749",
"giant axonal neuropathy 2, autosomal dominant",
"giant platelet disorder, isolated",
"gigantism due to ghrf hypersecretion",
"gilbert syndrome",
"gilles de la tourette syndrome, susceptibility to",
"gillespie syndrome",
"gillessen kaesbach nishimura syndrome",
"gitelman syndrome",
"glanzmann thrombasthenia  mondo:0100326",
"glanzmann thrombasthenia 1",
"glanzmann thrombasthenia 2",
"glass syndrome",
"glaucoma 1, open angle, 1o",
"glaucoma 1, open angle, e",
"glaucoma 1, open angle, f",
"glaucoma 1, open angle, f  obsolete termmondo:0011311",
"glaucoma 1, open angle, g",
"glaucoma 1, open angle, g  obsolete termmondo:0012357",
"glaucoma 1, open angle, o  mondo:0013134",
"glaucoma 1a, primary open angle",
"glaucoma 3, primary congenital, d",
"glaucoma 3, primary congenital, d  mondo:0013122",
"glaucoma 3, primary congenital, e",
"glaucoma 3a, primary open angle, congenital, juvenile, or adult onset",
"glaucoma, normal tension, susceptibility to",
"glaucoma, normal tension, susceptibility to  mondo:0011693",
"glaucoma, primary closed angle",
"glioblastoma 3",
"glioblastoma, somatic",
"glioma susceptibility 1",
"glioma susceptibility 2",
"glioma susceptibility 9",
"glioma, susceptibility to, somatic",
"global developmental delay with or without impaired intellectual development",
"global developmental delay with speech and behavioral abnormalities",
"global developmental delay, absent or hypoplastic corpus callosum, and dysmorphic facies",
"global developmental delay, progressive ataxia, and elevated glutamine",
"glomerulopathy with fibronectin deposits 2",
"glomerulopathy with fibronectin deposits 2  mondo:0011165",
"glomerulosclerosis, focal segmental, 1",
"glomerulosclerosis, focal segmental, 2",
"glomerulosclerosis, focal segmental, 3",
"glomerulosclerosis, focal segmental, 4, susceptibility to",
"glomerulosclerosis, focal segmental, 5",
"glomerulosclerosis, focal segmental, 6",
"glomerulosclerosis, focal segmental, 7",
"glomuvenous malformations",
"glow syndrome, somatic mosaic",
"glucocorticoid deficiency 2",
"glucocorticoid deficiency 4, with or without mineralocorticoid deficiency",
"glucocorticoid deficiency 5",
"glucocorticoid deficiency, due to acth unresponsiveness",
"glucocorticoid resistance",
"glucocorticoid therapy, response to",
"glucose/galactose malabsorption",
"glut1 deficiency syndrome  mondo:0000188",
"glut1 deficiency syndrome 1, infantile onset, severe",
"glut1 deficiency syndrome 2, childhood onset",
"glutamate formiminotransferase deficiency",
"glutamate pyruvate transaminase 2 deficiency  mondo:0014567",
"glutaminase deficiency  mondo:0600001",
"glutamine deficiency, congenital",
"glutaric acidemia iia",
"glutaric acidemia iib",
"glutaric acidemia iic",
"glutaric acidemia type 3  mondo:0009283",
"glutaric aciduria iii",
"glutaricaciduria, type i",
"glutaryl-coa dehydrogenase deficiency  mondo:0009281",
"glutathione synthetase deficiency",
"glutathioninuria",
"glycerol kinase deficiency",
"glycerol quantitative trait locus",
"glyceronephosphate o-acyltransferase deficiency  mondo:0100273",
"glycine encephalopathy",
"glycine encephalopathy  mondo:0011612",
"glycine encephalopathy with normal serum glycine",
"glycine n methyltransferase deficiency",
"glycine n-methyltransferase deficiency  mondo:0011698",
"glycogen storage disease 0, liver",
"glycogen storage disease 0, muscle",
"glycogen storage disease due to glycogen branching enzyme deficiency  mondo:0009292",
"glycogen storage disease due to muscle and heart glycogen synthase deficiency  mondo:0012693",
"glycogen storage disease i  mondo:0002413",
"glycogen storage disease ia",
"glycogen storage disease ib",
"glycogen storage disease ic",
"glycogen storage disease ii",
"glycogen storage disease ii  mondo:0009290",
"glycogen storage disease iii  mondo:0009291",
"glycogen storage disease iiia",
"glycogen storage disease iiib",
"glycogen storage disease iv",
"glycogen storage disease ixb  mondo:0009868",
"glycogen storage disease ixc",
"glycogen storage disease ixc  mondo:0013091",
"glycogen storage disease of heart, lethal congenital",
"glycogen storage disease vi",
"glycogen storage disease vi  mondo:0009294",
"glycogen storage disease vii",
"glycogen storage disease x",
"glycogen storage disease xi",
"glycogen storage disease xii",
"glycogen storage disease xiii",
"glycogen storage disease xv",
"glycogen storage disease, type ixa1",
"glycogen storage disease, type ixa2",
"glycogen storage disorder due to hepatic glycogen synthase deficiency  mondo:0009414",
"glycosylphosphatidylinositol biosynthesis defect 11",
"glycosylphosphatidylinositol biosynthesis defect 15",
"glycosylphosphatidylinositol biosynthesis defect 15  mondo:0060627",
"glycosylphosphatidylinositol biosynthesis defect 16",
"glycosylphosphatidylinositol biosynthesis defect 17",
"glycosylphosphatidylinositol biosynthesis defect 18",
"glycosylphosphatidylinositol biosynthesis defect 21  mondo:0032824",
"glycosylphosphatidylinositol biosynthesis defect 25",
"glycosylphosphatidylinositol deficiency",
"glyoxalase ii deficiency",
"gm1 gangliosidosis  mondo:0018149",
"gm1 gangliosidosis, type i",
"gm1 gangliosidosis, type ii",
"gm1 gangliosidosis, type iii",
"gm2 gangliosidosis, ab variant",
"gm2 gangliosidosis, several forms",
"gm3 synthase deficiency  mondo:0018274",
"gnat2-related retinopathy  mondo:0800392",
"gnathodiaphyseal dysplasia",
"gnptab-mucolipidosis  mondo:0100122",
"gnptg-mucolipidosis  mondo:0009652",
"goiter, multinodular 1, with or without sertoli leydig cell tumors",
"goldberg shprintzen megacolon syndrome",
"goldberg-shprintzen syndrome  mondo:0012280",
"gonadal dysgenesis, dysmorphic facies, retinal dystrophy, and myopathy",
"gout susceptibility 4",
"gout, prps related",
"gpr179-related retinopathy  mondo:0800396",
"gracile bone dysplasia",
"gracile syndrome",
"graft versus host disease, protection against",
"grange syndrome",
"gray platelet syndrome",
"gray platelet syndrome  mondo:0007686",
"greenberg dysplasia  mondo:0008974",
"greenberg skeletal dysplasia",
"greig cephalopolysyndactyly syndrome",
"griscelli syndrome type 1  mondo:0008962",
"griscelli syndrome type 2  mondo:0011872",
"griscelli syndrome, type 1",
"griscelli syndrome, type 2",
"griscelli syndrome, type 3",
"grm6-related retinopathy  mondo:0800397",
"growth hormone deficiency with pituitary anomalies",
"growth hormone deficiency, isolated partial",
"growth hormone deficiency, isolated, type ia",
"growth hormone deficiency, isolated, type ib",
"growth hormone deficiency, isolated, type ii",
"growth hormone deficiency, isolated, type iv",
"growth hormone deficiency, isolated, type v",
"growth hormone insensitivity with immune dysregulation 1, autosomal recessive",
"growth hormone insensitivity with immune dysregulation 2, autosomal dominant",
"growth hormone insensitivity, partial",
"growth retardation with deafness and mental retardation due to igf1 deficiency",
"growth retardation, developmental delay, facial dysmorphism",
"growth retardation, impaired intellectual development, hypotonia, and hepatopathy",
"gtp cyclohydrolase i deficiency  mondo:0100184",
"guanidinoacetate methyltransferase deficiency  mondo:0012999",
"gucy2d-related dominant retinopathy  mondo:0100441",
"gucy2d-related recessive retinopathy  mondo:0100453",
"guttmacher syndrome",
"gyrate atrophy of choroid and retina with or without ornithinemia",
"h syndrome  mondo:0011273",
"h. pylori infection, susceptibility to",
"haddad syndrome",
"haddad syndrome  mondo:0020493",
"hailey hailey disease",
"haim munk syndrome",
"hair morphology 1, hair thickness",
"hajdu cheney syndrome",
"hamamy syndrome",
"hand foot uterus syndrome",
"hand2 related congenital heart defect  mondo:0800476",
"hangover, susceptibility to",
"hao fountain syndrome",
"hao-fountain syndrome  mondo:0014805",
"harderoporphyria",
"harel yoon syndrome",
"harp syndrome",
"hartnup disease  mondo:0009324",
"hartnup disorder",
"hartsfield syndrome",
"hartsfield-bixler-demyer syndrome  mondo:0014196",
"hashimoto thyroiditis",
"hawkinsinuria",
"hawkinsinuria  mondo:0007700",
"hay wells syndrome",
"hdl deficiency, familial, 1",
"hearing impairment and infertile male syndrome  mondo:0100069",
"hearing loss disorder  mondo:0005365",
"hearing loss, autosomal recessive  mondo:0019588",
"hearing loss, autosomal recessive 119  mondo:0030480",
"hearing loss, x-linked 6  mondo:0010484",
"heart and brain malformation syndrome",
"heart block, nonprogressive",
"heart block, progressive, type ia",
"heart hand syndrome, slovenian type",
"heimler syndrome 1",
"heimler syndrome 2",
"heinz body anemia",
"heinz body anemias, alpha",
"helios deficiency  mondo:0800139",
"helix syndrome",
"hellp syndrome, maternal, of pregnancy",
"helsmoortel van der aa syndrome",
"hemangioblastoma, cerebellar, somatic",
"hemangioma, capillary infantile, somatic",
"hemangioma, capillary infantile, susceptibility to",
"hematuria, benign familial",
"hematuria, familial benign",
"heme oxygenase 1 deficiency",
"heme oxygenase 1 deficiency  mondo:0013536",
"hemiplegic migraine-developmental and epileptic encephalopathy spectrum  mondo:0100539",
"hemochromatosis",
"hemochromatosis, type 2a",
"hemochromatosis, type 2b",
"hemochromatosis, type 3",
"hemochromatosis, type 4",
"hemochromatosis, type 5",
"hemoglobin h disease, deletional and nondeletional",
"hemoglobin h disease, nondeletional",
"hemoglobin m disease  mondo:0018023",
"hemoglobin, high altitude adaptation",
"hemolytic anemia due to adenylate kinase deficiency",
"hemolytic anemia due to gamma glutamylcysteine synthetase deficiency",
"hemolytic anemia due to glutathione peroxidase deficiency",
"hemolytic anemia due to glutathione reductase deficiency",
"hemolytic anemia due to glutathione synthetase deficiency",
"hemolytic anemia due to hexokinase deficiency",
"hemolytic anemia due to phosphofructokinase deficiency",
"hemolytic anemia due to triosephosphate isomerase deficiency",
"hemolytic anemia, cd59 mediated, with or without immune mediated polyneuropathy",
"hemolytic anemia, congenital, x linked",
"hemolytic anemia, g6pd deficient favism",
"hemolytic anemia, nonspherocytic, due to glucose phosphate isomerase deficiency",
"hemolytic uremic syndrome, atypical, susceptibility to",
"hemolytic uremic syndrome, atypical, susceptibility to, 1",
"hemolytic uremic syndrome, atypical, susceptibility to, 2",
"hemolytic uremic syndrome, atypical, susceptibility to, 3",
"hemolytic uremic syndrome, atypical, susceptibility to, 4",
"hemolytic uremic syndrome, atypical, susceptibility to, 5",
"hemolytic uremic syndrome, atypical, susceptibility to, 6",
"hemolytic uremic syndrome, atypical, susceptibility to, 7",
"hemophagocytic lymphohistiocytosis, familial, 2",
"hemophagocytic lymphohistiocytosis, familial, 3",
"hemophagocytic lymphohistiocytosis, familial, 4",
"hemophagocytic lymphohistiocytosis, familial, 5",
"hemophilia a",
"hemophilia a  mondo:0010602",
"hemophilia b",
"hemophilia b  mondo:0010604",
"hemorrhage, intracerebral, susceptibility to",
"hemorrhagic destruction of the brain, subependymal calcification, and cataracts",
"hemorrhagic diathesis due to antithrombin pittsburgh",
"hemosiderosis, systemic, due to aceruloplasminemia",
"hennekam lymphangiectasia lymphedema syndrome 1",
"hennekam lymphangiectasia lymphedema syndrome 2",
"hennekam lymphangiectasia lymphedema syndrome 3",
"heparin cofactor 2 deficiency  mondo:0012876",
"hepatic adenoma, somatic",
"hepatic lipase deficiency",
"hepatic veno-occlusive disease-immunodeficiency syndrome  mondo:0009338",
"hepatic venoocclusive disease with immunodeficiency",
"hepatitis b virus infection, susceptibility to",
"hepatitis b virus, susceptibility to",
"hepatitis c virus infection, response to therapy of",
"hepatitis c virus, resistance to",
"hepatitis c virus, response to therapy of",
"hepatitis c virus, susceptibility to",
"hepatitis, fulminant viral, susceptibility to",
"hepatoblastoma, somatic",
"hepatocellular cancer, somatic",
"hepatocellular carcinoma, childhood type, somatic",
"hepatocellular carcinoma, somatic",
"hereditary angioedema type 3  mondo:0012526",
"hereditary angioedema with c1inh deficiency  mondo:0033946",
"hereditary antithrombin deficiency  mondo:0013144",
"hereditary attr amyloidosis  obsolete termmondo:0017132",
"hereditary breast carcinoma  mondo:0016419",
"hereditary chronic pancreatitis  mondo:0008185",
"hereditary leiomyomatosis and renal cell cancer  mondo:0007888",
"hereditary mixed polyposis syndrome  mondo:0011023",
"hereditary motor and sensory neuropathy via",
"hereditary motor and sensory neuropathy, okinawa type",
"hereditary motor and sensory neuropathy, type iic",
"hereditary neuropathy with liability to pressure palsies  mondo:0008087",
"hereditary nonpolyposis colon cancer  mondo:0018630",
"hereditary peripheral neuropathy  mondo:0020127",
"hereditary persistence of alpha fetoprotein",
"hereditary persistence of fetal hemoglobin",
"hereditary pheochromocytoma-paraganglioma  mondo:0017366",
"hereditary sclerosing poikiloderma with tendon and pulmonary involvement  mondo:0014310",
"hereditary sensory and autonomic neuropathy  mondo:0015364",
"hereditary sensory and autonomic neuropathy type 4  mondo:0009746",
"hereditary sensory and autonomic neuropathy type 6  mondo:0013839",
"hereditary spastic paraplegia  mondo:0019064",
"hereditary spastic paraplegia 11  mondo:0011445",
"hereditary spastic paraplegia 33  mondo:0012448",
"hereditary spastic paraplegia 8  mondo:0011339",
"hereditary spherocytosis  mondo:0019350",
"hereditary thrombocytopenia and hematologic cancer predisposition syndrome  mondo:0011071",
"hereditary thrombophilia due to congenital histidine-rich (poly-l) glycoprotein deficiency  mondo:0013143",
"hereditary thrombophilia due to congenital protein c deficiency  mondo:0019145",
"hereditary thrombophilia due to congenital protein s deficiency  mondo:0019144",
"hereditary von willebrand disease  mondo:0019565",
"hermansky pudlak syndrome 1",
"hermansky pudlak syndrome 10",
"hermansky pudlak syndrome 11",
"hermansky pudlak syndrome 2",
"hermansky pudlak syndrome 3",
"hermansky pudlak syndrome 4",
"hermansky pudlak syndrome 5",
"hermansky pudlak syndrome 6",
"hermansky pudlak syndrome 7",
"hermansky pudlak syndrome 8",
"hermansky pudlak syndrome 9",
"hermansky-pudlak syndrome 1  mondo:0008748",
"hermansky-pudlak syndrome 10  mondo:0014885",
"hermansky-pudlak syndrome 11  mondo:0030903",
"hermansky-pudlak syndrome 2  mondo:0011997",
"hermansky-pudlak syndrome 3  mondo:0013555",
"hermansky-pudlak syndrome 4  mondo:0013556",
"hermansky-pudlak syndrome 5  mondo:0013557",
"hermansky-pudlak syndrome 6  mondo:0013558",
"hermansky-pudlak syndrome 7  mondo:0013559",
"hermansky-pudlak syndrome 8  mondo:0013560",
"hermansky-pudlak syndrome 9  mondo:0013606",
"heterotaxy, visceral, 1, x linked",
"heterotaxy, visceral, 12, autosomal",
"heterotaxy, visceral, 2, autosomal",
"heterotaxy, visceral, 4, autosomal",
"heterotaxy, visceral, 5",
"heterotaxy, visceral, 6, autosomal recessive",
"heterotaxy, visceral, 7, autosomal",
"heterotaxy, visceral, 8, autosomal",
"heterotaxy, visceral, 9, autosomal, with male infertility",
"heterotopia, periventricular, 1",
"hex a pseudodeficiency",
"heyn sproul jackson syndrome",
"heyn-sproul-jackson syndrome  mondo:0032882",
"hfe hemochromatosis, modifier of",
"high density lipoprotein cholesterol level qtl 10",
"high density lipoprotein cholesterol level qtl 11",
"high density lipoprotein cholesterol level qtl 12",
"high density lipoprotein cholesterol level qtl 7",
"high density lipoprotein cholesterol level qtl 8",
"high density lipoprotein cholesterol level qtl 9",
"high density lipoprotein cholesterol level qtl6",
"high molecular weight kininogen deficiency",
"high myopia-sensorineural deafness syndrome  mondo:0009082",
"hip dysplasia, beukes type",
"hirschsprung disease, cardiac defects, and autonomic dysfunction",
"hirschsprung disease, protection against",
"hirschsprung disease, susceptibility to, 1",
"hirschsprung disease, susceptibility to, 2",
"hirschsprung disease, susceptibility to, 3",
"hirschsprung disease, susceptibility to, 4",
"histidinemia",
"histidinemia  mondo:0009345",
"histiocytoma, angiomatoid fibrous, somatic",
"histiocytosis lymphadenopathy plus syndrome",
"hiv 1 disease, delayed progression of",
"hiv 1 disease, rapid progression of",
"hiv 1 viremia, susceptibility to",
"hiv 1, resistance to",
"hiv 1, susceptibility to",
"hiv infection, resistance to",
"hiv infection, susceptibility/resistance to",
"hiv type 1, susceptibility to",
"hiv/aids, susceptibility to",
"hiv1 infection, resistance to",
"hiv1, resistance to",
"hmg coa lyase deficiency",
"hmg coa synthase 2 deficiency",
"hodgkin lymphoma, susceptibility to",
"holocarboxylase synthetase deficiency",
"holocarboxylase synthetase deficiency  mondo:0009666",
"holoprosencephaly  mondo:0016296",
"holoprosencephaly 11",
"holoprosencephaly 12 with or without pancreatic agenesis  mondo:0032787",
"holoprosencephaly 12, with or without pancreatic agenesis",
"holoprosencephaly 13, x linked",
"holoprosencephaly 2",
"holoprosencephaly 3",
"holoprosencephaly 4",
"holoprosencephaly 5",
"holoprosencephaly 7",
"holoprosencephaly 9",
"holt oram syndrome",
"holt-oram syndrome  mondo:0007732",
"homocysteine plasma level",
"homocystinuria due to methylene tetrahydrofolate reductase deficiency  mondo:0009353",
"homocystinuria due to mthfr deficiency",
"homocystinuria megaloblastic anemia, cbl e type",
"homocystinuria megaloblastic anemia, cblg complementation type",
"homocystinuria, b6 responsive and nonresponsive types",
"homocystinuria, cbld type, variant 1",
"hsd10 mitochondrial disease",
"hsd10 mitochondrial disease  mondo:0010327",
"humerofemoral hypoplasia with radiotibial ray deficiency",
"huntington disease",
"huntington disease  mondo:0007739",
"huntington disease like 1",
"huntington disease like 2",
"huriez syndrome",
"hutchinson gilford progeria",
"hyaline fibromatosis syndrome",
"hyaline fibromatosis syndrome  mondo:0009229",
"hydatidiform mole, recurrent, 1",
"hydatidiform mole, recurrent, 2",
"hydatidiform mole, recurrent, 3",
"hydranencephaly with abnormal genitalia",
"hydrocephalus due to aqueductal stenosis",
"hydrocephalus with congenital idiopathic intestinal pseudoobstruction",
"hydrocephalus with hirschsprung disease",
"hydrocephalus, congenital communicating, 1",
"hydrocephalus, congenital, 1",
"hydrocephalus, congenital, 2, with or without brain or eye anomalies",
"hydrocephalus, congenital, 3, with brain anomalies",
"hydrocephalus, normal pressure, 1",
"hydrolethalus syndrome",
"hydrolethalus syndrome 2",
"hydrops, lactic acidosis, and sideroblastic anemia",
"hydroxykynureninuria",
"hydroxyprolinemia  mondo:0009374",
"hyper igd syndrome",
"hyper ige recurrent infection syndrome",
"hyper ige recurrent infection syndrome 3, autosomal recessive",
"hyper ige recurrent infection syndrome 4, autosomal recessive",
"hyper ige recurrent infection syndrome 5, autosomal recessive",
"hyper ige recurrent infection syndrome, autosomal recessive",
"hyper-ige recurrent infection syndrome 1, autosomal dominant  mondo:0007818",
"hyper-ige recurrent infection syndrome 3, autosomal recessive  mondo:0032654",
"hyper-ige recurrent infection syndrome 5, autosomal recessive  mondo:0030069",
"hyper-igm syndrome type 1  mondo:0010626",
"hyper-igm syndrome type 2  mondo:0011528",
"hyper-igm syndrome type 3  mondo:0011735",
"hyper-igm syndrome type 5  mondo:0011971",
"hyperaldosteronism, familial, type ii",
"hyperaldosteronism, familial, type iii",
"hyperaldosteronism, familial, type iv",
"hyperalphalipoproteinemia",
"hyperammonemia due to carbonic anhydrase va deficiency",
"hyperammonemia due to n-acetylglutamate synthase deficiency  mondo:0009377",
"hyperammonemic encephalopathy due to carbonic anhydrase va deficiency  mondo:0014332",
"hyperandrogenism, nonclassic type, due to 21 hydroxylase deficiency",
"hyperapobetalipoproteinemia, susceptibility to",
"hyperargininemia  mondo:0008814",
"hyperbilirubinemia, familial transient neonatal",
"hyperbilirubinemia, rotor type, digenic",
"hyperbiliverdinemia",
"hypercalcemia, infantile, 1",
"hypercalcemia, infantile, 2",
"hypercalcemia, infantile, 2  mondo:0014851",
"hypercalciuria, absorptive, susceptibility to",
"hypercarotenemia and vitamin a deficiency, autosomal dominant",
"hyperchlorhidrosis, isolated",
"hypercholanemia, familial",
"hypercholanemia, familial 1",
"hypercholanemia, familial 2",
"hypercholesterolemia, autosomal dominant, 3  mondo:0011369",
"hypercholesterolemia, autosomal dominant, type b  mondo:0007751",
"hypercholesterolemia, familial, 1",
"hypercholesterolemia, familial, 1  mondo:0007750",
"hypercholesterolemia, familial, 2",
"hypercholesterolemia, familial, 3",
"hypercholesterolemia, familial, 4",
"hypercholesterolemia, familial, 4  mondo:0011374",
"hypercholesterolemia, familial, due to ldlr defect, modifier of",
"hypercholesterolemia, familial, modifier of",
"hypercholesterolemia, susceptibility to",
"hyperchylomicronemia, late onset",
"hyperekplexia 1",
"hyperekplexia 2",
"hyperekplexia 3",
"hyperekplexia 4",
"hypereosinophilic syndrome, idiopathic, resistant to imatinib",
"hyperferritinemia cataract syndrome",
"hyperfibrinolysis, familial, due to increased release of plat",
"hyperglycinemia, lactic acidosis, and seizures",
"hyperglycinuria",
"hyperinsulinemic hypoglycemia with polycystic kidney disease  mondo:1030000",
"hyperinsulinemic hypoglycemia, familial, 1",
"hyperinsulinemic hypoglycemia, familial, 2",
"hyperinsulinemic hypoglycemia, familial, 3",
"hyperinsulinemic hypoglycemia, familial, 4",
"hyperinsulinemic hypoglycemia, familial, 5",
"hyperinsulinemic hypoglycemia, familial, 7",
"hyperinsulinism due to short chain 3-hydroxylacyl-coa dehydrogenase deficiency  obsolete termmondo:0009278",
"hyperinsulinism hyperammonemia syndrome",
"hyperinsulinism-hyperammonemia syndrome  mondo:0011717",
"hyperkalemic periodic paralysis, type 2",
"hyperkeratotic cutaneous capillary venous malformations associated with cerebral capillary malformations",
"hyperlipidemia, familial combined, susceptibility to",
"hyperlipoproteinemia, type 1d",
"hyperlipoproteinemia, type ib",
"hyperlipoproteinemia, type iii",
"hyperlysinemia",
"hyperlysinemia  mondo:0009388",
"hypermanganesemia with dystonia 1",
"hypermanganesemia with dystonia 2",
"hypermethioninemia due to adenosine kinase deficiency",
"hypermethioninemia with deficiency of s adenosylhomocysteine hydrolase",
"hypermethioninemia with deficiency of s-adenosylhomocysteine hydrolase  mondo:0013404",
"hypermethioninemia, persistent, autosomal dominant, due to methionine adenosyltransferase i/iii deficiency",
"hyperornithinemia hyperammonemia homocitrullinemia syndrome",
"hyperostosis cranalis interna",
"hyperostosis, endosteal",
"hyperoxaluria, primary, type 1",
"hyperoxaluria, primary, type ii",
"hyperoxaluria, primary, type iii",
"hyperparathyroidism 2 with jaw tumors  mondo:0007768",
"hyperparathyroidism 4",
"hyperparathyroidism jaw tumor syndrome",
"hyperparathyroidism, familial primary",
"hyperparathyroidism, neonatal",
"hyperparathyroidism, transient neonatal",
"hyperphenylalaninemia due to dnajc12 deficiency  mondo:0044304",
"hyperphenylalaninemia, bh4 deficient, a",
"hyperphenylalaninemia, bh4 deficient, b",
"hyperphenylalaninemia, bh4 deficient, c",
"hyperphenylalaninemia, bh4 deficient, d",
"hyperphenylalaninemia, mild, non bh4 deficient",
"hyperphenylalaninemia, non pku mild",
"hyperphosphatasia with intellectual disability syndrome 4  mondo:0014318",
"hyperphosphatasia with mental retardation syndrome 1",
"hyperphosphatasia with mental retardation syndrome 2",
"hyperphosphatasia with mental retardation syndrome 3",
"hyperphosphatasia with mental retardation syndrome 4",
"hyperphosphatasia with mental retardation syndrome 6",
"hyperpigmentation with or without hypopigmentation",
"hyperproinsulinemia",
"hyperprolactinemia",
"hyperprolinemia type 1  mondo:0009400",
"hyperprolinemia type 2  mondo:0009401",
"hyperprolinemia, type i",
"hyperprolinemia, type ii",
"hyperproreninemia",
"hypersensitivity syndrome, carbamazepine induced, susceptibility to",
"hypertelorism, teebi type",
"hypertension and brachydactyly syndrome",
"hypertension, diastolic, resistance to",
"hypertension, early onset, autosomal dominant, with exacerbation in pregnancy",
"hypertension, essential",
"hypertension, essential, salt sensitive",
"hypertension, essential, susceptibility to",
"hypertension, insulin resistance related, susceptibility to",
"hypertension, pregnancy induced",
"hypertension, salt resistant",
"hypertension, salt sensitive essential, susceptibility to",
"hypertension, susceptibility to",
"hyperthyroidism, familial gestational",
"hyperthyroidism, nonautoimmune",
"hypertrichosis, congenital generalized, with gingival hyperplasia",
"hypertrichotic osteochondrodysplasia",
"hypertriglyceridemia, susceptibility to",
"hypertriglyceridemia, transient infantile",
"hypertrophic cardiomyopathy  mondo:0005045",
"hypertrophic cardiomyopathy 10  mondo:0012112",
"hypertrophic osteoarthropathy, primary, autosomal recessive 1",
"hypertrophic osteoarthropathy, primary, autosomal recessive 2",
"hypertrypsinemia, neonatal",
"hypertryptophanemia",
"hyperuricemia, hrpt related",
"hyperuricemia, pulmonary hypertension, renal failure, and alkalosis",
"hypervalinemia and hyperleucine-isoleucinemia  mondo:0100058",
"hypervalinemia or hyperleucine isoleucinemia",
"hypoaldosteronism, congenital, due to cmo i deficiency",
"hypoaldosteronism, congenital, due to cmo ii deficiency",
"hypoalphalipoproteinemia, primary, 2, with or without corneal clouding",
"hypobetalipoproteinemia",
"hypobetalipoproteinemia, familial, 2",
"hypocalcemia, autosomal dominant",
"hypocalcemia, autosomal dominant 2",
"hypocalcemia, autosomal dominant, with bartter syndrome",
"hypocalciuric hypercalcemia, type i",
"hypocalciuric hypercalcemia, type ii",
"hypocalciuric hypercalcemia, type iii",
"hypoceruloplasminemia, hereditary",
"hypochondroplasia",
"hypochondroplasia  mondo:0007793",
"hypodysfibrinogenemia",
"hypodysfibrinogenemia, congenital",
"hypofibrinogenemia, congenital",
"hypoglycemia of infancy, leucine sensitive",
"hypogonadotropic hypogonadism 1 with or without anosmia  mondo:0010635",
"hypogonadotropic hypogonadism 1 with or without anosmia kallmann syndrome 1",
"hypogonadotropic hypogonadism 10 with or without anosmia",
"hypogonadotropic hypogonadism 11 with or without anosmia",
"hypogonadotropic hypogonadism 12 with or without anosmia",
"hypogonadotropic hypogonadism 13 with or without anosmia",
"hypogonadotropic hypogonadism 14 with or without anosmia",
"hypogonadotropic hypogonadism 15 with or without anosmia",
"hypogonadotropic hypogonadism 16 with or without anosmia",
"hypogonadotropic hypogonadism 17 with or without anosmia",
"hypogonadotropic hypogonadism 18 with or without anosmia",
"hypogonadotropic hypogonadism 19 with or without anosmia",
"hypogonadotropic hypogonadism 2 with or without anosmia",
"hypogonadotropic hypogonadism 20 with or without anosmia",
"hypogonadotropic hypogonadism 21 with anosmia",
"hypogonadotropic hypogonadism 22, with or without anosmia",
"hypogonadotropic hypogonadism 23 with or without anosmia",
"hypogonadotropic hypogonadism 24 without anosmia",
"hypogonadotropic hypogonadism 25 with anosmia",
"hypogonadotropic hypogonadism 3 with or without anosmia",
"hypogonadotropic hypogonadism 3 with or without anosmia  mondo:0009482",
"hypogonadotropic hypogonadism 4 with or without anosmia",
"hypogonadotropic hypogonadism 4 with or without anosmia  mondo:0012528",
"hypogonadotropic hypogonadism 5 with or without anosmia",
"hypogonadotropic hypogonadism 6 with or without anosmia",
"hypogonadotropic hypogonadism 7 without anosmia",
"hypogonadotropic hypogonadism 8 with or without anosmia",
"hypogonadotropic hypogonadism 9 with or without anosmia",
"hypohaptoglobinemia",
"hypoinsulinemic hypoglycemia with hemihypertrophy",
"hypokalemic alkalosis, familial, with specific renal tubulopathy  mondo:0009423",
"hypokalemic periodic paralysis, type 1",
"hypokalemic periodic paralysis, type 2",
"hypomagnesemia 1, intestinal",
"hypomagnesemia 2, renal",
"hypomagnesemia 3, renal",
"hypomagnesemia 4, renal",
"hypomagnesemia 5, renal, with ocular involvement",
"hypomagnesemia 6, renal",
"hypomagnesemia, seizures, and intellectual disability 1  mondo:0020787",
"hypomagnesemia, seizures, and mental retardation",
"hypomagnesemia, seizures, and mental retardation 2",
"hypomyelinating leukodystrophy 13  mondo:0014813",
"hypomyelinating neuropathy, congenital, 1",
"hypomyelinating neuropathy, congenital, 2",
"hypomyelinating neuropathy, congenital, 3",
"hypomyelination with brainstem and spinal cord involvement and leg spasticity",
"hypoparathyroidism retardation dysmorphism syndrome",
"hypoparathyroidism, familial isolated 1",
"hypoparathyroidism, familial isolated 2",
"hypoparathyroidism, sensorineural deafness, and renal dysplasia",
"hypoparathyroidism-deafness-renal disease syndrome  mondo:0007797",
"hypophosphatasia, adult",
"hypophosphatasia, childhood",
"hypophosphatasia, infantile",
"hypophosphatemic rickets",
"hypophosphatemic rickets with hypercalciuria",
"hypophosphatemic rickets, ar",
"hypophosphatemic rickets, autosomal dominant",
"hypophosphatemic rickets, autosomal recessive, 2",
"hypophosphatemic rickets, x linked dominant",
"hypopigmentation, organomegaly, and delayed myelination and development",
"hypopigmentation, organomegaly, and delayed myelination and development  mondo:0032805",
"hypopigmentation-punctate palmoplantar keratoderma syndrome  mondo:0014227",
"hypoplasminogenemia  mondo:0009009",
"hypoplastic left heart syndrome 1",
"hypoplastic left heart syndrome 2",
"hypoplastic or aplastic tibia with polydactyly",
"hypoproteinemia, hypercatabolic  mondo:0009434",
"hypoprothrombinemia",
"hypospadias 1, x linked",
"hypospadias 2, x linked",
"hypotaurinemic retinal degeneration and cardiomyopathy  mondo:0007777",
"hypothyroidism, central, and testicular enlargement",
"hypothyroidism, congenital nongoitrous, 5",
"hypothyroidism, congenital, due to thyroid dysgenesis or hypoplasia",
"hypothyroidism, congenital, nongoitrous 4",
"hypothyroidism, congenital, nongoitrous, 1",
"hypothyroidism, congenital, nongoitrous, 6",
"hypothyroidism, congenital, nongoitrous, 7",
"hypothyroidism, congenital, nongoitrous, 8",
"hypothyroidism, congenital, nongoitrous, 9",
"hypotonia, ataxia, and delayed development syndrome",
"hypotonia, ataxia, and delayed development syndrome  mondo:0015021",
"hypotonia, ataxia, developmental delay, and tooth enamel defect syndrome",
"hypotonia, hypoventilation, impaired intellectual development, dysautonomia, epilepsy, and eye abnormalities",
"hypotonia, infantile, with psychomotor retardation",
"hypotonia, infantile, with psychomotor retardation and characteristic facies 1",
"hypotonia, infantile, with psychomotor retardation and characteristic facies 2",
"hypotonia, infantile, with psychomotor retardation and characteristic facies 2  mondo:0014777",
"hypotonia, infantile, with psychomotor retardation and characteristic facies 3",
"hypotrichosis 1",
"hypotrichosis 11",
"hypotrichosis 12",
"hypotrichosis 13",
"hypotrichosis 14",
"hypotrichosis 2",
"hypotrichosis 3",
"hypotrichosis 4",
"hypotrichosis 5",
"hypotrichosis 6",
"hypotrichosis 7",
"hypotrichosis 8",
"hypotrichosis and recurrent skin vesicles",
"hypotrichosis lymphedema telangiectasia renal defect syndrome",
"hypotrichosis lymphedema telangiectasia syndrome",
"hypotrichosis, congenital, with juvenile macular dystrophy",
"hypouricemia, renal",
"hypouricemia, renal, 2",
"hystrix like ichthyosis with deafness",
"ichthyosiform erythroderma, corneal involvement, and hearing loss  mondo:0009440",
"ichthyosis bullosa of siemens",
"ichthyosis histrix, curth macklin type",
"ichthyosis prematurity syndrome",
"ichthyosis vulgaris",
"ichthyosis with confetti",
"ichthyosis, congenital, autosomal recessive 1",
"ichthyosis, congenital, autosomal recessive 10",
"ichthyosis, congenital, autosomal recessive 11",
"ichthyosis, congenital, autosomal recessive 12",
"ichthyosis, congenital, autosomal recessive 13",
"ichthyosis, congenital, autosomal recessive 14",
"ichthyosis, congenital, autosomal recessive 2",
"ichthyosis, congenital, autosomal recessive 3",
"ichthyosis, congenital, autosomal recessive 4a",
"ichthyosis, congenital, autosomal recessive 4b harlequin",
"ichthyosis, congenital, autosomal recessive 5",
"ichthyosis, congenital, autosomal recessive 6",
"ichthyosis, congenital, autosomal recessive 8",
"ichthyosis, congenital, autosomal recessive 9",
"ichthyosis, cyclic, with epidermolytic hyperkeratosis",
"ichthyosis, follicular, with atrichia and photophobia syndrome 2",
"ichthyosis, lamellar, autosomal dominant",
"ichthyosis, leukocyte vacuoles, alopecia, and sclerosing cholangitis",
"ichthyosis, spastic quadriplegia, and mental retardation",
"ichthyosis, x linked",
"ichthyotic keratoderma, spasticity, hypomyelination, and dysmorphic facies",
"idh3b-related retinopathy  mondo:0800393",
"ifap syndrome 1, with or without bresheck syndrome  mondo:0100213",
"ifap syndrome with or without bresheck syndrome",
"ifih1-related type 1 interferonopathy  mondo:0700262",
"ift140-related recessive ciliopathy  mondo:0100509",
"iga nephropathy, susceptibility to, 3",
"ige, elevated level of",
"igg receptor i, phagocytic, familial deficiency of",
"ikbkg-related immunodeficiency with or without ectodermal dysplasia  mondo:0100162",
"imagawa matsumoto syndrome",
"image i syndrome",
"image syndrome",
"imerslund grasbeck syndrome 1",
"imerslund grasbeck syndrome 2",
"iminoglycinuria  mondo:0009448",
"iminoglycinuria, digenic",
"immune dysregulation and systemic hyperinflammation syndrome",
"immune dysregulation-polyendocrinopathy-enteropathy-x-linked syndrome  mondo:0010580",
"immunodeficiency 10",
"immunodeficiency 104  mondo:0012163",
"immunodeficiency 11a",
"immunodeficiency 11b with atopic dermatitis",
"immunodeficiency 11b with atopic dermatitis  mondo:0054697",
"immunodeficiency 12",
"immunodeficiency 14",
"immunodeficiency 14  mondo:0014222",
"immunodeficiency 14b, autosomal recessive  mondo:0023655",
"immunodeficiency 15a",
"immunodeficiency 15b",
"immunodeficiency 16",
"immunodeficiency 17, cd3 gamma deficient",
"immunodeficiency 18",
"immunodeficiency 18  mondo:0014278",
"immunodeficiency 18, scid variant",
"immunodeficiency 19",
"immunodeficiency 19  mondo:0014280",
"immunodeficiency 20",
"immunodeficiency 21",
"immunodeficiency 22",
"immunodeficiency 23",
"immunodeficiency 24",
"immunodeficiency 25",
"immunodeficiency 25  mondo:0012426",
"immunodeficiency 26, with or without neurologic abnormalities",
"immunodeficiency 27a, mycobacteriosis, ar",
"immunodeficiency 27b, mycobacteriosis, ad",
"immunodeficiency 28, mycobacteriosis",
"immunodeficiency 29, mycobacteriosis",
"immunodeficiency 30",
"immunodeficiency 31a, mycobacteriosis, autosomal dominant",
"immunodeficiency 31b  mondo:0013427",
"immunodeficiency 31b, mycobacterial and viral infections, autosomal recessive",
"immunodeficiency 31c, chronic mucocutaneous candidiasis, autosomal dominant",
"immunodeficiency 32a, mycobacteriosis, autosomal dominant",
"immunodeficiency 32b, monocyte and dendritic cell deficiency, autosomal recessive",
"immunodeficiency 33",
"immunodeficiency 34, mycobacteriosis, x linked",
"immunodeficiency 35",
"immunodeficiency 36",
"immunodeficiency 36  mondo:0014453",
"immunodeficiency 37",
"immunodeficiency 37  mondo:0014491",
"immunodeficiency 38",
"immunodeficiency 39",
"immunodeficiency 40",
"immunodeficiency 41 with lymphoproliferation and autoimmunity",
"immunodeficiency 42",
"immunodeficiency 43",
"immunodeficiency 44",
"immunodeficiency 45",
"immunodeficiency 46",
"immunodeficiency 47",
"immunodeficiency 48",
"immunodeficiency 49",
"immunodeficiency 50",
"immunodeficiency 51",
"immunodeficiency 52",
"immunodeficiency 53",
"immunodeficiency 53  mondo:0054696",
"immunodeficiency 54",
"immunodeficiency 55",
"immunodeficiency 56",
"immunodeficiency 57 with autoinflammation",
"immunodeficiency 58",
"immunodeficiency 59 and hypoglycemia",
"immunodeficiency 60",
"immunodeficiency 60  mondo:0032723",
"immunodeficiency 61",
"immunodeficiency 61  mondo:0010296",
"immunodeficiency 62",
"immunodeficiency 62  mondo:0032763",
"immunodeficiency 63 with lymphoproliferation and autoimmunity",
"immunodeficiency 63 with lymphoproliferation and autoimmunity  mondo:0032782",
"immunodeficiency 64",
"immunodeficiency 65, susceptibility to viral infections",
"immunodeficiency 66",
"immunodeficiency 67",
"immunodeficiency 68",
"immunodeficiency 69, mycobacteriosis",
"immunodeficiency 70",
"immunodeficiency 71 with inflammatory disease and congenital thrombocytopenia",
"immunodeficiency 72 with autoinflammation",
"immunodeficiency 73a with defective neutrophil chemotaxix and leukocytosis",
"immunodeficiency 73b with defective neutrophil chemotaxis and lymphopenia",
"immunodeficiency 73b with defective neutrophil chemotaxis and lymphopenia  mondo:0033554",
"immunodeficiency 73c with defective neutrophil chemotaxis and hypogammaglobulinemia",
"immunodeficiency 73c with defective neutrophil chemotaxis and hypogammaglobulinemia  mondo:0033555",
"immunodeficiency 74, covid19 related, x linked",
"immunodeficiency 75",
"immunodeficiency 76",
"immunodeficiency 76  mondo:0030898",
"immunodeficiency 77",
"immunodeficiency 78 with autoimmunity and developmental delay",
"immunodeficiency 79",
"immunodeficiency 8",
"immunodeficiency 80 with or without congenital cardiomyopathy  mondo:0030266",
"immunodeficiency 81  mondo:0030302",
"immunodeficiency 84  mondo:0030333",
"immunodeficiency 9",
"immunodeficiency 92  mondo:0030498",
"immunodeficiency 97 with autoinflammation  mondo:0030717",
"immunodeficiency centromeric instability facial anomalies syndrome 1",
"immunodeficiency centromeric instability facial anomalies syndrome 2",
"immunodeficiency centromeric instability facial anomalies syndrome 3",
"immunodeficiency centromeric instability facial anomalies syndrome 4",
"immunodeficiency disease  mondo:0021094",
"immunodeficiency due to ficolin 3 deficiency",
"immunodeficiency due to purine nucleoside phosphorylase deficiency",
"immunodeficiency with hyper igm, type 2",
"immunodeficiency with hyper igm, type 3",
"immunodeficiency with hyper igm, type 5",
"immunodeficiency, common variable, 1",
"immunodeficiency, common variable, 1  mondo:0011864",
"immunodeficiency, common variable, 10",
"immunodeficiency, common variable, 10  mondo:0014260",
"immunodeficiency, common variable, 11",
"immunodeficiency, common variable, 12",
"immunodeficiency, common variable, 12  mondo:0014697",
"immunodeficiency, common variable, 13",
"immunodeficiency, common variable, 14",
"immunodeficiency, common variable, 14  mondo:0054691",
"immunodeficiency, common variable, 2",
"immunodeficiency, common variable, 2  mondo:0009413",
"immunodeficiency, common variable, 3",
"immunodeficiency, common variable, 3  mondo:0013283",
"immunodeficiency, common variable, 4",
"immunodeficiency, common variable, 4  mondo:0013284",
"immunodeficiency, common variable, 5",
"immunodeficiency, common variable, 5  mondo:0013285",
"immunodeficiency, common variable, 6",
"immunodeficiency, common variable, 6  mondo:0013286",
"immunodeficiency, common variable, 7",
"immunodeficiency, common variable, 7  mondo:0013862",
"immunodeficiency, common variable, 8, with autoimmunity",
"immunodeficiency, developmental delay, and hypohomocysteinemia",
"immunodeficiency, x linked, with hyper igm",
"immunodeficiency, x linked, with magnesium defect, epstein barr virus infection and neoplasia",
"immunodeficiency-centromeric instability-facial anomalies syndrome 1  mondo:0009454",
"immunodeficiency-centromeric instability-facial anomalies syndrome 3  mondo:0014828",
"immunodeficiency-centromeric instability-facial anomalies syndrome 4  mondo:0014829",
"immunodysregulation, polyendocrinopathy, and enteropathy, x linked",
"immunoglobulin a deficiency 2",
"immunoskeletal dysplasia with neurodevelopmental abnormalities",
"impdh2 enzyme activity, variation in",
"inborn disorder of cobalamin metabolism and transport  mondo:0019220",
"inborn glycerol kinase deficiency  mondo:0010613",
"inclusion body myopathy with early onset paget disease and frontotemporal dementia 1",
"inclusion body myopathy with early onset paget disease with or without frontotemporal dementia 2",
"inclusion body myopathy with early onset paget disease without frontotemporal dementia 3",
"inclusion body myopathy with early-onset paget disease with or without frontotemporal dementia 2  mondo:0014178",
"inclusion body myopathy with paget disease of bone and frontotemporal dementia  mondo:0000507",
"incontinentia pigmenti",
"incontinentia pigmenti  mondo:0010631",
"increased responsiveness to growth hormone",
"infantile cataract, skin abnormalities, glutamate excess, and impaired intellectual development",
"infantile cataract, skin abnormalities, glutamate excess, and impaired intellectual development  mondo:0032685",
"infantile cerebellar retinal degeneration",
"infantile convulsions and choreoathetosis  mondo:0011178",
"infantile hypophosphatasia  obsolete termmondo:0009427",
"infantile liver failure syndrome 1",
"infantile liver failure syndrome 2",
"infantile liver failure syndrome 3",
"infantile neuroaxonal dystrophy 1",
"infantile onset multisystem neurologic, endocrine, and pancreatic disease",
"infantile-onset epilepsy  mondo:0100207",
"infections, recurrent, with encephalopathy, hepatic dysfunction, and cardiovascular malformations",
"inflammatory bowel disease 1, crohn disease",
"inflammatory bowel disease 13",
"inflammatory bowel disease 14",
"inflammatory bowel disease 17, protection against",
"inflammatory bowel disease 25, early onset, autosomal recessive",
"inflammatory bowel disease 28, early onset, autosomal recessive",
"inflammatory bowel disease 29",
"inflammatory bowel disease crohn disease 10",
"inflammatory bowel disease crohn disease 19",
"inflammatory bowel disease crohn disease 30",
"inflammatory bowel disease, immunodeficiency, and encephalopathy",
"inflammatory bowel disease, immunodeficiency, and encephalopathy  mondo:0032601",
"inflammatory poikiloderma with hair abnormalities and acral keratoses",
"inflammatory skin and bowel disease, neonatal, 1",
"inflammatory skin and bowel disease, neonatal, 2",
"influenza, severe, susceptibility to",
"inherited blood coagulation disorder  mondo:0021181",
"inherited focal segmental glomerulosclerosis  mondo:0005363",
"inherited glutathione synthetase deficiency  mondo:0017909",
"inherited neurodegenerative disorder  mondo:0024237",
"inherited prekallikrein deficiency  mondo:0012901",
"inherited retinal dystrophy  mondo:0019118",
"inosine triphosphatase deficiency",
"insensitivity to pain, congenital",
"insensitivity to pain, congenital, with anhidrosis",
"insomnia, fatal familial",
"insulin like growth factor i, resistance to",
"insulin resistance, severe, digenic",
"insulin resistance, susceptibility to",
"insulinomatosis and diabetes mellitus",
"intellectual developmental disorder 59  mondo:0032795",
"intellectual developmental disorder 60 with seizures",
"intellectual developmental disorder 61",
"intellectual developmental disorder 62",
"intellectual developmental disorder and retinitis pigmentosa",
"intellectual developmental disorder with abnormal behavior, microcephaly, and short stature",
"intellectual developmental disorder with autism and speech delay",
"intellectual developmental disorder with autistic features and language delay, with or without seizures",
"intellectual developmental disorder with autistic features and language delay, with or without seizures  mondo:0030051",
"intellectual developmental disorder with behavioral abnormalities and craniofacial dysmorphism with or without seizures",
"intellectual developmental disorder with cardiac arrhythmia",
"intellectual developmental disorder with cardiac defects and dysmorphic facies",
"intellectual developmental disorder with cardiac defects and dysmorphic facies  mondo:0032672",
"intellectual developmental disorder with dysmorphic facies and behavioral abnormalities",
"intellectual developmental disorder with dysmorphic facies and ptosis",
"intellectual developmental disorder with dysmorphic facies, seizures, and distal limb anomalies",
"intellectual developmental disorder with dysmorphic facies, speech delay, and t cell abnormalities",
"intellectual developmental disorder with epilepsy, behavioral abnormalities, and coarse facies",
"intellectual developmental disorder with hypertelorism and distinctive facies",
"intellectual developmental disorder with hypotonia and behavioral abnormalities",
"intellectual developmental disorder with impaired language and dysmorphic facies",
"intellectual developmental disorder with macrocephaly, seizures, and speech delay",
"intellectual developmental disorder with nasal speech, dysmorphic facies, and variable skeletal anomalies",
"intellectual developmental disorder with neuropsychiatric features",
"intellectual developmental disorder with or without epilepsy or cerebellar ataxia",
"intellectual developmental disorder with paroxysmal dyskinesia or seizures",
"intellectual developmental disorder with poor growth and with or without seizures or ataxia",
"intellectual developmental disorder with seizures and language delay",
"intellectual developmental disorder with severe speech and ambulation defects",
"intellectual developmental disorder with short stature and behavioral abnormalities",
"intellectual developmental disorder with short stature and variable skeletal anomalies",
"intellectual developmental disorder with short stature, facial anomalies, and speech defects",
"intellectual developmental disorder with speech delay and axonal peripheral neuropathy",
"intellectual developmental disorder with speech delay and axonal peripheral neuropathy  mondo:0030849",
"intellectual developmental disorder with speech delay, autism, and dysmorphic facies",
"intellectual developmental disorder, autosomal dominant 44, with microcephaly",
"intellectual developmental disorder, autosomal dominant 6, with or without seizures",
"intellectual developmental disorder, autosomal dominant 63, with macrocephaly",
"intellectual developmental disorder, autosomal dominant 64",
"intellectual developmental disorder, autosomal recessive 12",
"intellectual developmental disorder, autosomal recessive 69",
"intellectual developmental disorder, autosomal recessive 70",
"intellectual developmental disorder, autosomal recessive 71",
"intellectual developmental disorder, autosomal recessive 72",
"intellectual developmental disorder, autosomal recessive 75, with neuropsychiatric features and variant lissencephaly  mondo:0030785",
"intellectual developmental disorder, x linked 108",
"intellectual developmental disorder, x linked 109",
"intellectual developmental disorder, x linked 50",
"intellectual developmental disorder, x linked, syndrome, snijders blok type",
"intellectual developmental disorder, x linked, syndromic, armfield type",
"intellectual developmental disorder, x linked, syndromic, hackman di donato type",
"intellectual developmental disorder, x linked, syndromic, wu type",
"intellectual disability  mondo:0001071",
"intellectual disability, x-linked 106  mondo:0030907",
"intellectual disability-microcephaly-strabismus-behavioral abnormalities syndrome  mondo:0014606",
"intellectual disability-obesity-brain malformations-facial dysmorphism syndrome  mondo:0018123",
"intellectual disability-severe speech delay-mild dysmorphism syndrome  mondo:0013352",
"intellectual disability-sparse hair-brachydactyly syndrome  mondo:0011053",
"interferon, alpha, deficiency",
"interleukin 1 receptor antagonist deficiency",
"interleukin 6 receptor, soluble, serum level of, qtl",
"interleukin 6, serum level of, qtl",
"interstitial lung and liver disease",
"interstitial lung disease 2  mondo:0800029",
"interstitial lung disease, nephrotic syndrome, and epidermolysis bullosa, congenital",
"interstitial nephritis, karyomegalic",
"intervertebral disc disease, susceptibility to",
"intestinal polyposis syndrome  mondo:0015185",
"intestinal pseudoobstruction, neuronal",
"intracranial hemorrhage in brain cerebrovascular malformations, susceptibility to",
"intrinsic cardiomyopathy  mondo:0000591",
"intrinsic factor deficiency",
"iron refractory iron deficiency anemia",
"ischemic stroke, susceptibility to",
"ischiocoxopodopatellar syndrome with or without pulmonary arterial hypertension",
"isobutyryl coa dehydrogenase deficiency",
"isobutyryl-coa dehydrogenase deficiency  mondo:0012648",
"isolated growth hormone deficiency due to defect in ghrf",
"isolated growth hormone deficiency type iii  mondo:0010615",
"isolated growth hormone deficiency, type iii, with agammaglobulinemia",
"isolated pierre-robin syndrome  mondo:0009869",
"isolated sulfite oxidase deficiency  mondo:0010089",
"isovaleric acidemia",
"isovaleric acidemia  mondo:0009475",
"itpkb deficiency  mondo:0800140",
"ivic syndrome",
"jaberi elahi syndrome",
"jaberi-elahi syndrome  mondo:0060711",
"jackson weiss syndrome",
"jalili syndrome",
"jalili syndrome  mondo:0009007",
"jansen de vries syndrome",
"jawad syndrome",
"jervell and lange nielsen syndrome",
"jervell and lange nielsen syndrome 2",
"jervell and lange-nielsen syndrome  mondo:0002441",
"johanson blizzard syndrome",
"joint laxity, short stature, and myopia",
"joubert syndrome  mondo:0018772",
"joubert syndrome 1",
"joubert syndrome 1  mondo:0008944",
"joubert syndrome 10",
"joubert syndrome 12",
"joubert syndrome 13",
"joubert syndrome 14",
"joubert syndrome 14  mondo:0013745",
"joubert syndrome 15",
"joubert syndrome 16",
"joubert syndrome 17",
"joubert syndrome 17  mondo:0013824",
"joubert syndrome 18",
"joubert syndrome 19",
"joubert syndrome 2",
"joubert syndrome 20",
"joubert syndrome 21",
"joubert syndrome 21  mondo:0014288",
"joubert syndrome 22",
"joubert syndrome 23",
"joubert syndrome 24",
"joubert syndrome 24  mondo:0014724",
"joubert syndrome 25",
"joubert syndrome 26",
"joubert syndrome 27",
"joubert syndrome 28",
"joubert syndrome 29",
"joubert syndrome 3",
"joubert syndrome 3  mondo:0012078",
"joubert syndrome 30",
"joubert syndrome 30  mondo:0033308",
"joubert syndrome 31",
"joubert syndrome 32",
"joubert syndrome 33",
"joubert syndrome 34",
"joubert syndrome 35",
"joubert syndrome 36",
"joubert syndrome 37",
"joubert syndrome 4",
"joubert syndrome 5",
"joubert syndrome 6",
"joubert syndrome 7",
"joubert syndrome 8",
"joubert syndrome 9",
"juberg hayward syndrome",
"junior blood group system",
"juvenile arthritis",
"juvenile myelomonocytic leukemia",
"juvenile polyposis syndrome  mondo:0017380",
"juvenile polyposis/hereditary hemorrhagic telangiectasia syndrome",
"juvenile polyposis/hereditary hemorrhagic telangiectasia syndrome  mondo:0008278",
"kabuki syndrome 1",
"kabuki syndrome 1  mondo:0007843",
"kabuki syndrome 2",
"kabuki syndrome 2  mondo:0010465",
"kahrizi syndrome",
"kallikrein, decreased urinary activity of",
"kanzaki disease",
"kaposi sarcoma, susceptibility to",
"kat6b-related multiple congenital anomalies syndrome  mondo:0036042",
"kaufman oculocerebrofacial syndrome",
"kaya barakat masson syndrome",
"kaya-barakat-masson syndrome  mondo:0030878",
"kbg syndrome",
"kbg syndrome  mondo:0007846",
"kcnh1 associated disorder  mondo:0100485",
"keipert syndrome",
"kennedy disease  mondo:0010735",
"kenny caffey syndrome, type 1",
"kenny caffey syndrome, type 2",
"keppen lubinsky syndrome",
"keratitis",
"keratitis ichthyosis deafness syndrome",
"keratitis ichthyosis deafness syndrome, autosomal recessive",
"keratoconus 1",
"keratoconus 9",
"keratoderma, palmoplantar, punctate type ia",
"keratoderma, palmoplantar, with deafness",
"keratoendothelitis fugax hereditaria",
"keratolytic winter erythema",
"keratosis follicularis spinulosa decalvans, x linked",
"keratosis linearis with ichthyosis congenita and sclerosing keratoderma",
"keratosis palmoplantaris striata i, ad",
"keratosis palmoplantaris striata ii",
"keratosis palmoplantaris striata iii",
"keratosis pilaris atrophicans",
"keratosis, seborrheic, somatic",
"keutel syndrome",
"khan khan katsanis syndrome",
"khan-khan-katsanis syndrome  mondo:0032764",
"kidney disorder  mondo:0005240",
"kilquist syndrome",
"kindler syndrome",
"king denborough syndrome",
"kininogen deficiency",
"kleefstra syndrome  mondo:0012455",
"kleefstra syndrome 1",
"kleefstra syndrome 2",
"klippel feil syndrome 1, autosomal dominant",
"klippel feil syndrome 2",
"klippel feil syndrome 3, autosomal dominant",
"klippel feil syndrome 4, autosomal recessive, with myopathy and facial dysmorphism",
"klippel-feil anomaly-myopathy-facial dysmorphism syndrome  mondo:0014689",
"kniest dysplasia",
"kniest dysplasia  mondo:0007987",
"knobloch syndrome 1  mondo:0800167",
"knobloch syndrome, type 1",
"kohlschutter tonz syndrome",
"kohlschutter tonz syndrome like",
"koolen de vries syndrome",
"koolen-de vries syndrome  mondo:0012496",
"kosaki overgrowth syndrome",
"kowarski syndrome",
"krabbe disease",
"krabbe disease  mondo:0009499",
"krabbe disease due to saposin a deficiency  mondo:0012720",
"krabbe disease, atypical",
"kufor rakeb syndrome",
"kufor-rakeb syndrome  mondo:0011706",
"kuru, susceptibility to",
"l 2 hydroxyglutaric aciduria",
"l ferritin deficiency, dominant and recessive",
"l1 syndrome  mondo:0017140",
"lacrimal duct defect",
"lactase deficiency, congenital",
"lactase persistence/nonpersistence",
"lactate dehydrogenase b deficiency",
"lacticacidemia due to pdx1 deficiency",
"ladd syndrome",
"lafora disease  mondo:0009697",
"laing distal myopathy",
"lama2-related muscular dystrophy  mondo:0100228",
"lamb shaffer syndrome",
"lamb-shaffer syndrome  mondo:0014778",
"langer mesomelic dysplasia",
"language delay and adhd/cognitive impairment with or without cardiac arrhythmia",
"laron dwarfism",
"larsen syndrome",
"laryngoonychocutaneous syndrome",
"lateral meningocele syndrome",
"lathosterolosis",
"laurence moon syndrome",
"laurin sandrow syndrome",
"lca5-related retinopathy  mondo:0100445",
"lchad deficiency",
"ldl cholesterol level qtl2",
"lead poisoning, susceptibility to",
"leanness, inherited",
"leber congenital amaurosis 1",
"leber congenital amaurosis 10",
"leber congenital amaurosis 11",
"leber congenital amaurosis 12",
"leber congenital amaurosis 13",
"leber congenital amaurosis 14",
"leber congenital amaurosis 15",
"leber congenital amaurosis 16",
"leber congenital amaurosis 17",
"leber congenital amaurosis 18",
"leber congenital amaurosis 19",
"leber congenital amaurosis 2",
"leber congenital amaurosis 3",
"leber congenital amaurosis 4",
"leber congenital amaurosis 5",
"leber congenital amaurosis 6",
"leber congenital amaurosis 7",
"leber congenital amaurosis 8",
"leber congenital amaurosis 9",
"leber congenital amaurosis with early onset deafness",
"leber congenital amaurosis with early-onset deafness  mondo:0060650",
"leber hereditary optic neuropathy, modifier of",
"left ventricular noncompaction 1, with or without congenital heart defects",
"left ventricular noncompaction 10",
"left ventricular noncompaction 3",
"left ventricular noncompaction 4",
"left ventricular noncompaction 5",
"left ventricular noncompaction 6",
"left ventricular noncompaction 7",
"left ventricular noncompaction 8",
"left ventricular noncompaction 9",
"legg calve perthes disease",
"legionnaire disease, susceptibility to",
"legius syndrome",
"legius syndrome  mondo:0012669",
"leigh syndrome  mondo:0009723",
"leiomyomatosis and renal cell cancer",
"lenz majewski hyperostotic dwarfism",
"leopard syndrome 1",
"leopard syndrome 2",
"leopard syndrome 3",
"leprechaunism",
"leprosy, protection against",
"leprosy, susceptibility to",
"leprosy, susceptibility to, 4",
"leprosy, susceptibility to, 5",
"leri weill dyschondrosteosis",
"lesch nyhan syndrome",
"lesch-nyhan syndrome  mondo:0010298",
"lessel kreienkamp syndrome",
"lessel kubisch syndrome",
"lessel-kreienkamp syndrome  mondo:0030897",
"lethal congenital contractural syndrome 2",
"lethal congenital contractural syndrome 3",
"lethal congenital contracture syndrome 1",
"lethal congenital contracture syndrome 10",
"lethal congenital contracture syndrome 11",
"lethal congenital contracture syndrome 4",
"lethal congenital contracture syndrome 5",
"lethal congenital contracture syndrome 6",
"lethal congenital contracture syndrome 7",
"lethal congenital contracture syndrome 8",
"lethal congenital contracture syndrome 9",
"lethal restrictive dermopathy  obsolete termmondo:0010143",
"leukemia, acute lymphoblastic",
"leukemia, acute lymphoblastic, somatic",
"leukemia, acute lymphoblastic, susceptibility to, 3",
"leukemia, acute lymphocytic, philadelphia chromosome positive, somatic",
"leukemia, acute myeloid",
"leukemia, acute myeloid, reduced survival in, somatic",
"leukemia, acute myeloid, somatic",
"leukemia, acute myeloid, susceptibility to",
"leukemia, acute nonlymphocytic",
"leukemia, acute promyelocytic",
"leukemia, acute promyelocytic, pl2f/rara type",
"leukemia, acute promyelocytic, pml/rara type",
"leukemia, acute promyelocytic, somatic",
"leukemia, acute t cell",
"leukemia, chronic myeloid, philadelphia chromosome positive, somatic",
"leukemia, juvenile myelomonocytic",
"leukemia, juvenile myelomonocytic, somatic",
"leukemia, megakaryoblastic, with or without down syndrome, somatic",
"leukemia, philadelphia chromosome positive, resistant to imatinib",
"leukemia, post chemotherapy, susceptibility to",
"leukemia, t cell acute lymphoblastic",
"leukemia, t cell acute lymphoblastic, somatic",
"leukemia, t cell acute lymphoblastoid",
"leukemia, t cell acute lymphocytic, somatic",
"leukemia/lymphoma, b cell, 2",
"leukemia/lymphoma, b cell, 3",
"leukemia/lymphoma, t cell",
"leukocyte adhesion deficiency",
"leukocyte adhesion deficiency 3  mondo:0013016",
"leukocyte adhesion deficiency, type iii",
"leukodystrophy and acquired microcephaly with or without dystonia",
"leukodystrophy, adult onset, autosomal dominant",
"leukodystrophy, hypomyelinating, 10",
"leukodystrophy, hypomyelinating, 11",
"leukodystrophy, hypomyelinating, 12",
"leukodystrophy, hypomyelinating, 13",
"leukodystrophy, hypomyelinating, 14",
"leukodystrophy, hypomyelinating, 15",
"leukodystrophy, hypomyelinating, 16",
"leukodystrophy, hypomyelinating, 17",
"leukodystrophy, hypomyelinating, 18",
"leukodystrophy, hypomyelinating, 18  mondo:0032730",
"leukodystrophy, hypomyelinating, 19, transient infantile",
"leukodystrophy, hypomyelinating, 2",
"leukodystrophy, hypomyelinating, 20",
"leukodystrophy, hypomyelinating, 3",
"leukodystrophy, hypomyelinating, 4",
"leukodystrophy, hypomyelinating, 6",
"leukodystrophy, hypomyelinating, 7, with or without oligodontia and/or hypogonadotropic hypogonadism",
"leukodystrophy, hypomyelinating, 8, with or without oligodontia and/or hypogonadotropic hypogonadism",
"leukodystrophy, hypomyelinating, 9",
"leukodystrophy, progressive, early childhood onset",
"leukoencephalopathy with ataxia",
"leukoencephalopathy with brain stem and spinal cord involvement and lactate elevation",
"leukoencephalopathy with dystonia and motor neuropathy",
"leukoencephalopathy with vanishing white matter",
"leukoencephalopathy with vanishing white matter 2  mondo:0957870",
"leukoencephalopathy with vanishing white matter 3  mondo:0957871",
"leukoencephalopathy with vanishing white matter 5  mondo:0957873",
"leukoencephalopathy, acute reversible, with increased urinary alpha ketoglutarate",
"leukoencephalopathy, brain calcifications, and cysts",
"leukoencephalopathy, cystic, without megalencephaly",
"leukoencephalopathy, developmental delay, and episodic neurologic regression syndrome",
"leukoencephalopathy, diffuse hereditary, with spheroids",
"leukoencephalopathy, motor delay, spasticity, and dysarthria syndrome",
"leukoencephalopathy, progressive, infantile onset, with or without deafness",
"leukoencephalopathy, progressive, with ovarian failure",
"leukotriene c4 synthase deficiency",
"leydig cell adenoma, somatic, with precocious puberty",
"leydig cell hypoplasia with hypergonadotropic hypogonadism",
"leydig cell hypoplasia with pseudohermaphroditism",
"lhermitte duclos syndrome",
"li campeau syndrome",
"li fraumeni syndrome",
"li ghorgani weisz hubshman syndrome",
"li-fraumeni syndrome  mondo:0018875",
"liang wang syndrome",
"liberfarb syndrome",
"lichtenstein knorr syndrome",
"liddle syndrome  mondo:0008323",
"liddle syndrome 1",
"liddle syndrome 2",
"liddle syndrome 3",
"liebenberg syndrome",
"lig4 syndrome",
"limb mammary syndrome",
"linear skin defects with multiple congenital anomalies 1",
"linear skin defects with multiple congenital anomalies 2",
"linear skin defects with multiple congenital anomalies 3",
"lipase deficiency, combined",
"lipid storage myopathy due to flavin adenine dinucleotide synthetase deficiency",
"lipodystrophy  mondo:0006573",
"lipodystrophy, congenital generalized, type 1",
"lipodystrophy, congenital generalized, type 2",
"lipodystrophy, congenital generalized, type 3",
"lipodystrophy, congenital generalized, type 4",
"lipodystrophy, familial partial, type 2",
"lipodystrophy, familial partial, type 3",
"lipodystrophy, familial partial, type 4",
"lipodystrophy, familial partial, type 5",
"lipodystrophy, familial partial, type 6",
"lipodystrophy, familial partial, type 7",
"lipodystrophy, partial, acquired, susceptibility to",
"lipoid adrenal hyperplasia",
"lipoma",
"lipoma, somatic",
"lipoprotein glomerulopathy",
"lipoprotein lipase deficiency",
"lipoyltransferase 1 deficiency",
"lissencephaly 1",
"lissencephaly 10",
"lissencephaly 2 norman roberts type",
"lissencephaly 3",
"lissencephaly 4 with microcephaly",
"lissencephaly 5",
"lissencephaly 6, with microcephaly",
"lissencephaly 7 with cerebellar hypoplasia",
"lissencephaly 8",
"lissencephaly 9 with complex brainstem malformation",
"lissencephaly spectrum disorder with complex brainstem malformation  mondo:0100472",
"lissencephaly spectrum disorders  mondo:0018838",
"lissencephaly with cerebellar hypoplasia  mondo:0019450",
"lissencephaly, x linked",
"lissencephaly, x linked 2",
"liver failure, transient infantile",
"loeys dietz syndrome 1",
"loeys dietz syndrome 2",
"loeys dietz syndrome 3",
"loeys dietz syndrome 4",
"loeys dietz syndrome 5",
"loeys-dietz syndrome  mondo:0018954",
"loeys-dietz syndrome 2  mondo:0012427",
"long chain 3-hydroxyacyl-coa dehydrogenase deficiency  mondo:0012173",
"long chain acyl-coa dehydrogenase deficiency  mondo:0020531",
"long qt syndrome  mondo:0002442",
"long qt syndrome 1",
"long qt syndrome 1, acquired, susceptibility to",
"long qt syndrome 10",
"long qt syndrome 11",
"long qt syndrome 12",
"long qt syndrome 13",
"long qt syndrome 14",
"long qt syndrome 15",
"long qt syndrome 16",
"long qt syndrome 2",
"long qt syndrome 2, acquired, susceptibility to",
"long qt syndrome 3",
"long qt syndrome 4",
"long qt syndrome 5",
"long qt syndrome 5  mondo:0013372",
"long qt syndrome 6",
"long qt syndrome 8",
"long qt syndrome 9",
"long qt syndrome, acquired, reduced susceptibility to",
"lopes maciel rodan syndrome",
"low density lipoprotein cholesterol level qtl 1",
"low density lipoprotein cholesterol level qtl 7",
"low density lipoprotein cholesterol level qtl 8",
"low density lipoprotein cholesterol level qtl6",
"low renin hypertension, susceptibility to",
"lowe syndrome",
"lower urinary tract obstruction, congenital",
"lowry wood syndrome",
"lpa deficiency, congenital",
"lui jee baron syndrome",
"lujan fryns syndrome",
"lumbar disc degeneration",
"lumbar disc disease, susceptibility to",
"lumbar disc herniation, susceptibility to",
"lung cancer susceptibility 2",
"lung cancer, protection against",
"lung cancer, protection against, in smokers",
"lung cancer, resistance to",
"lung cancer, somatic",
"lung cancer, susceptibility to",
"lung disease, immunodeficiency, and chromosome breakage syndrome",
"lung disease, immunodeficiency, and chromosome breakage syndrome;  mondo:0014984",
"lupus nephritis, susceptibility to",
"luscan lumish syndrome",
"luteinizing hormone resistance, female",
"lymphangioleiomyomatosis",
"lymphangioleiomyomatosis, somatic",
"lymphatic malformation 1",
"lymphatic malformation 1  mondo:0007919",
"lymphatic malformation 3",
"lymphatic malformation 4",
"lymphatic malformation 6",
"lymphatic malformation 7",
"lymphatic malformation 8",
"lymphedema distichiasis syndrome",
"lymphedema distichiasis syndrome with renal disease and diabetes mellitus",
"lymphedema-distichiasis syndrome  mondo:0007922",
"lymphocytic leukemia, acute t cell",
"lymphoma, b cell",
"lymphoma, b cell non hodgkin, somatic",
"lymphoma, follicular, somatic",
"lymphoma, malt, somatic",
"lymphoma, mantle cell, somatic",
"lymphoma, non hodgkin",
"lymphoma, non hodgkin, somatic",
"lymphoma, somatic",
"lymphoproliferative syndrome  mondo:0016537",
"lymphoproliferative syndrome 1",
"lymphoproliferative syndrome 1  mondo:0013081",
"lymphoproliferative syndrome 2",
"lymphoproliferative syndrome 3",
"lymphoproliferative syndrome, x linked, 1",
"lymphoproliferative syndrome, x linked, 2",
"lynch syndrome  mondo:0005835",
"lysinuric protein intolerance",
"lysinuric protein intolerance  mondo:0009109",
"lysosomal acid lipase deficiency  obsolete termmondo:0010204",
"lysosomal acid phosphatase deficiency",
"lysyl hydroxylase 3 deficiency",
"machado joseph disease",
"macrocephaly, acquired, with impaired intellectual development",
"macrocephaly, alopecia, cutis laxa, and scoliosis",
"macrocephaly, dysmorphic facies, and psychomotor retardation",
"macrocephaly/autism syndrome",
"macrocephaly/megalencephaly syndrome, autosomal recessive",
"macrocytic anemia, refractory, due to 5q deletion, somatic",
"macrodactyly, somatic",
"macroglobulinemia, waldenstrom, somatic",
"macrothrombocytopenia and granulocyte inclusions with or without nephritis or sensorineural hearing loss",
"macrothrombocytopenia and granulocyte inclusions with or without nephritis or sensorineural hearing loss  mondo:0015912",
"macrothrombocytopenia, autosomal dominant, tubb1 related",
"macrothrombocytopenia, isolated  mondo:0031447",
"macrothrombocytopenia, isolated, 1, autosomal dominant  mondo:0800047",
"macrothrombocytopenia-lymphedema-developmental delay-facial dysmorphism-camptodactyly syndrome  mondo:0014757",
"macular corneal dystrophy",
"macular degeneration, age related",
"macular degeneration, age related, 1",
"macular degeneration, age related, 11",
"macular degeneration, age related, 12",
"macular degeneration, age related, 13, susceptibility to",
"macular degeneration, age related, 14, reduced risk of",
"macular degeneration, age related, 15, susceptibility to",
"macular degeneration, age related, 2",
"macular degeneration, age related, 3",
"macular degeneration, age related, 4",
"macular degeneration, age related, 6",
"macular degeneration, age related, 7",
"macular degeneration, age related, 8",
"macular degeneration, age related, 9",
"macular degeneration, age related, neovascular type",
"macular degeneration, age related, reduced risk of",
"macular degeneration, age related, susceptibility to, 5",
"macular degeneration, early onset",
"macular degeneration, x linked atrophic",
"macular dystrophy with central cone involvement",
"macular dystrophy with or without cone dysfunction",
"macular dystrophy, patterned, 1",
"macular dystrophy, patterned, 2",
"macular dystrophy, patterned, 3",
"macular dystrophy, retinal, 2",
"macular dystrophy, vitelliform, 2",
"macular dystrophy, vitelliform, 3",
"macular dystrophy, vitelliform, 4",
"macular dystrophy, vitelliform, 5",
"majeed syndrome",
"majeed syndrome  mondo:0012316",
"major affective disorder 7, susceptibility to",
"major depressive disorder and accelerated response to antidepressant drug treatment",
"major depressive disorder, response to citalopram therapy in",
"malan overgrowth syndrome  mondo:0013885",
"malaria, cerebral, reduced risk of",
"malaria, cerebral, susceptibility to",
"malaria, mild, susceptibility to",
"malaria, protection against",
"malaria, resistance to",
"malaria, severe, resistance to",
"malaria, severe, susceptibility to",
"malaria, susceptibility to",
"malaria, vivax, protection against",
"male germ cell tumor, somatic",
"male infertility due to acrosin deficiency",
"maleylacetoacetate isomerase deficiency",
"maleylacetoacetate isomerase deficiency  mondo:0060527",
"malignant fibrous histiocytoma",
"malignant hyperthermia susceptibility 1",
"malignant hyperthermia susceptibility 5",
"malignant hyperthermia, susceptibility to, 1  mondo:0007783",
"malignant hyperthermia, susceptibility to, 5",
"malignant hyperthermia, susceptibility to, 5  mondo:0011163",
"malonic aciduria  mondo:0009556",
"malonyl coa decarboxylase deficiency",
"malouf syndrome",
"man1b1-congenital disorder of glycosylation  mondo:0018349",
"man2b2 deficiency  mondo:0800141",
"mandibular hypoplasia, deafness, progeroid features, and lipodystrophy syndrome",
"mandibuloacral dysplasia",
"mandibuloacral dysplasia progeroid syndrome",
"mandibuloacral dysplasia progeroid syndrome  mondo:0030880",
"mandibuloacral dysplasia with type b lipodystrophy",
"mandibuloacral dysplasia with type b lipodystrophy  mondo:0012074",
"mandibulofacial dysostosis with alopecia",
"mandibulofacial dysostosis, guion almeida type",
"mandibulofacial dysostosis-microcephaly syndrome  mondo:0012516",
"manitoba oculotrichoanal syndrome",
"mannosidosis, alpha , types i and ii",
"mannosidosis, beta",
"maple syrup urine disease  mondo:0009563",
"maple syrup urine disease type 1a  mondo:0023691",
"maple syrup urine disease type 1b  mondo:0023692",
"maple syrup urine disease, mild variant",
"maple syrup urine disease, mild variant  mondo:0014057",
"maple syrup urine disease, type ia",
"maple syrup urine disease, type ib",
"maple syrup urine disease, type ii",
"marden walker syndrome",
"marfan lipodystrophy syndrome",
"marfan syndrome",
"marfan syndrome  mondo:0007947",
"marinesco sjogren syndrome",
"marinesco-sjogren syndrome  mondo:0009567",
"marshall smith syndrome",
"marshall syndrome",
"marshall-smith syndrome  mondo:0011244",
"marsili syndrome",
"martsolf syndrome",
"masa syndrome",
"masp2 deficiency",
"mass syndrome",
"mast syndrome",
"mastocytosis, cutaneous",
"mastocytosis, systemic, somatic",
"maternal riboflavin deficiency  mondo:0014013",
"maturity onset diabetes of the young 6",
"maturity onset diabetes of the young, type 10",
"maturity onset diabetes of the young, type 11",
"maturity onset diabetes of the young, type 13",
"maturity onset diabetes of the young, type 14",
"maturity onset diabetes of the young, type ix",
"maturity onset diabetes of the young, type vii",
"maturity onset diabetes of the young, type viii",
"maturity-onset diabetes of the young type 8  mondo:0012348",
"mcardle disease",
"mccune albright syndrome, somatic, mosaic",
"mckusick kaufman syndrome",
"mcleod syndrome with or without chronic granulomatous disease",
"meacham syndrome",
"meckel syndrome 1",
"meckel syndrome 10",
"meckel syndrome 11",
"meckel syndrome 12",
"meckel syndrome 13",
"meckel syndrome 2",
"meckel syndrome 3",
"meckel syndrome 4",
"meckel syndrome 5",
"meckel syndrome 6",
"meckel syndrome 7",
"meckel syndrome 8",
"meckel syndrome 9",
"mecom-associated syndrome  mondo:0100458",
"meconium ileus",
"med12-related intellectual disability syndrome  mondo:0100000",
"medium chain acyl-coa dehydrogenase deficiency  mondo:0008721",
"mednik syndrome",
"mednik syndrome  mondo:0012251",
"medullary thyroid carcinoma",
"medulloblastoma",
"medulloblastoma  mondo:0007959",
"medulloblastoma, desmoplastic",
"medulloblastoma, somatic",
"meesmann corneal dystrophy 1",
"meesmann corneal dystrophy 2",
"meester loeys syndrome",
"mega corpus callosum syndrome with cerebellar hypoplasia and cortical malformations",
"megabladder, congenital",
"megacystis microcolon intestinal hypoperistalsis syndrome",
"megakaryoblastic leukemia, acute",
"megalencephalic leukoencephalopathy with subcortical cysts",
"megalencephalic leukoencephalopathy with subcortical cysts 1  mondo:0024555",
"megalencephalic leukoencephalopathy with subcortical cysts 2a",
"megalencephalic leukoencephalopathy with subcortical cysts 2a  mondo:0013490",
"megalencephalic leukoencephalopathy with subcortical cysts 2b, remitting, with or without intellectual disability  mondo:0013491",
"megalencephalic leukoencephalopathy with subcortical cysts 2b, remitting, with or without mental retardation",
"megalencephaly capillary malformation polymicrogyria syndrome, somatic",
"megalencephaly polymicrogyria polydactyly hydrocephalus syndrome 1",
"megalencephaly polymicrogyria polydactyly hydrocephalus syndrome 2",
"megalencephaly polymicrogyria polydactyly hydrocephalus syndrome 3",
"megaloblastic anemia due to dihydrofolate reductase deficiency",
"megaloblastic anemia, folate responsive",
"megalocornea 1, x linked",
"megf10-related myopathy  mondo:0013731",
"megf8-related carpenter syndrome  mondo:0013998",
"mehmo syndrome",
"mehmo syndrome  mondo:0010258",
"meier gorlin syndrome 1",
"meier gorlin syndrome 2",
"meier gorlin syndrome 3",
"meier gorlin syndrome 4",
"meier gorlin syndrome 5",
"meier gorlin syndrome 6",
"meier gorlin syndrome 7",
"meier gorlin syndrome 8",
"meier-gorlin syndrome 2  mondo:0013428",
"meier-gorlin syndrome 3  mondo:0013430",
"meier-gorlin syndrome 4  mondo:0013431",
"meier-gorlin syndrome 7  mondo:0014894",
"melanocytic nevus syndrome, congenital, somatic",
"melanoma and neural system tumor syndrome",
"melanoma pancreatic cancer syndrome",
"melanoma, cutaneous malignant, 2",
"melanoma, cutaneous malignant, 3",
"melanoma, cutaneous malignant, 5",
"melanoma, cutaneous malignant, 6",
"melanoma, cutaneous malignant, 9",
"melanoma, cutaneous malignant, susceptibility to, 10",
"melanoma, cutaneous malignant, susceptibility to, 3  mondo:0012183",
"melanoma, cutaneous malignant, susceptibility to, 8",
"melanoma, malignant, somatic",
"melanoma-pancreatic cancer syndrome  mondo:0011713",
"meleda disease",
"melioidosis, susceptibility to",
"melnick needles syndrome",
"melorheostosis, isolated, somatic mosaic",
"memory, enhanced, qtl",
"mend syndrome",
"mend syndrome  mondo:0010498",
"meningioma",
"meningioma, familial, susceptibility to",
"meningioma, nf2 related, somatic",
"meningioma, sis related",
"menke hennekam syndrome 1",
"menke hennekam syndrome 2",
"menkes disease",
"menkes disease  mondo:0010651",
"mental retardation and distinctive facial features with or without cardiac defects",
"mental retardation and microcephaly with pontine and cerebellar hypoplasia",
"mental retardation hypotonic facies syndrome, x linked",
"mental retardation syndrome, x linked, siderius type",
"mental retardation with language impairment and with or without autistic features",
"mental retardation, anterior maxillary protrusion, and strabismus",
"mental retardation, autosomal dominant 1",
"mental retardation, autosomal dominant 10",
"mental retardation, autosomal dominant 11",
"mental retardation, autosomal dominant 13",
"mental retardation, autosomal dominant 21",
"mental retardation, autosomal dominant 22",
"mental retardation, autosomal dominant 23",
"mental retardation, autosomal dominant 26",
"mental retardation, autosomal dominant 29",
"mental retardation, autosomal dominant 3",
"mental retardation, autosomal dominant 30",
"mental retardation, autosomal dominant 31",
"mental retardation, autosomal dominant 33",
"mental retardation, autosomal dominant 34",
"mental retardation, autosomal dominant 35",
"mental retardation, autosomal dominant 36",
"mental retardation, autosomal dominant 38",
"mental retardation, autosomal dominant 39",
"mental retardation, autosomal dominant 40",
"mental retardation, autosomal dominant 41",
"mental retardation, autosomal dominant 42",
"mental retardation, autosomal dominant 43",
"mental retardation, autosomal dominant 45",
"mental retardation, autosomal dominant 46",
"mental retardation, autosomal dominant 47",
"mental retardation, autosomal dominant 48",
"mental retardation, autosomal dominant 49",
"mental retardation, autosomal dominant 5",
"mental retardation, autosomal dominant 50",
"mental retardation, autosomal dominant 51",
"mental retardation, autosomal dominant 52",
"mental retardation, autosomal dominant 53",
"mental retardation, autosomal dominant 54",
"mental retardation, autosomal dominant 55, with seizures",
"mental retardation, autosomal dominant 56",
"mental retardation, autosomal dominant 57",
"mental retardation, autosomal dominant 58",
"mental retardation, autosomal dominant 59",
"mental retardation, autosomal dominant 7",
"mental retardation, autosomal recessive 1",
"mental retardation, autosomal recessive 13",
"mental retardation, autosomal recessive 14",
"mental retardation, autosomal recessive 18",
"mental retardation, autosomal recessive 2",
"mental retardation, autosomal recessive 27",
"mental retardation, autosomal recessive 3",
"mental retardation, autosomal recessive 34, with variant lissencephaly",
"mental retardation, autosomal recessive 36",
"mental retardation, autosomal recessive 38",
"mental retardation, autosomal recessive 39",
"mental retardation, autosomal recessive 40",
"mental retardation, autosomal recessive 41",
"mental retardation, autosomal recessive 42",
"mental retardation, autosomal recessive 43",
"mental retardation, autosomal recessive 44",
"mental retardation, autosomal recessive 45",
"mental retardation, autosomal recessive 46",
"mental retardation, autosomal recessive 47",
"mental retardation, autosomal recessive 48",
"mental retardation, autosomal recessive 5",
"mental retardation, autosomal recessive 50",
"mental retardation, autosomal recessive 51",
"mental retardation, autosomal recessive 53",
"mental retardation, autosomal recessive 54",
"mental retardation, autosomal recessive 56",
"mental retardation, autosomal recessive 57",
"mental retardation, autosomal recessive 58",
"mental retardation, autosomal recessive 59",
"mental retardation, autosomal recessive 60",
"mental retardation, autosomal recessive 61",
"mental retardation, autosomal recessive 63",
"mental retardation, autosomal recessive 64",
"mental retardation, autosomal recessive 65",
"mental retardation, autosomal recessive 67",
"mental retardation, autosomal recessive 68",
"mental retardation, autosomal recessive 7",
"mental retardation, autosomal recessive, 37",
"mental retardation, autosomal recessive, 52",
"mental retardation, autosomal recessive, 6",
"mental retardation, fra12a type",
"mental retardation, stereotypic movements, epilepsy, and/or cerebral malformations",
"mental retardation, truncal obesity, retinal dystrophy, and micropenis",
"mental retardation, with or without nystagmus",
"mental retardation, x linked",
"mental retardation, x linked 1/78",
"mental retardation, x linked 100",
"mental retardation, x linked 101",
"mental retardation, x linked 103",
"mental retardation, x linked 104",
"mental retardation, x linked 105",
"mental retardation, x linked 106",
"mental retardation, x linked 107",
"mental retardation, x linked 12/35",
"mental retardation, x linked 19",
"mental retardation, x linked 21/34",
"mental retardation, x linked 29 and others",
"mental retardation, x linked 3 methylmalonic acidemia and homocysteinemia, cblx type",
"mental retardation, x linked 30/47",
"mental retardation, x linked 41",
"mental retardation, x linked 58",
"mental retardation, x linked 63",
"mental retardation, x linked 72",
"mental retardation, x linked 9/44",
"mental retardation, x linked 90",
"mental retardation, x linked 93",
"mental retardation, x linked 96",
"mental retardation, x linked 97",
"mental retardation, x linked 98",
"mental retardation, x linked 99",
"mental retardation, x linked 99, syndromic, female restricted",
"mental retardation, x linked syndromic 16",
"mental retardation, x linked syndromic 5",
"mental retardation, x linked syndromic, christianson type",
"mental retardation, x linked syndromic, lubs type",
"mental retardation, x linked syndromic, nascimento type",
"mental retardation, x linked syndromic, raymond type",
"mental retardation, x linked syndromic, turner type",
"mental retardation, x linked, snyder robinson type",
"mental retardation, x linked, syndromic 11, shashi type",
"mental retardation, x linked, syndromic 13",
"mental retardation, x linked, syndromic 14",
"mental retardation, x linked, syndromic 15 cabezas type",
"mental retardation, x linked, syndromic 32",
"mental retardation, x linked, syndromic 33",
"mental retardation, x linked, syndromic 34",
"mental retardation, x linked, syndromic, 35",
"mental retardation, x linked, syndromic, bain type",
"mental retardation, x linked, syndromic, claes jensen type",
"mental retardation, x linked, syndromic, hedera type",
"mental retardation, x linked, syndromic, houge type",
"mental retardation, x linked, with cerebellar hypoplasia and distinctive facial appearance",
"mental retardation, x linked, with isolated growth hormone deficiency",
"mephenytoin poor metabolizer",
"mertk-related retinopathy  mondo:0800394",
"mesothelioma, somatic",
"metabolic crises, recurrent, with variable encephalomyopathic features and neurologic regression",
"metabolic encephalomyopathic crises, recurrent, with rhabdomyolysis, cardiac arrhythmias, and neurodegeneration",
"metabolic syndrome, protection against",
"metacarpal 4 5 fusion",
"metachondromatosis",
"metachromatic leukodystrophy",
"metachromatic leukodystrophy  mondo:0018868",
"metachromatic leukodystrophy due to sap b deficiency",
"metachromatic leukodystrophy due to saposin b deficiency  mondo:0009590",
"metaphyseal anadysplasia 1",
"metaphyseal anadysplasia 2",
"metaphyseal chondrodysplasia, murk jansen type",
"metaphyseal chondrodysplasia, schmid type",
"metaphyseal dysplasia with maxillary hypoplasia with or without brachydactyly",
"metaphyseal dysplasia without hypotrichosis",
"metaphyseal dysplasia, spahr type",
"metatropic dysplasia",
"methemoglobinemia and ambiguous genitalia",
"methemoglobinemia, alpha type",
"methemoglobinemia, alpha type  mondo:0020835",
"methemoglobinemia, beta type",
"methemoglobinemia, type i",
"methemoglobinemia, type ii",
"methionine adenosyltransferase deficiency  mondo:0009607",
"methionine adenosyltransferase deficiency, autosomal recessive",
"methylcobalamin deficiency type cble  mondo:0009354",
"methylcobalamin deficiency type cblg  mondo:0009609",
"methylmalonate semialdehyde dehydrogenase deficiency",
"methylmalonate semialdehyde dehydrogenase deficiency  mondo:0013579",
"methylmalonic acidemia due to methylmalonyl-coa epimerase deficiency  mondo:0009615",
"methylmalonic acidemia due to transcobalamin receptor defect  mondo:0013341",
"methylmalonic acidemia with homocystinuria, type cblj  mondo:0013925",
"methylmalonic aciduria and homocystinuria  mondo:0016826",
"methylmalonic aciduria and homocystinuria type cblc  mondo:0010184",
"methylmalonic aciduria and homocystinuria type cblf  mondo:0010183",
"methylmalonic aciduria and homocystinuria, cblc type",
"methylmalonic aciduria and homocystinuria, cblc type, digenic",
"methylmalonic aciduria and homocystinuria, cbld type",
"methylmalonic aciduria and homocystinuria, cblf type",
"methylmalonic aciduria and homocystinuria, cblj type",
"methylmalonic aciduria due to methylmalonyl-coa mutase deficiency  mondo:0009612",
"methylmalonic aciduria, cbla type  mondo:0009613",
"methylmalonic aciduria, cblb type  mondo:0009614",
"methylmalonic aciduria, cbld type, variant 2",
"methylmalonic aciduria, mut0 type",
"methylmalonic aciduria, transient, due to transcobalamin receptor defect",
"methylmalonic aciduria, vitamin b12 responsive, cbla type",
"methylmalonic aciduria, vitamin b12 responsive, cblb type",
"methylmalonyl coa epimerase deficiency",
"mevalonate kinase deficiency  mondo:0017708",
"mevalonic aciduria",
"mgat2-congenital disorder of glycosylation  mondo:0008908",
"mhc class i deficiency  mondo:0011476",
"mhc class ii deficiency  mondo:0008855",
"mhc class ii deficiency, complementation group b",
"microangiopathy and leukoencephalopathy, pontine, autosomal dominant",
"microcephalic osteodysplastic primordial dwarfism type ii  mondo:0008872",
"microcephalic osteodysplastic primordial dwarfism, type i",
"microcephalic osteodysplastic primordial dwarfism, type ii",
"microcephalic primordial dwarfism due to rttn deficiency  mondo:0018764",
"microcephaly  mondo:0001149",
"microcephaly 1, primary, autosomal recessive",
"microcephaly 10, primary, autosomal recessive",
"microcephaly 11, primary, autosomal recessive",
"microcephaly 12, primary, autosomal recessive",
"microcephaly 13, primary, autosomal recessive",
"microcephaly 14, primary, autosomal recessive",
"microcephaly 16, primary, autosomal recessive",
"microcephaly 17, primary, autosomal recessive",
"microcephaly 18, primary, autosomal dominant",
"microcephaly 19, primary, autosomal recessive",
"microcephaly 2, primary, autosomal recessive, with or without cortical malformations",
"microcephaly 2, primary, autosomal recessive, with or without cortical malformations  mondo:0011435",
"microcephaly 20, primary, autosomal recessive",
"microcephaly 21, primary, autosomal recessive",
"microcephaly 22, primary, autosomal recessive",
"microcephaly 23, primary, autosomal recessive",
"microcephaly 24, primary, autosomal recessive",
"microcephaly 25, primary, autosomal recessive",
"microcephaly 26, primary, autosomal dominant",
"microcephaly 27, primary, autosomal dominant",
"microcephaly 28, primary, autosomal recessive",
"microcephaly 3, primary, autosomal recessive",
"microcephaly 4, primary, autosomal recessive",
"microcephaly 5, primary, autosomal recessive",
"microcephaly 6 with or without short stature  mondo:0700054",
"microcephaly 7, primary, autosomal recessive",
"microcephaly 8, primary, autosomal recessive",
"microcephaly 9, primary, autosomal recessive",
"microcephaly and chorioretinopathy 1  mondo:0009624",
"microcephaly and chorioretinopathy, autosomal recessive, 1",
"microcephaly and chorioretinopathy, autosomal recessive, 2",
"microcephaly and chorioretinopathy, autosomal recessive, 3",
"microcephaly capillary malformation syndrome",
"microcephaly micromelia syndrome",
"microcephaly with intellectual disability  mondo:0100200",
"microcephaly with or without chorioretinopathy, lymphedema, or intellectual disability  mondo:0007918",
"microcephaly with or without chorioretinopathy, lymphedema, or mental retardation",
"microcephaly with or without short stature  mondo:0100346",
"microcephaly, amish type",
"microcephaly, cataracts, impaired intellectual development, and dystonia with abnormal striatum",
"microcephaly, congenital cataract, and psoriasiform dermatitis",
"microcephaly, developmental delay, and brittle hair syndrome",
"microcephaly, epilepsy, and diabetes syndrome",
"microcephaly, epilepsy, and diabetes syndrome 2",
"microcephaly, facial dysmorphism, renal agenesis, and ambiguous genitalia syndrome",
"microcephaly, growth deficiency, seizures, and brain malformations",
"microcephaly, growth restriction, and increased sister chromatid exchange 2",
"microcephaly, postnatal progressive, with seizures and brain atrophy",
"microcephaly, progressive, seizures, and cerebral and cerebellar atrophy",
"microcephaly, seizures, and developmental delay",
"microcephaly, seizures, and developmental delay  mondo:0013254",
"microcephaly, short stature, and impaired glucose metabolism 1",
"microcephaly, short stature, and impaired glucose metabolism 2",
"microcephaly, short stature, and limb abnormalities",
"microcephaly, short stature, and polymicrogyria with seizures",
"microcornea, myopic chorioretinal atrophy, and telecanthus",
"microcornea, rod cone dystrophy, cataract, and posterior staphyloma 1",
"microcornea, rod cone dystrophy, cataract, and posterior staphyloma 2",
"microcornea-myopic chorioretinal atrophy  mondo:0014195",
"microhydranencephaly",
"microphthalmia with coloboma 3",
"microphthalmia with coloboma 5",
"microphthalmia with coloboma 6",
"microphthalmia with coloboma 6, digenic",
"microphthalmia with limb anomalies",
"microphthalmia, isolated 2",
"microphthalmia, isolated 3",
"microphthalmia, isolated 4",
"microphthalmia, isolated 5",
"microphthalmia, isolated 6",
"microphthalmia, isolated 7",
"microphthalmia, isolated 8",
"microphthalmia, isolated, with coloboma 10",
"microphthalmia, isolated, with coloboma 7",
"microphthalmia, isolated, with coloboma 7  mondo:0013783",
"microphthalmia, isolated, with coloboma 8",
"microphthalmia, isolated, with coloboma 9",
"microphthalmia, syndromic 1",
"microphthalmia, syndromic 11",
"microphthalmia, syndromic 12",
"microphthalmia, syndromic 12  mondo:0014229",
"microphthalmia, syndromic 13",
"microphthalmia, syndromic 15",
"microphthalmia, syndromic 2",
"microphthalmia, syndromic 2  mondo:0010261",
"microphthalmia, syndromic 3",
"microphthalmia, syndromic 5",
"microphthalmia, syndromic 6",
"microphthalmia, syndromic 9",
"microphthalmia/coloboma and skeletal dysplasia syndrome",
"microspherophakia and/or megalocornea, with ectopia lentis and with or without secondary glaucoma",
"microtia with or without hearing impairment ad",
"microtia, hearing impairment, and cleft palate ar",
"microvascular complications of diabetes 1",
"microvascular complications of diabetes 2",
"microvascular complications of diabetes 3",
"microvascular complications of diabetes 4",
"microvascular complications of diabetes 5",
"microvascular complications of diabetes 6",
"microvascular complications of diabetes 7",
"microvillus inclusion disease",
"midface hypoplasia, hearing impairment, elliptocytosis, and nephrocalcinosis",
"migraine without aura, susceptibility to",
"migraine, familial basilar",
"migraine, familial hemiplegic, 1",
"migraine, familial hemiplegic, 1, with progressive cerebellar ataxia",
"migraine, familial hemiplegic, 2",
"migraine, familial hemiplegic, 3",
"migraine, resistance to",
"migraine, susceptibility to",
"migraine, with or without aura, susceptibility to, 13",
"miller syndrome",
"minicore myopathy with external ophthalmoplegia",
"mirage syndrome",
"mirror movements 1 and/or agenesis of the corpus callosum",
"mirror movements 1 and/or agenesis of the corpus callosum  mondo:0100515",
"mirror movements 2",
"mirror movements 3",
"mirror movements 4",
"mismatch repair cancer syndrome 1",
"mismatch repair cancer syndrome 1  mondo:0010159",
"mismatch repair cancer syndrome 2",
"mismatch repair cancer syndrome 3",
"mismatch repair cancer syndrome 4",
"mitchell riley syndrome",
"mitchell syndrome",
"mitchell syndrome  mondo:0030073",
"mitochondrial complex i deficiency, nuclear type 1",
"mitochondrial complex i deficiency, nuclear type 10",
"mitochondrial complex i deficiency, nuclear type 11",
"mitochondrial complex i deficiency, nuclear type 12",
"mitochondrial complex i deficiency, nuclear type 13",
"mitochondrial complex i deficiency, nuclear type 14",
"mitochondrial complex i deficiency, nuclear type 15",
"mitochondrial complex i deficiency, nuclear type 16",
"mitochondrial complex i deficiency, nuclear type 17",
"mitochondrial complex i deficiency, nuclear type 18",
"mitochondrial complex i deficiency, nuclear type 19",
"mitochondrial complex i deficiency, nuclear type 2",
"mitochondrial complex i deficiency, nuclear type 20",
"mitochondrial complex i deficiency, nuclear type 21",
"mitochondrial complex i deficiency, nuclear type 22",
"mitochondrial complex i deficiency, nuclear type 23",
"mitochondrial complex i deficiency, nuclear type 24",
"mitochondrial complex i deficiency, nuclear type 25",
"mitochondrial complex i deficiency, nuclear type 26",
"mitochondrial complex i deficiency, nuclear type 27",
"mitochondrial complex i deficiency, nuclear type 28",
"mitochondrial complex i deficiency, nuclear type 29",
"mitochondrial complex i deficiency, nuclear type 3",
"mitochondrial complex i deficiency, nuclear type 30",
"mitochondrial complex i deficiency, nuclear type 31",
"mitochondrial complex i deficiency, nuclear type 32",
"mitochondrial complex i deficiency, nuclear type 33",
"mitochondrial complex i deficiency, nuclear type 34",
"mitochondrial complex i deficiency, nuclear type 35",
"mitochondrial complex i deficiency, nuclear type 36",
"mitochondrial complex i deficiency, nuclear type 37",
"mitochondrial complex i deficiency, nuclear type 4",
"mitochondrial complex i deficiency, nuclear type 5",
"mitochondrial complex i deficiency, nuclear type 6",
"mitochondrial complex i deficiency, nuclear type 7",
"mitochondrial complex i deficiency, nuclear type 8",
"mitochondrial complex i deficiency, nuclear type 9",
"mitochondrial complex ii deficiency, nuclear type 1",
"mitochondrial complex ii deficiency, nuclear type 2",
"mitochondrial complex ii deficiency, nuclear type 3",
"mitochondrial complex ii deficiency, nuclear type 4",
"mitochondrial complex iii deficiency, nuclear type 1",
"mitochondrial complex iii deficiency, nuclear type 10",
"mitochondrial complex iii deficiency, nuclear type 2",
"mitochondrial complex iii deficiency, nuclear type 3",
"mitochondrial complex iii deficiency, nuclear type 4",
"mitochondrial complex iii deficiency, nuclear type 5",
"mitochondrial complex iii deficiency, nuclear type 6",
"mitochondrial complex iii deficiency, nuclear type 7",
"mitochondrial complex iii deficiency, nuclear type 8",
"mitochondrial complex iii deficiency, nuclear type 9",
"mitochondrial complex iv deficiency, nuclear type 1",
"mitochondrial complex iv deficiency, nuclear type 10",
"mitochondrial complex iv deficiency, nuclear type 11",
"mitochondrial complex iv deficiency, nuclear type 12",
"mitochondrial complex iv deficiency, nuclear type 13",
"mitochondrial complex iv deficiency, nuclear type 14",
"mitochondrial complex iv deficiency, nuclear type 15",
"mitochondrial complex iv deficiency, nuclear type 16",
"mitochondrial complex iv deficiency, nuclear type 17",
"mitochondrial complex iv deficiency, nuclear type 18",
"mitochondrial complex iv deficiency, nuclear type 19",
"mitochondrial complex iv deficiency, nuclear type 2",
"mitochondrial complex iv deficiency, nuclear type 20",
"mitochondrial complex iv deficiency, nuclear type 21",
"mitochondrial complex iv deficiency, nuclear type 3",
"mitochondrial complex iv deficiency, nuclear type 4",
"mitochondrial complex iv deficiency, nuclear type 5, french canadian",
"mitochondrial complex iv deficiency, nuclear type 6",
"mitochondrial complex iv deficiency, nuclear type 7",
"mitochondrial complex iv deficiency, nuclear type 8",
"mitochondrial complex iv, deficiency, nuclear type 9",
"mitochondrial complex v atp synthase deficiency",
"mitochondrial complex v atp synthase deficiency, nuclear type 1",
"mitochondrial complex v atp synthase deficiency, nuclear type 2",
"mitochondrial complex v atp synthase deficiency, nuclear type 3",
"mitochondrial complex v atp synthase deficiency, nuclear type 4",
"mitochondrial complex v atp synthase deficiency, nuclear type 6",
"mitochondrial disease  mondo:0044970",
"mitochondrial dna depletion syndrome 1 mngie type",
"mitochondrial dna depletion syndrome 11",
"mitochondrial dna depletion syndrome 12a cardiomyopathic type ad",
"mitochondrial dna depletion syndrome 12b (cardiomyopathic type), autosomal recessive  mondo:0014175",
"mitochondrial dna depletion syndrome 12b cardiomyopathic type ar",
"mitochondrial dna depletion syndrome 13 encephalomyopathic type",
"mitochondrial dna depletion syndrome 14 encephalocardiomyopathic type",
"mitochondrial dna depletion syndrome 15 hepatocerebral type",
"mitochondrial dna depletion syndrome 16 hepatic type",
"mitochondrial dna depletion syndrome 17",
"mitochondrial dna depletion syndrome 18",
"mitochondrial dna depletion syndrome 19",
"mitochondrial dna depletion syndrome 2 myopathic type",
"mitochondrial dna depletion syndrome 3 hepatocerebral type",
"mitochondrial dna depletion syndrome 4a alpers type",
"mitochondrial dna depletion syndrome 4b mngie type",
"mitochondrial dna depletion syndrome 5 encephalomyopathic with or without methylmalonic aciduria",
"mitochondrial dna depletion syndrome 6 hepatocerebral type",
"mitochondrial dna depletion syndrome 7 hepatocerebral type",
"mitochondrial dna depletion syndrome 8a encephalomyopathic type with renal tubulopathy",
"mitochondrial dna depletion syndrome 8b mngie type",
"mitochondrial dna depletion syndrome 9 encephalomyopathic type with methylmalonic aciduria",
"mitochondrial myopathy with lactic acidosis",
"mitochondrial myopathy, episodic, with optic atrophy and reversible leukoencephalopathy",
"mitochondrial phosphate carrier deficiency",
"mitochondrial pyruvate carrier deficiency",
"mitochondrial recessive ataxia syndrome includes sando and scae",
"mitochondrial short chain enoyl coa hydratase 1 deficiency",
"mitochondrial short-chain enoyl-coa hydratase 1 deficiency  mondo:0014563",
"mitochondrial trifunctional protein deficiency",
"mitochondrial trifunctional protein deficiency  mondo:0012172",
"mitral valve prolapse 2",
"mitral valve prolapse 3",
"miyoshi muscular dystrophy 1",
"miyoshi muscular dystrophy 3",
"mody, type i",
"mody, type ii",
"mody, type iii",
"mody, type iv",
"mogs-congenital disorder of glycosylation  mondo:0011629",
"mohr tranebjaerg syndrome",
"molybdenum cofactor deficiency a",
"molybdenum cofactor deficiency b",
"molybdenum cofactor deficiency c",
"monilethrix",
"monocarboxylate transporter 1 deficiency",
"monogenic diabetes  mondo:0015967",
"mononeuropathy of the median nerve, mild",
"monosomy 7 myelodysplasia and leukemia syndrome 1",
"monosomy 7 myelodysplasia and leukemia syndrome 2",
"morbid obesity and spermatogenic failure",
"morm syndrome  mondo:0012423",
"morning glory disc anomaly",
"mosaic variegated aneuploidy syndrome 1",
"mosaic variegated aneuploidy syndrome 1  mondo:0009759",
"mosaic variegated aneuploidy syndrome 2",
"mosaic variegated aneuploidy syndrome 2  mondo:0013582",
"mosaic variegated aneuploidy syndrome 3",
"mosaic variegated aneuploidy syndrome 4",
"movement disorder  mondo:0005395",
"mowat wilson syndrome",
"mowat-wilson syndrome  mondo:0009341",
"moyamoya 6 with achalasia",
"moyamoya disease 2, susceptibility to",
"moyamoya disease 5",
"mpi-congenital disorder of glycosylation  mondo:0011257",
"muckle wells syndrome",
"mucocutaneous ulceration, chronic",
"mucoepidermoid salivary gland carcinoma",
"mucoepithelial dysplasia, hereditary",
"mucolipidosis ii alpha/beta",
"mucolipidosis iii alpha/beta",
"mucolipidosis iii gamma",
"mucolipidosis iv",
"mucolipidosis type iv  mondo:0009653",
"mucopolysaccharidosis ih",
"mucopolysaccharidosis ih/s",
"mucopolysaccharidosis ii",
"mucopolysaccharidosis is",
"mucopolysaccharidosis iva",
"mucopolysaccharidosis plus syndrome",
"mucopolysaccharidosis type 1  mondo:0001586",
"mucopolysaccharidosis type 2  mondo:0010674",
"mucopolysaccharidosis type 3a  mondo:0009655",
"mucopolysaccharidosis type 3b  mondo:0009656",
"mucopolysaccharidosis type 3c  mondo:0009657",
"mucopolysaccharidosis type 3d  mondo:0009658",
"mucopolysaccharidosis type 4a  mondo:0009659",
"mucopolysaccharidosis type 4b  mondo:0009660",
"mucopolysaccharidosis type 6  mondo:0009661",
"mucopolysaccharidosis type 7  mondo:0009662",
"mucopolysaccharidosis type 9  mondo:0011093",
"mucopolysaccharidosis type iiia sanfilippo a",
"mucopolysaccharidosis type iiib sanfilippo b",
"mucopolysaccharidosis type iiic sanfilippo c",
"mucopolysaccharidosis type iiid",
"mucopolysaccharidosis type ivb morquio",
"mucopolysaccharidosis type ix",
"mucopolysaccharidosis type vi maroteaux lamy",
"mucopolysaccharidosis vii",
"mucopolysaccharidosis-plus syndrome  mondo:0015012",
"mucosulfatidosis  mondo:0010088",
"muenke syndrome",
"muenke syndrome  mondo:0011274",
"muir torre syndrome",
"mulibrey nanism",
"mulibrey nanism  mondo:0009664",
"mullegama klein martinez syndrome",
"mullerian aplasia and hyperandrogenism",
"multicentric carpotarsal osteolysis syndrome",
"multicentric osteolysis, nodulosis, and arthropathy",
"multinucleated neurons, anhydramnios, renal dysplasia, cerebellar hypoplasia, and hydranencephaly",
"multiple acyl-coa dehydrogenase deficiency  mondo:0009282",
"multiple congenital anomalies hypotonia seizures syndrome 1",
"multiple congenital anomalies hypotonia seizures syndrome 2",
"multiple congenital anomalies hypotonia seizures syndrome 3",
"multiple congenital anomalies neurodevelopmental syndrome, x linked",
"multiple congenital anomalies-hypotonia-seizures syndrome 1  mondo:0013563",
"multiple congenital anomalies-neurodevelopmental syndrome, x-linked  mondo:0025351",
"multiple endocrine neoplasia 1",
"multiple endocrine neoplasia iia",
"multiple endocrine neoplasia iib",
"multiple endocrine neoplasia type 1  mondo:0007540",
"multiple endocrine neoplasia type 2a  mondo:0008234",
"multiple endocrine neoplasia type 2b  mondo:0008082",
"multiple endocrine neoplasia type 4  mondo:0012552",
"multiple endocrine neoplasia, type iv",
"multiple epiphyseal dysplasia  mondo:0016648",
"multiple fibroadenomas of the breast",
"multiple intestinal atresia  mondo:0009465",
"multiple joint dislocations, short stature, craniofacial dysmorphism, with or without congenital heart defects",
"multiple mitochondrial dysfunctions syndrome 1",
"multiple mitochondrial dysfunctions syndrome 2 with hyperglycinemia",
"multiple mitochondrial dysfunctions syndrome 3",
"multiple mitochondrial dysfunctions syndrome 4",
"multiple mitochondrial dysfunctions syndrome 5",
"multiple mitochondrial dysfunctions syndrome 6",
"multiple myeloma, resistance to",
"multiple myeloma, susceptibility to",
"multiple pterygium syndrome, lethal type",
"multiple sclerosis, disease progression, modifier of",
"multiple sclerosis, susceptibility to, 1",
"multiple sclerosis, susceptibility to, 5",
"multiple self healing squamous epithelioma, susceptibility to",
"multiple self-healing squamous epithelioma  mondo:0007566",
"multiple sulfatase deficiency",
"multiple synostoses syndrome 1",
"multiple synostoses syndrome 2",
"multiple synostoses syndrome 3",
"multiple synostoses syndrome 4",
"multiple system atrophy, susceptibility to",
"multisystemic smooth muscle dysfunction syndrome",
"mungan syndrome",
"muscle glycogenosis",
"muscle hypertrophy",
"muscle-eye-brain disease  mondo:0018939",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 1",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 10",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 11",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 12",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 13",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 14",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 2",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 3",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 4",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 5",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 6",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 7",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 8",
"muscular dystrophy dystroglycanopathy congenital with brain and eye anomalies, type a, 9",
"muscular dystrophy dystroglycanopathy congenital with impaired intellectual development, type b, 15",
"muscular dystrophy dystroglycanopathy congenital with mental retardation, type b, 1",
"muscular dystrophy dystroglycanopathy congenital with mental retardation, type b, 14",
"muscular dystrophy dystroglycanopathy congenital with mental retardation, type b, 2",
"muscular dystrophy dystroglycanopathy congenital with mental retardation, type b, 3",
"muscular dystrophy dystroglycanopathy congenital with mental retardation, type b, 6",
"muscular dystrophy dystroglycanopathy congenital with or without mental retardation, type b, 5",
"muscular dystrophy dystroglycanopathy congenital without mental retardation, type b, 4",
"muscular dystrophy dystroglycanopathy limb girdle type c, 8",
"muscular dystrophy dystroglycanopathy limb girdle, type c, 1",
"muscular dystrophy dystroglycanopathy limb girdle, type c, 12",
"muscular dystrophy dystroglycanopathy limb girdle, type c, 14",
"muscular dystrophy dystroglycanopathy limb girdle, type c, 15",
"muscular dystrophy dystroglycanopathy limb girdle, type c, 2",
"muscular dystrophy dystroglycanopathy limb girdle, type c, 3",
"muscular dystrophy dystroglycanopathy limb girdle, type c, 4",
"muscular dystrophy dystroglycanopathy limb girdle, type c, 5",
"muscular dystrophy dystroglycanopathy limb girdle, type c, 7",
"muscular dystrophy dystroglycanopathy limb girdle, type c, 9",
"muscular dystrophy, autosomal recessive, with cardiomyopathy and triangular tongue",
"muscular dystrophy, autosomal recessive, with rigid spine and distal joint contractures",
"muscular dystrophy, congenital",
"muscular dystrophy, congenital, davignon chauveau type",
"muscular dystrophy, congenital, due to itga7 deficiency",
"muscular dystrophy, congenital, megaconial type",
"muscular dystrophy, congenital, merosin deficient or partially deficient",
"muscular dystrophy, congenital, with cataracts and intellectual disability",
"muscular dystrophy, limb girdle, autosomal dominant 1",
"muscular dystrophy, limb girdle, autosomal dominant 2",
"muscular dystrophy, limb girdle, autosomal dominant 3",
"muscular dystrophy, limb girdle, autosomal dominant 4",
"muscular dystrophy, limb girdle, autosomal recessive 1",
"muscular dystrophy, limb girdle, autosomal recessive 10",
"muscular dystrophy, limb girdle, autosomal recessive 12",
"muscular dystrophy, limb girdle, autosomal recessive 17",
"muscular dystrophy, limb girdle, autosomal recessive 18",
"muscular dystrophy, limb girdle, autosomal recessive 2",
"muscular dystrophy, limb girdle, autosomal recessive 21",
"muscular dystrophy, limb girdle, autosomal recessive 23",
"muscular dystrophy, limb girdle, autosomal recessive 26",
"muscular dystrophy, limb girdle, autosomal recessive 3",
"muscular dystrophy, limb girdle, autosomal recessive 4",
"muscular dystrophy, limb girdle, autosomal recessive 5",
"muscular dystrophy, limb girdle, autosomal recessive 6",
"muscular dystrophy, limb girdle, autosomal recessive 7",
"muscular dystrophy, limb girdle, autosomal recessive 8",
"muscular dystrophy, limb-girdle, autosomal dominant  mondo:0015151",
"muscular dystrophy, rigid spine, 1",
"muscular dystrophy-dystroglycanopathy  mondo:0018276",
"muscular dystrophy-dystroglycanopathy (congenital with brain and eye anomalies), type a13  mondo:0014120",
"myasthenia, congenital, 12, with tubular aggregates",
"myasthenic syndrome, congenital, 10",
"myasthenic syndrome, congenital, 11, associated with acetylcholine receptor deficiency",
"myasthenic syndrome, congenital, 13, with tubular aggregates",
"myasthenic syndrome, congenital, 14, with tubular aggregates",
"myasthenic syndrome, congenital, 15, without tubular aggregates",
"myasthenic syndrome, congenital, 16",
"myasthenic syndrome, congenital, 17",
"myasthenic syndrome, congenital, 18",
"myasthenic syndrome, congenital, 19",
"myasthenic syndrome, congenital, 1a, slow channel",
"myasthenic syndrome, congenital, 1b, fast channel",
"myasthenic syndrome, congenital, 20, presynaptic",
"myasthenic syndrome, congenital, 21, presynaptic",
"myasthenic syndrome, congenital, 22",
"myasthenic syndrome, congenital, 23, presynaptic",
"myasthenic syndrome, congenital, 24, presynaptic",
"myasthenic syndrome, congenital, 25",
"myasthenic syndrome, congenital, 2a, slow channel",
"myasthenic syndrome, congenital, 2c, associated with acetylcholine receptor deficiency",
"myasthenic syndrome, congenital, 3a, slow channel",
"myasthenic syndrome, congenital, 3b, fast channel",
"myasthenic syndrome, congenital, 3c, associated with acetylcholine receptor deficiency",
"myasthenic syndrome, congenital, 4a, slow channel",
"myasthenic syndrome, congenital, 4b, fast channel",
"myasthenic syndrome, congenital, 4c, associated with acetylcholine receptor deficiency",
"myasthenic syndrome, congenital, 5",
"myasthenic syndrome, congenital, 6, presynaptic",
"myasthenic syndrome, congenital, 7, presynaptic",
"myasthenic syndrome, congenital, 8, with pre  and postsynaptic defects",
"myasthenic syndrome, congenital, 9, associated with acetylcholine receptor deficiency",
"mycobacterium tuberculosis, protection against",
"mycobacterium tuberculosis, susceptibility to",
"mycobacterium tuberculosis, susceptibility to infection by",
"myelodysplastic syndrome",
"myelodysplastic syndrome, preleukemic",
"myelodysplastic syndrome, somatic",
"myelodysplastic syndrome, susceptibility to",
"myelofibrosis with myeloid metaplasia, somatic",
"myelofibrosis, somatic",
"myelogenous leukemia, acute",
"myeloid leukemia, acute, m4/m4eo subtype, somatic",
"myelokathexis, isolated",
"myeloperoxidase deficiency",
"myeloproliferative disorder",
"myeloproliferative disorder with eosinophilia",
"myeloproliferative/lymphoproliferative neoplasms, familial multiple types, susceptibility to",
"myh-6 related congenital heart defects  mondo:0800442",
"myh7-related skeletal myopathy  mondo:0008050",
"myhre syndrome",
"myhre syndrome  mondo:0007688",
"myocardial infarction, decreased susceptibility to",
"myocardial infarction, protection against",
"myocardial infarction, susceptibility to",
"myoclonic atonic epilepsy",
"myoclonic epilepsy, infantile, familial",
"myoclonic epilepsy, juvenile, susceptibility to, 1",
"myoclonus, familial, 1",
"myoclonus, familial, 2",
"myoclonus, intractable, neonatal",
"myofibrillar myopathy  mondo:0018943",
"myofibrillar myopathy 10",
"myofibrillar myopathy 11",
"myofibrillar myopathy 5  mondo:0012289",
"myofibrillar myopathy 8  mondo:0014993",
"myofibromatosis, infantile 2",
"myofibromatosis, infantile, 1",
"myoglobinuria, acute recurrent, autosomal recessive",
"myoglobinuria, acute recurrent, autosomal recessive  mondo:0009992",
"myokymia",
"myopathy caused by variation in crppa  mondo:0100530",
"myopathy caused by variation in fkrp  mondo:0700066",
"myopathy caused by variation in fktn  mondo:0700067",
"myopathy caused by variation in gmppb  mondo:0700084",
"myopathy caused by variation in pomgnt1  mondo:0700068",
"myopathy caused by variation in pomgnt2  mondo:0700069",
"myopathy caused by variation in pomt1  mondo:0700070",
"myopathy caused by variation in pomt2  mondo:0700071",
"myopathy due to myoadenylate deaminase deficiency",
"myopathy with abnormal lipid metabolism  mondo:0009703",
"myopathy with extrapyramidal signs",
"myopathy with lactic acidosis, hereditary",
"myopathy, actin, congenital, with cores",
"myopathy, actin, congenital, with excess of thin myofilaments",
"myopathy, areflexia, respiratory distress, and dysphagia, early onset",
"myopathy, areflexia, respiratory distress, and dysphagia, early onset, mild variant",
"myopathy, centronuclear, 5  mondo:0014418",
"myopathy, centronuclear, 6, with fiber-type disproportion  mondo:0054695",
"myopathy, congenital proximal, with minicore lesions",
"myopathy, congenital with structured cores and z line abnormalities",
"myopathy, congenital, baily bloch",
"myopathy, congenital, compton north",
"myopathy, congenital, progressive, with scoliosis",
"myopathy, congenital, with diaphragmatic defects, respiratory insufficiency, and dysmorphic facies",
"myopathy, congenital, with fast twitch type ii fiber atrophy",
"myopathy, congenital, with fiber type disproportion",
"myopathy, congenital, with fiber type disproportion 1",
"myopathy, congenital, with respiratory insufficiency and bone fractures",
"myopathy, congenital, with tremor",
"myopathy, distal, 4",
"myopathy, distal, 5",
"myopathy, distal, 6, adult onset",
"myopathy, distal, tateyama type",
"myopathy, distal, with anterior tibial onset",
"myopathy, distal, with rimmed vacuoles",
"myopathy, epilepsy, and progressive cerebral atrophy",
"myopathy, isolated mitochondrial, autosomal dominant",
"myopathy, lactic acidosis, and sideroblastic anemia 1",
"myopathy, lactic acidosis, and sideroblastic anemia 2",
"myopathy, mitochondrial progressive, with congenital cataract and developmental delay",
"myopathy, mitochondrial, and ataxia",
"myopathy, myofibrillar, 1",
"myopathy, myofibrillar, 2",
"myopathy, myofibrillar, 3",
"myopathy, myofibrillar, 4",
"myopathy, myofibrillar, 5",
"myopathy, myofibrillar, 6",
"myopathy, myofibrillar, 7",
"myopathy, myofibrillar, 8",
"myopathy, myofibrillar, 9, with early respiratory failure",
"myopathy, myofibrillar, 9, with early respiratory failure  mondo:0011362",
"myopathy, myofibrillar, fatal infantile hypertonic, alpha b crystallin related",
"myopathy, myosin storage, autosomal dominant",
"myopathy, myosin storage, autosomal recessive",
"myopathy, proximal, and ophthalmoplegia  mondo:0011577",
"myopathy, scapulohumeroperoneal",
"myopathy, spheroid body",
"myopathy, tubular aggregate, 1",
"myopathy, tubular aggregate, 2",
"myopathy, vacuolar, with casq1 aggregates",
"myopathy, x linked, with excessive autophagy",
"myopathy, x linked, with postural muscle atrophy",
"myopia 21, autosomal dominant",
"myopia 22, autosomal dominant",
"myopia 23, autosomal recessive",
"myopia 24, autosomal dominant",
"myopia 25, autosomal dominant",
"myopia 26, x linked, female limited",
"myopia 27",
"myopia 6",
"myopia, high, with cataract and vitreoretinal degeneration",
"myosclerosis, congenital",
"myotonia congenita, atypical, acetazolamide responsive",
"myotonia congenita, dominant",
"myotonia congenita, recessive",
"myotonia levior, recessive",
"myotonic dystrophy 1",
"myotonic dystrophy 2",
"myotubular myopathy, x linked",
"mypn-related myopathy  mondo:0015023",
"myxoma, intracardiac",
"n acetylaspartate deficiency",
"n acetylglutamate synthase deficiency",
"n-acetylaspartate deficiency  mondo:0013549",
"naa10-related syndrome  mondo:0100124",
"nabais sa de vries syndrome, type 1",
"nabais sa de vries syndrome, type 2",
"nacc1-related neurodevelopmental disorder with epilepsy, cataracts and episodic irritability  mondo:0800475",
"naegeli franceschetti jadassohn syndrome",
"nail disorder, nonsyndromic congenital, 1",
"nail disorder, nonsyndromic congenital, 3, leukonychia",
"nail patella syndrome",
"nail-patella syndrome  mondo:0008061",
"nance horan syndrome",
"nance-horan syndrome  mondo:0010545",
"nanophthalmos 2",
"nanophthalmos 4",
"narcolepsy 1",
"narcolepsy 7",
"nasopharyngeal carcinoma, somatic",
"nasopharyngeal carcinoma, susceptibility to, 3",
"naxos disease",
"nemaline myopathy  mondo:0018958",
"nemaline myopathy 1, autosomal dominant or recessive",
"nemaline myopathy 10",
"nemaline myopathy 10  mondo:0014513",
"nemaline myopathy 11, autosomal recessive",
"nemaline myopathy 2  mondo:0009725",
"nemaline myopathy 2, autosomal recessive",
"nemaline myopathy 3, autosomal dominant or recessive",
"nemaline myopathy 4, autosomal dominant",
"nemaline myopathy 5  mondo:0011539",
"nemaline myopathy 5, amish type",
"nemaline myopathy 6  mondo:0012237",
"nemaline myopathy 6, autosomal dominant",
"nemaline myopathy 7  mondo:0012538",
"nemaline myopathy 7, autosomal recessive",
"nemaline myopathy 8  mondo:0014138",
"nemaline myopathy 8, autosomal recessive",
"nemaline myopathy 9",
"nemaline myopathy 9  mondo:0014326",
"neonatal encephalopathy with non-epileptic myoclonus  mondo:0100456",
"neonatal severe primary hyperparathyroidism  mondo:0009397",
"neonatal-onset developmental and epileptic encephalopathy  mondo:0100455",
"neonatal-onset encephalopathy with rigidity and seizures  mondo:0013784",
"nephrogenic syndrome of inappropriate antidiuresis",
"nephrolithiasis, calcium oxalate",
"nephrolithiasis, type i",
"nephrolithiasis, uric acid, susceptibility to",
"nephrolithiasis/osteoporosis, hypophosphatemic, 1",
"nephronophthisis  mondo:0019005",
"nephronophthisis 1  mondo:0009728",
"nephronophthisis 1, juvenile",
"nephronophthisis 11",
"nephronophthisis 12",
"nephronophthisis 12  mondo:0013442",
"nephronophthisis 13",
"nephronophthisis 14",
"nephronophthisis 15",
"nephronophthisis 16",
"nephronophthisis 16  mondo:0014158",
"nephronophthisis 18",
"nephronophthisis 19",
"nephronophthisis 2  mondo:0011190",
"nephronophthisis 2, infantile",
"nephronophthisis 20",
"nephronophthisis 20  mondo:0014997",
"nephronophthisis 3",
"nephronophthisis 4",
"nephronophthisis 4  mondo:0011752",
"nephronophthisis 7",
"nephronophthisis 7  mondo:0012680",
"nephronophthisis 9",
"nephronophthisis like nephropathy 1",
"nephronophthisis-like nephropathy 1  mondo:0013163",
"nephropathy due to cfhr5 deficiency",
"nephropathy with pretibial epidermolysis bullosa and deafness",
"nephrotic syndrome, type 1",
"nephrotic syndrome, type 10",
"nephrotic syndrome, type 11",
"nephrotic syndrome, type 12",
"nephrotic syndrome, type 13",
"nephrotic syndrome, type 14",
"nephrotic syndrome, type 15",
"nephrotic syndrome, type 16",
"nephrotic syndrome, type 17",
"nephrotic syndrome, type 18",
"nephrotic syndrome, type 18  mondo:0032581",
"nephrotic syndrome, type 19",
"nephrotic syndrome, type 2",
"nephrotic syndrome, type 20",
"nephrotic syndrome, type 20  mondo:0026726",
"nephrotic syndrome, type 21",
"nephrotic syndrome, type 22",
"nephrotic syndrome, type 23",
"nephrotic syndrome, type 24",
"nephrotic syndrome, type 3",
"nephrotic syndrome, type 3  mondo:0012546",
"nephrotic syndrome, type 4",
"nephrotic syndrome, type 5, with or without ocular abnormalities",
"nephrotic syndrome, type 6",
"nephrotic syndrome, type 7",
"nephrotic syndrome, type 8",
"nephrotic syndrome, type 9",
"nescav syndrome",
"nestor guillermo progeria syndrome",
"nestor-guillermo progeria syndrome  mondo:0013523",
"netherton syndrome",
"neu laxova syndrome 1",
"neu laxova syndrome 2",
"neural tube defects",
"neural tube defects, folate sensitive, susceptibility to",
"neural tube defects, susceptibility to",
"neuralgic amyotrophy  mondo:0017362",
"neuroblastoma with hirschsprung disease",
"neuroblastoma, susceptibility to, 1",
"neuroblastoma, susceptibility to, 2",
"neuroblastoma, susceptibility to, 3",
"neuroblastoma, susceptibility to, 3  mondo:0013083",
"neurocutaneous melanosis, somatic",
"neurodegeneration due to cerebral folate transport deficiency",
"neurodegeneration with ataxia and late onset optic atrophy",
"neurodegeneration with ataxia, dystonia, and gaze palsy, childhood onset",
"neurodegeneration with brain iron accumulation 1",
"neurodegeneration with brain iron accumulation 2b",
"neurodegeneration with brain iron accumulation 3",
"neurodegeneration with brain iron accumulation 4",
"neurodegeneration with brain iron accumulation 4  mondo:0013674",
"neurodegeneration with brain iron accumulation 5",
"neurodegeneration with brain iron accumulation 6",
"neurodegeneration with brain iron accumulation 7",
"neurodegeneration with brain iron accumulation 8",
"neurodegeneration, childhood onset, hypotonia, respiratory insufficiency and brain imaging abnormalities",
"neurodegeneration, childhood onset, stress induced, with variable ataxia and seizures",
"neurodegeneration, childhood onset, with ataxia, tremor, optic atrophy, and cognitive decline",
"neurodegeneration, childhood onset, with brain atrophy",
"neurodegeneration, childhood onset, with cerebellar atrophy",
"neurodegeneration, childhood-onset, with hypotonia, respiratory insufficiency, and brain imaging abnormalities  mondo:0030947",
"neurodegeneration, early onset, with choreoathetoid movements and microcytic anemia",
"neurodegeneration, infantile onset, biotin responsive",
"neurodegenerative disease  mondo:0005559",
"neurodegenerative syndrome due to cerebral folate transport deficiency  mondo:0013110",
"neurodevelopmental disorder and language delay with or without structural brain abnormalities",
"neurodevelopmental disorder and structural brain anomalies with or without seizures and spasticity",
"neurodevelopmental disorder with absent language and variable seizures",
"neurodevelopmental disorder with ataxia, hypotonia, and microcephaly",
"neurodevelopmental disorder with ataxic gait, absent speech, and decreased cortical white matter",
"neurodevelopmental disorder with behavioral abnormalities, absent speech, and hypotonia",
"neurodevelopmental disorder with brain anomalies and with or without vertebral or cardiac anomalies",
"neurodevelopmental disorder with brain anomalies, seizures, and scoliosis",
"neurodevelopmental disorder with cardiomyopathy, spasticity, and brain abnormalities",
"neurodevelopmental disorder with cardiomyopathy, spasticity, and brain abnormalities  mondo:0030866",
"neurodevelopmental disorder with cataracts, poor growth, and dysmorphic facies",
"neurodevelopmental disorder with central and peripheral motor dysfunction",
"neurodevelopmental disorder with cerebellar atrophy and motor dysfunction  mondo:0859152",
"neurodevelopmental disorder with cerebellar atrophy and with or without seizures",
"neurodevelopmental disorder with cerebellar atrophy and with or without seizures  mondo:0020841",
"neurodevelopmental disorder with cerebellar hypoplasia and spasticity",
"neurodevelopmental disorder with cerebral atrophy and variable facial dysmorphism",
"neurodevelopmental disorder with coarse facies and mild distal skeletal abnormalities",
"neurodevelopmental disorder with dysmorphic facies and distal limb anomalies",
"neurodevelopmental disorder with dysmorphic facies and distal skeletal anomalies",
"neurodevelopmental disorder with dysmorphic facies and variable seizures",
"neurodevelopmental disorder with dysmorphic facies, impaired speech and hypotonia",
"neurodevelopmental disorder with epilepsy and hypoplasia of the corpus callosum",
"neurodevelopmental disorder with epilepsy, cataracts, feeding difficulties, and delayed brain myelination",
"neurodevelopmental disorder with epilepsy, spasticity, and brain atrophy",
"neurodevelopmental disorder with epilepsy, spasticity, and brain atrophy  mondo:0032894",
"neurodevelopmental disorder with hypotonia and autistic features with or without hyperkinetic movements",
"neurodevelopmental disorder with hypotonia and cerebellar atrophy, with or without seizures",
"neurodevelopmental disorder with hypotonia and variable intellectual and behavioral abnormalities",
"neurodevelopmental disorder with hypotonia and variable intellectual and behavioral abnormalities  mondo:0032829",
"neurodevelopmental disorder with hypotonia, facial dysmorphism, and brain abnormalities  mondo:0859165",
"neurodevelopmental disorder with hypotonia, impaired expressive language, and with or without seizures",
"neurodevelopmental disorder with hypotonia, microcephaly, and seizures",
"neurodevelopmental disorder with hypotonia, neonatal respiratory insufficiency, and thermodysregulation",
"neurodevelopmental disorder with hypotonia, neuropathy, and deafness",
"neurodevelopmental disorder with hypotonia, neuropathy, and deafness  mondo:0060496",
"neurodevelopmental disorder with hypotonia, seizures, and absent language",
"neurodevelopmental disorder with impaired intellectual development, hypotonia, and ataxia",
"neurodevelopmental disorder with impaired speech and hyperkinetic movements",
"neurodevelopmental disorder with involuntary movements",
"neurodevelopmental disorder with language impairment and behavioral abnormalities",
"neurodevelopmental disorder with language impairment and behavioral abnormalities  mondo:0030060",
"neurodevelopmental disorder with microcephaly and gray sclerae",
"neurodevelopmental disorder with microcephaly and spastic paraplegia",
"neurodevelopmental disorder with microcephaly and structural brain anomalies",
"neurodevelopmental disorder with microcephaly, arthrogryposis, and structural brain anomalies",
"neurodevelopmental disorder with microcephaly, ataxia, and seizures",
"neurodevelopmental disorder with microcephaly, ataxia, and seizures  mondo:0060577",
"neurodevelopmental disorder with microcephaly, cataracts, and renal abnormalities",
"neurodevelopmental disorder with microcephaly, cortical malformations, and spasticity",
"neurodevelopmental disorder with microcephaly, epilepsy, and brain atrophy",
"neurodevelopmental disorder with microcephaly, epilepsy, and hypomyelination",
"neurodevelopmental disorder with microcephaly, hypotonia, and variable brain anomalies",
"neurodevelopmental disorder with microcephaly, impaired language, and gait abnormalities  mondo:0100348",
"neurodevelopmental disorder with microcephaly, impaired language, and gait abnormalities, autosomal recessive",
"neurodevelopmental disorder with microcephaly, impaired language, epilepsy, and gait abnormalities  mondo:0030837",
"neurodevelopmental disorder with microcephaly, impaired language, epilepsy, and gait abnormalities, autosomal dominant",
"neurodevelopmental disorder with microcephaly, seizures, and brain atrophy",
"neurodevelopmental disorder with microcephaly, seizures, and cortical atrophy",
"neurodevelopmental disorder with microcephaly, seizures, and cortical atrophy  mondo:0060621",
"neurodevelopmental disorder with midbrain and hindbrain malformations",
"neurodevelopmental disorder with motor and speech delay and behavioral abnormalities",
"neurodevelopmental disorder with movement abnormalities, abnormal gait, and autistic features",
"neurodevelopmental disorder with nonspecific brain abnormalities and with or without seizures",
"neurodevelopmental disorder with nonspecific brain abnormalities and with or without seizures  mondo:0032877",
"neurodevelopmental disorder with or without anomalies of the brain, eye, or heart",
"neurodevelopmental disorder with or without autism or seizures",
"neurodevelopmental disorder with or without autistic features and/or structural brain abnormalities",
"neurodevelopmental disorder with or without early onset generalized epilepsy",
"neurodevelopmental disorder with or without hyperkinetic movements and seizures, autosomal dominant",
"neurodevelopmental disorder with or without hyperkinetic movements and seizures, autosomal recessive",
"neurodevelopmental disorder with or without seizures and gait abnormalities",
"neurodevelopmental disorder with or without seizures and gait abnormalities  mondo:0060641",
"neurodevelopmental disorder with or without variable brain abnormalities",
"neurodevelopmental disorder with or without variable brain abnormalities; nedba  mondo:0032755",
"neurodevelopmental disorder with poor language and loss of hand skills",
"neurodevelopmental disorder with progressive microcephaly, spasticity, and brain abnormalities",
"neurodevelopmental disorder with progressive microcephaly, spasticity, and brain anomalies",
"neurodevelopmental disorder with progressive spasticity and brain white matter abnormalities",
"neurodevelopmental disorder with regression, abnormal movements, loss of speech, and seizures",
"neurodevelopmental disorder with seizures and brain atrophy",
"neurodevelopmental disorder with seizures and nonepileptic hyperkinetic movements",
"neurodevelopmental disorder with seizures and speech and walking impairment",
"neurodevelopmental disorder with seizures, hypotonia, and brain abnormalities",
"neurodevelopmental disorder with seizures, spasticity, and complete or partial agenesis of the corpus callosum",
"neurodevelopmental disorder with severe motor impairment and absent language",
"neurodevelopmental disorder with spastic diplegia and visual defects",
"neurodevelopmental disorder with spastic quadriplegia and brain abnormalities with or without seizures",
"neurodevelopmental disorder with spastic quadriplegia, optic atrophy, seizures, and structural brain anomalies",
"neurodevelopmental disorder with spasticity and poor growth",
"neurodevelopmental disorder with spasticity, cataracts, and cerebellar hypoplasia  mondo:0859137",
"neurodevelopmental disorder with speech impairment and dysmorphic facies",
"neurodevelopmental disorder with structural brain anomalies and dysmorphic facies",
"neurodevelopmental disorder with visual defects and brain anomalies",
"neurodevelopmental disorder wtih dysmorphic facies, sleep disturbance, and brain abnormalities",
"neurodevelopmental disorder, mitochondrial, with abnormal movements and lactic acidosis, with or without seizures",
"neurodevelopmental disorder-craniofacial dysmorphism-cardiac defect-hip dysplasia syndrome  mondo:0018681",
"neurodevelopmental, jaw, eye, and digital syndrome",
"neuroepithelioma",
"neurofacioskeletal syndrome with or without renal agenesis",
"neurofibromatosis noonan syndrome",
"neurofibromatosis type 1  mondo:0018975",
"neurofibromatosis type 2  mondo:0007039",
"neurofibromatosis, familial spinal",
"neurofibromatosis, type 1",
"neurofibromatosis, type 2",
"neurofibrosarcoma, somatic",
"neurometabolic disorder due to serine deficiency  mondo:0018162",
"neuromuscular disease  mondo:0019056",
"neuromuscular disease and ocular or auditory anomalies with or without seizures",
"neuromuscular disease, congenital, with uniform type 1 fiber",
"neuromyotonia and axonal neuropathy, autosomal recessive",
"neuronal ceroid lipofuscinosis  mondo:0016295",
"neuronal intranuclear inclusion disease",
"neuronopathy, distal hereditary motor  obsolete termmondo:0000075",
"neuronopathy, distal hereditary motor, autosomal dominant  mondo:0015362",
"neuronopathy, distal hereditary motor, type 7a  mondo:0008024",
"neuronopathy, distal hereditary motor, type iia",
"neuronopathy, distal hereditary motor, type iib",
"neuronopathy, distal hereditary motor, type iic",
"neuronopathy, distal hereditary motor, type iid",
"neuronopathy, distal hereditary motor, type ix",
"neuronopathy, distal hereditary motor, type va",
"neuronopathy, distal hereditary motor, type vb",
"neuronopathy, distal hereditary motor, type vi",
"neuronopathy, distal hereditary motor, type viia",
"neuronopathy, distal hereditary motor, type viib",
"neuronopathy, distal hereditary motor, type viii",
"neuroocular syndrome  mondo:0859193",
"neurooculocardiogenitourinary syndrome",
"neuropathy, distal hereditary motor, type vc",
"neuropathy, hereditary motor and sensory, russe type",
"neuropathy, hereditary motor and sensory, type 6b  mondo:0014671",
"neuropathy, hereditary motor and sensory, type vib",
"neuropathy, hereditary motor and sensory, type vic, with optic atrophy",
"neuropathy, hereditary motor, with myopathic features",
"neuropathy, hereditary sensory and autonomic, type 1c  mondo:0013337",
"neuropathy, hereditary sensory and autonomic, type 2a  mondo:0024309",
"neuropathy, hereditary sensory and autonomic, type ia",
"neuropathy, hereditary sensory and autonomic, type ic",
"neuropathy, hereditary sensory and autonomic, type ii",
"neuropathy, hereditary sensory and autonomic, type iib",
"neuropathy, hereditary sensory and autonomic, type iid",
"neuropathy, hereditary sensory and autonomic, type v",
"neuropathy, hereditary sensory and autonomic, type vi",
"neuropathy, hereditary sensory and autonomic, type vii",
"neuropathy, hereditary sensory and autonomic, type viii",
"neuropathy, hereditary sensory, type 1d  mondo:0013381",
"neuropathy, hereditary sensory, type 1f  mondo:0014286",
"neuropathy, hereditary sensory, type id",
"neuropathy, hereditary sensory, type ie",
"neuropathy, hereditary sensory, type if",
"neuropathy, hereditary sensory, type iic",
"neuropathy, hereditary sensory, with spastic paraplegia",
"neuropathy, hereditary, with or without age related macular degeneration",
"neuropathy, inflammatory demyelinating",
"neuropathy, recurrent, with pressure palsies",
"neutral lipid storage disease with myopathy",
"neutral lipid storage myopathy  mondo:0012545",
"neutropenia  mondo:0001475",
"neutropenia, cyclic",
"neutropenia, nonimmune chronic idiopathic, of adults",
"neutropenia, severe congenital 1, autosomal dominant",
"neutropenia, severe congenital 2, autosomal dominant",
"neutropenia, severe congenital 3, autosomal recessive",
"neutropenia, severe congenital 4, autosomal recessive",
"neutropenia, severe congenital, 5, autosomal recessive",
"neutropenia, severe congenital, 6, autosomal recessive",
"neutropenia, severe congenital, 7, autosomal recessive",
"neutropenia, severe congenital, 8, autosomal dominant",
"neutropenia, severe congenital, x linked",
"neutrophil immunodeficiency syndrome  mondo:0011988",
"neutrophilic dermatosis, acute febrile",
"nevoid basal cell carcinoma syndrome  mondo:0007187",
"nevus comedonicus, somatic",
"nevus sebaceous or woolly hair nevus, somatic",
"nevus, epidermal, somatic",
"newfoundland rod cone dystrophy",
"nicolaides baraitser syndrome",
"nicotine addiction, protection from",
"nicotine addiction, susceptibility to",
"nicotine dependence, protection against",
"nicotine dependence, susceptibility to",
"niemann pick disease, type a",
"niemann pick disease, type b",
"niemann pick disease, type c1",
"niemann pick disease, type c2",
"niemann pick disease, type d",
"niemann-pick disease, type c1  mondo:0009757",
"niemann-pick disease, type c2  mondo:0011873",
"night blindness, congenital stationary complete, 1a, x linked",
"night blindness, congenital stationary complete, 1b, autosomal recessive",
"night blindness, congenital stationary complete, 1c, autosomal recessive",
"night blindness, congenital stationary complete, 1d, autosomal recessive",
"night blindness, congenital stationary complete, 1e, autosomal recessive",
"night blindness, congenital stationary complete, 1f, autosomal recessive",
"night blindness, congenital stationary incomplete, 2a, x linked",
"night blindness, congenital stationary, autosomal dominant 1",
"night blindness, congenital stationary, autosomal dominant 2",
"night blindness, congenital stationary, autosomal dominant 3",
"night blindness, congenital stationary, type 1g",
"night blindness, congenital stationary, type 1h",
"night blindness, congenital stationary, type 1i",
"nijmegen breakage syndrome",
"nijmegen breakage syndrome  mondo:0009623",
"nijmegen breakage syndrome like disorder",
"nik deficiency  mondo:0018642",
"nivelon nivelon mabille syndrome",
"nizon isidor syndrome",
"nkx2-1 related choreoathetosis and congenital hypothyroidism with or without pulmonary dysfunction  mondo:0100520",
"nkx2.5-related congenital, conduction and myopathic heart disease  mondo:0800441",
"nmnat1-related retinopathy  mondo:0800101",
"nog-related symphalangism spectrum disorder  mondo:0100521",
"non-severe combined immunodeficiency due to copg1 deficiency  mondo:0800136",
"non-severe combined immunodeficiency due to polymerase delta deficiency  mondo:0800145",
"non-small cell lung carcinoma  mondo:0005233",
"non-syndromic intellectual disability  mondo:0000509",
"non-syndromic x-linked intellectual disability  mondo:0019181",
"nonaka myopathy",
"nonarteritic anterior ischemic optic neuropathy, susceptibility to",
"nonsmall cell lung cancer, response to tyrosine kinase inhibitor in",
"nonsmall cell lung cancer, somatic",
"nonsmall cell lung cancer, susceptibility to",
"nonsyndromic genetic hearing loss  mondo:0019497",
"noonan syndrome  mondo:0018997",
"noonan syndrome 1",
"noonan syndrome 10",
"noonan syndrome 11",
"noonan syndrome 12",
"noonan syndrome 13",
"noonan syndrome 2",
"noonan syndrome 3",
"noonan syndrome 4",
"noonan syndrome 5",
"noonan syndrome 6",
"noonan syndrome 7",
"noonan syndrome 8",
"noonan syndrome 9",
"noonan syndrome like disorder with loose anagen hair 2",
"noonan syndrome like disorder with or without juvenile myelomonocytic leukemia",
"noonan syndrome like with loose anagen hair 1",
"noonan syndrome with multiple lentigines  mondo:0007893",
"noonan syndrome-like disorder with loose anagen hair  mondo:0011899",
"nor polyagglutination syndrome",
"normal pressure hydrocephalus  mondo:0009366",
"norrie disease",
"norrie disease  mondo:0010691",
"norum disease",
"norwalk virus infection, resistance to",
"nr2f2 related multiple congenital anomalies/dysmorphic syndrome  mondo:0800458",
"nthl1-deficiency tumor predisposition syndrome  mondo:0100502",
"nystagmus 1, congenital, x linked",
"nystagmus 6, congenital, x linked",
"nystagmus, infantile periodic alternating, x linked",
"nyx-related retinopathy  mondo:0800407",
"obesity bmiq20",
"obesity with impaired prohormone processing",
"obesity, adrenal insufficiency, and red hair due to pomc deficiency",
"obesity, association with",
"obesity, early onset, susceptibility to",
"obesity, hyperphagia, and developmental delay",
"obesity, late onset",
"obesity, mild, early onset",
"obesity, morbid, due to leptin deficiency",
"obesity, morbid, due to leptin receptor deficiency",
"obesity, resistance to",
"obesity, resistance to bmiq20",
"obesity, severe",
"obesity, severe, and type ii diabetes",
"obesity, severe, susceptibility to, bmiq9",
"obesity, susceptibility to",
"obesity, susceptibility to, bmiq12",
"obesity, susceptibility to, bmiq14",
"obesity, susceptibility to, bmiq18",
"obesity, susceptibility to, bmiq19",
"obesity, susceptibility to, bmiq4",
"obsessive compulsive disorder",
"obsessive compulsive disorder, susceptibility to",
"occipital horn syndrome",
"occult macular dystrophy",
"ocular albinism, type i, nettleship falls type",
"ocular dysgenesis caused by defects in pax6 regulation  mondo:0700246",
"oculoauricular syndrome",
"oculoauricular syndrome  mondo:0012802",
"oculocerebrofacial syndrome, kaufman type  mondo:0009485",
"oculocerebrorenal syndrome  mondo:0010645",
"oculocutaneous albinism type 1  mondo:0018135",
"oculocutaneous albinism type 2  mondo:0008746",
"oculocutaneous albinism, type viii",
"oculodentodigital dysplasia",
"oculodentodigital dysplasia, autosomal recessive",
"oculoectodermal syndrome, somatic",
"oculomotor abducens synkinesis",
"oculopharyngeal muscular dystrophy",
"oculopharyngeal myopathy with leukoencephalopathy 1",
"oculopharyngodistal myopathy 1",
"oculopharyngodistal myopathy 1  mondo:0020793",
"oculopharyngodistal myopathy 2",
"oculoskeletodental syndrome",
"odonnell luria rodan syndrome",
"odontochondrodysplasia 1",
"odontohypophosphatasia",
"odontoonychodermal dysplasia",
"ogden syndrome",
"oguchi disease  mondo:0019152",
"oguchi disease 1",
"oguchi disease 2",
"ohdo syndrome, x linked",
"okt4 epitope deficiency",
"okur chung neurodevelopmental syndrome",
"oligodontia colorectal cancer syndrome",
"oligodontia-cancer predisposition syndrome  mondo:0012075",
"oliver mcfarlane syndrome",
"olmsted syndrome 1",
"olmsted syndrome 2",
"olmsted syndrome, x linked",
"omenn syndrome",
"omeprazole poor metabolizer",
"omodysplasia 1",
"omodysplasia 2",
"ondontochondrodysplasia 2 with hearing loss and diabetes",
"oocyte maturation defect 1",
"oocyte maturation defect 10",
"oocyte maturation defect 2",
"oocyte maturation defect 3",
"oocyte maturation defect 4",
"oocyte maturation defect 5",
"oocyte maturation defect 6",
"oocyte maturation defect 7",
"oocyte maturation defect 8",
"oocyte maturation defect 9",
"opa1-related optic atrophy with or without extraocular features  mondo:0800181",
"open-angle glaucoma  mondo:0005338",
"ophthalmoplegia, external, with rib and vertebral anomalies",
"opitz gbbb syndrome, type i",
"opitz gbbb syndrome, type ii",
"opitz kaveggia syndrome",
"opsismodysplasia",
"optic atrophy 1",
"optic atrophy 10 with or without ataxia, mental retardation, and seizures",
"optic atrophy 11",
"optic atrophy 12",
"optic atrophy 12  mondo:0033549",
"optic atrophy 13 with retinal and foveal abnormalities",
"optic atrophy 13 with retinal and foveal abnormalities  mondo:0008135",
"optic atrophy 3  mondo:0008133",
"optic atrophy 3 with cataract",
"optic atrophy 5",
"optic atrophy 7",
"optic atrophy 9",
"optic atrophy plus syndrome",
"optic disc anomalies with retinal and/or macular dystrophy",
"optic nerve hypoplasia",
"optic nerve hypoplasia and abnormalities of the central nervous system",
"organophosphate poisoning, sensitivity to",
"ornithine aminotransferase deficiency  mondo:0009796",
"ornithine carbamoyltransferase deficiency  mondo:0010703",
"ornithine transcarbamylase deficiency",
"ornithine translocase deficiency  mondo:0009393",
"orofacial cleft 10",
"orofacial cleft 11",
"orofacial cleft 15",
"orofacial cleft 5",
"orofacial cleft 6",
"orofacial cleft 7",
"orofacial cleft 8",
"orofaciodigital syndrome i",
"orofaciodigital syndrome iv",
"orofaciodigital syndrome type 14  mondo:0014413",
"orofaciodigital syndrome v",
"orofaciodigital syndrome vi",
"orofaciodigital syndrome xiv",
"orofaciodigital syndrome xv",
"orofaciodigital syndrome xvi",
"orofaciodigital syndrome xvii",
"orofaciodigital syndrome xviii",
"orotic aciduria",
"orthostatic hypotension 1, due to dbh deficiency",
"orthostatic hypotension 2",
"orthostatic intolerance",
"osseous heteroplasia, progressive",
"osteoarthritis 5",
"osteoarthritis susceptibility 1",
"osteoarthritis susceptibility 2",
"osteoarthritis susceptibility 3",
"osteoarthritis with mild chondrodysplasia",
"osteochondrodysplasia, brachydactyly, and overlapping malformed digits",
"osteochondrodysplasia, complex lethal, symoens barnes gistelinck type",
"osteofibrous dysplasia, susceptibility to",
"osteogenesis imperfecta 21",
"osteogenesis imperfecta type 1  mondo:0008146",
"osteogenesis imperfecta type 2  mondo:0008147",
"osteogenesis imperfecta type 3  mondo:0009804",
"osteogenesis imperfecta type 4  mondo:0008148",
"osteogenesis imperfecta, type i",
"osteogenesis imperfecta, type ii",
"osteogenesis imperfecta, type iii",
"osteogenesis imperfecta, type iv",
"osteogenesis imperfecta, type ix",
"osteogenesis imperfecta, type v",
"osteogenesis imperfecta, type vi",
"osteogenesis imperfecta, type vii",
"osteogenesis imperfecta, type viii",
"osteogenesis imperfecta, type x",
"osteogenesis imperfecta, type xi",
"osteogenesis imperfecta, type xii",
"osteogenesis imperfecta, type xiii",
"osteogenesis imperfecta, type xiv",
"osteogenesis imperfecta, type xix",
"osteogenesis imperfecta, type xv",
"osteogenesis imperfecta, type xvi",
"osteogenesis imperfecta, type xvii",
"osteogenesis imperfecta, type xviii",
"osteogenesis imperfecta, type xx",
"osteoglophonic dwarfism  mondo:0008150",
"osteoglophonic dysplasia",
"osteolysis, familial expansile",
"osteopathia striata with cranial sclerosis",
"osteopathia striata with cranial sclerosis  mondo:0010310",
"osteopetrosis, autosomal dominant 1",
"osteopetrosis, autosomal dominant 2",
"osteopetrosis, autosomal dominant 3",
"osteopetrosis, autosomal dominant 3  mondo:0020848",
"osteopetrosis, autosomal recessive 1",
"osteopetrosis, autosomal recessive 2",
"osteopetrosis, autosomal recessive 3, with renal tubular acidosis",
"osteopetrosis, autosomal recessive 4",
"osteopetrosis, autosomal recessive 5",
"osteopetrosis, autosomal recessive 6",
"osteopetrosis, autosomal recessive 7",
"osteopetrosis, autosomal recessive 8",
"osteopoikilosis with or without melorheostosis",
"osteoporosis",
"osteoporosis pseudoglioma syndrome",
"osteoporosis, early onset, susceptibility to, autosomal dominant",
"osteoporosis, postmenopausal",
"osteoporosis, postmenopausal, susceptibility",
"osteoporosis, susceptibility to",
"osteosarcoma",
"osteosarcoma, somatic",
"osteosclerosis",
"otitis media, susceptibility to",
"otofaciocervical syndrome",
"otofaciocervical syndrome 2",
"otofaciocervical syndrome 2  mondo:0014254",
"otopalatodigital syndrome, type i",
"otopalatodigital syndrome, type ii",
"otospondylomegaepiphyseal dysplasia  mondo:0008975",
"otospondylomegaepiphyseal dysplasia, autosomal dominant",
"otospondylomegaepiphyseal dysplasia, autosomal recessive",
"ovalocytosis, sa type",
"ovarian cancer, somatic",
"ovarian carcinoma",
"ovarian dysgenesis 1",
"ovarian dysgenesis 2",
"ovarian dysgenesis 3",
"ovarian dysgenesis 4",
"ovarian dysgenesis 5",
"ovarian dysgenesis 6",
"ovarian dysgenesis 7",
"ovarian dysgenesis 8",
"ovarian hyperstimulation syndrome",
"ovarian response to fsh stimulation",
"ovarioleukodystrophy",
"overgrowth syndrome and/or cerebral malformations due to abnormalities in mtor pathway genes  mondo:0100283",
"overhydrated hereditary stomatocytosis",
"p5cs deficiency  mondo:0100126",
"pachygyria, microcephaly, developmental delay, and dysmorphic facies, with or without seizures",
"pachyonychia congenita 1",
"pachyonychia congenita 2",
"pachyonychia congenita 3",
"pachyonychia congenita 4",
"paganini miozzo syndrome",
"paget disease of bone 2, early onset",
"paget disease of bone 3",
"paget disease of bone 5, juvenile onset",
"paget disease of bone 6",
"palb2-related cancer predisposition  mondo:0700272",
"pallister hall like syndrome",
"pallister hall syndrome",
"palmoplantar carcinoma, multiple self healing",
"palmoplantar hyperkeratosis and true hermaphroditism",
"palmoplantar hyperkeratosis with squamous cell carcinoma of skin and sex reversal",
"palmoplantar keratoderma and woolly hair",
"palmoplantar keratoderma with congenital alopecia",
"palmoplantar keratoderma, bothnian type",
"palmoplantar keratoderma, epidermolytic",
"palmoplantar keratoderma, nagashima type",
"palmoplantar keratoderma, nonepidermolytic",
"palmoplantar keratoderma, nonepidermolytic, focal",
"palmoplantar keratoderma, nonepidermolytic, focal 2",
"palmoplantar keratoderma, nonepidermolytic, focal or diffuse",
"palmoplantar keratoderma-esophageal carcinoma syndrome  mondo:0007856",
"pancreatic agenesis 1",
"pancreatic agenesis 1  mondo:0024547",
"pancreatic agenesis 2",
"pancreatic agenesis and congenital heart defects",
"pancreatic and cerebellar agenesis",
"pancreatic cancer 2",
"pancreatic cancer, somatic",
"pancreatic cancer, susceptibility to, 1",
"pancreatic cancer, susceptibility to, 3",
"pancreatic cancer, susceptibility to, 4",
"pancreatic cancer, susceptibility to, 5",
"pancreatic carcinoma, somatic",
"pancreatic lipase deficiency",
"pancreatitis, chronic, protection against",
"pancreatitis, chronic, susceptibility to",
"pancreatitis, hereditary",
"pancytopenia due to ikzf1 mutations  mondo:0014810",
"panhypopituitarism, x linked",
"panic disorder, susceptibility to",
"papillary renal cell carcinoma  mondo:0017884",
"papillon lefevre syndrome",
"papillorenal syndrome",
"paraganglioma and gastric stromal sarcoma",
"paragangliomas 1, with or without deafness",
"paragangliomas 2",
"paragangliomas 3",
"paragangliomas 4",
"paragangliomas 5",
"paragangliomas 6",
"paragangliomas 7",
"paramyotonia congenita",
"parastremmatic dwarfism",
"parathyroid adenoma with cystic changes",
"parathyroid adenoma, somatic",
"parathyroid carcinoma",
"parietal foramina  mondo:0018953",
"parietal foramina 1",
"parietal foramina 2",
"parietal foramina with cleidocranial dysplasia",
"parkinson disease  mondo:0005180",
"parkinson disease 1",
"parkinson disease 11",
"parkinson disease 13",
"parkinson disease 14, autosomal recessive",
"parkinson disease 15, autosomal recessive",
"parkinson disease 17",
"parkinson disease 18",
"parkinson disease 19a, juvenile onset",
"parkinson disease 19b, early onset",
"parkinson disease 20, early onset",
"parkinson disease 22, autosomal dominant",
"parkinson disease 23, autosomal recessive, early onset",
"parkinson disease 4",
"parkinson disease 5, susceptibility to",
"parkinson disease 6, early onset",
"parkinson disease 7, autosomal recessive early onset",
"parkinson disease 8",
"parkinson disease, age of onset, modifier",
"parkinson disease, juvenile, type 2",
"parkinson disease, late onset, susceptibility to",
"parkinson disease, susceptibility to",
"parkinsonism dystonia, infantile, 1",
"parkinsonism dystonia, infantile, 2",
"parkinsonism with spasticity, x linked",
"paroxysmal extreme pain disorder",
"paroxysmal nocturnal hemoglobinuria 2",
"paroxysmal nocturnal hemoglobinuria, somatic",
"paroxysmal nonkinesigenic dyskinesia 1",
"paroxysmal nonkinesigenic dyskinesia, 3, with or without generalized epilepsy",
"partington syndrome",
"patent ductus arteriosus 2",
"patent ductus arteriosus 3",
"pax5-related b lymphopenia and autism spectrum disorder  mondo:0100299",
"pax6-related ocular dysgenesis  mondo:0800183",
"pcare-related retinopathy  mondo:0800404",
"pcwh syndrome",
"peeling skin syndrome 1",
"peeling skin syndrome 2",
"peeling skin syndrome 3",
"peeling skin syndrome 4",
"peeling skin syndrome 5",
"peeling skin syndrome 6",
"peeling skin with leukonychia, acral punctate keratoses, cheilitis, and knuckle pads",
"peho syndrome",
"peho syndrome like",
"pelger huet anomaly",
"pelger huet anomaly with mild skeletal anomalies",
"pelizaeus merzbacher disease",
"pelizeaus-merzbacher spectrum disorder  mondo:0010714",
"pendred syndrome",
"pendred syndrome  mondo:0010134",
"pentosuria",
"pepck deficiency, mitochondrial",
"perching syndrome",
"periodic fever, familial",
"periodic fever, immunodeficiency, and thrombocytopenia syndrome",
"periodic fever, menstrual cycle dependent",
"periodontitis 1, juvenile",
"peripheral neuropathy, autosomal recessive, with or without impaired intellectual development",
"peripheral neuropathy, autosomal recessive, with or without impaired intellectual development  mondo:0029131",
"peripheral neuropathy, myopathy, hoarseness, and hearing loss",
"periventricular heterotopia with microcephaly",
"periventricular heterotopia with microcephaly, autosomal recessive  mondo:0011966",
"periventricular nodular heterotopia  mondo:0020341",
"periventricular nodular heterotopia 6",
"periventricular nodular heterotopia 7",
"periventricular nodular heterotopia 7  mondo:0014966",
"periventricular nodular heterotopia 8",
"periventricular nodular heterotopia 9",
"perlman syndrome",
"perlman syndrome  mondo:0009965",
"peroxisomal acyl coa oxidase deficiency",
"peroxisomal acyl-coa oxidase deficiency  mondo:0009919",
"peroxisomal fatty acyl coa reductase 1 disorder",
"peroxisome biogenesis disorder  mondo:0019234",
"peroxisome biogenesis disorder 10a zellweger",
"peroxisome biogenesis disorder 10b",
"peroxisome biogenesis disorder 11a zellweger",
"peroxisome biogenesis disorder 11b",
"peroxisome biogenesis disorder 12a zellweger",
"peroxisome biogenesis disorder 13a zellweger",
"peroxisome biogenesis disorder 14b",
"peroxisome biogenesis disorder 1a zellweger",
"peroxisome biogenesis disorder 1b nald/ird",
"peroxisome biogenesis disorder 2a zellweger",
"peroxisome biogenesis disorder 2b",
"peroxisome biogenesis disorder 3a zellweger",
"peroxisome biogenesis disorder 3b",
"peroxisome biogenesis disorder 4a zellweger",
"peroxisome biogenesis disorder 4b",
"peroxisome biogenesis disorder 5a zellweger",
"peroxisome biogenesis disorder 5b",
"peroxisome biogenesis disorder 6a zellweger",
"peroxisome biogenesis disorder 6b",
"peroxisome biogenesis disorder 7a zellweger",
"peroxisome biogenesis disorder 7b",
"peroxisome biogenesis disorder 8a zellweger",
"peroxisome biogenesis disorder 8b",
"peroxisome biogenesis disorder 9b",
"perrault syndrome  mondo:0017312",
"perrault syndrome 1",
"perrault syndrome 2",
"perrault syndrome 2  mondo:0013972",
"perrault syndrome 3",
"perrault syndrome 3  mondo:0013588",
"perrault syndrome 4",
"perrault syndrome 5",
"perrault syndrome 6",
"perry syndrome",
"persistent hyperplastic primary vitreous, autosomal recessive",
"persistent mullerian duct syndrome, type i",
"persistent mullerian duct syndrome, type ii",
"persistent truncus arteriosus",
"peters plus syndrome",
"peutz jeghers syndrome",
"peutz-jeghers syndrome  mondo:0008280",
"pfeiffer syndrome",
"pfeiffer syndrome  mondo:0007043",
"pfeiffer syndrome type 1  mondo:0019659",
"pgm1-congenital disorder of glycosylation  mondo:0013968",
"pharc syndrome  mondo:0012984",
"phelan mcdermid syndrome",
"phelan-mcdermid syndrome  mondo:0011652",
"phenylketonuria",
"phenylketonuria  mondo:0009861",
"phenylthiocarbamide tasting",
"pheochromocytoma",
"pheochromocytoma, modifier of",
"pheochromocytoma, susceptibility to",
"phip-related behavioral problems-intellectual disability-obesity-dysmorphic features syndrome  mondo:0035133",
"phosphoenolpyruvate carboxykinase deficiency, cytosolic",
"phosphoglycerate dehydrogenase deficiency",
"phosphoglycerate kinase 1 deficiency",
"phosphohydroxylysinuria",
"phosphohydroxylysinuria  mondo:0014008",
"phosphoribosylpyrophosphate synthetase superactivity",
"phosphoribosylpyrophosphate synthetase superactivity  mondo:0010395",
"phosphorylase kinase deficiency of liver and muscle, autosomal recessive",
"phosphoserine aminotransferase deficiency",
"phosphoserine phosphatase deficiency",
"phytanoyl-coa hydroxylase deficiency  mondo:0100258",
"pick disease",
"pidermolysis bullosa, junctional 7, with interstitial lung disease and nephrotic syndrome  mondo:0013881",
"piebaldism",
"pierpont syndrome",
"pierson syndrome",
"piezo1-related generalized lymphatic dysplasia with non-immune hydrops fetalis  mondo:0035474",
"pigmentary disorder, reticulate, with systemic manifestations, x linked",
"pigmented nodular adrenocortical disease, primary, 1",
"pigmented nodular adrenocortical disease, primary, 2",
"pigmented nodular adrenocortical disease, primary, 3",
"pigmented paravenous chorioretinal atrophy",
"pilarowski bjornsson syndrome",
"pilomatricoma, somatic",
"pitt hopkins like syndrome 1",
"pitt hopkins like syndrome 2",
"pitt hopkins syndrome",
"pitt-hopkins syndrome  mondo:0012589",
"pituitary adenoma 1, multiple types",
"pituitary adenoma 2, gh secreting",
"pituitary adenoma 3, multiple types, somatic",
"pituitary adenoma 4, acth secreting, somatic",
"pituitary adenoma 5, multiple types",
"pituitary adenoma predisposition",
"pituitary adenoma, acth secreting, somatic",
"pituitary hormone deficiency, combined, 1",
"pituitary hormone deficiency, combined, 2",
"pituitary hormone deficiency, combined, 3",
"pituitary hormone deficiency, combined, 4",
"pituitary hormone deficiency, combined, 5",
"pituitary hormone deficiency, combined, 6",
"pituitary tumor, invasive",
"pityriasis rubra pilaris",
"pla2g6-associated neurodegeneration  mondo:0017998",
"placental abruption",
"placental lactogen deficiency",
"plasma triglyceride level qtl, low",
"plasminogen activator inhibitor 1 deficiency",
"plasminogen deficiency, type i",
"platelet abnormalities with eosinophilia and immune-mediated inflammatory disease  mondo:0060583",
"platelet activating factor acetylhydrolase deficiency",
"platelet disorder, familial, with associated myeloid malignancy",
"platelet glycoprotein iv deficiency",
"platelet plc beta 2 deficiency",
"platelet-type bleeding disorder 11  mondo:0013623",
"platelet-type bleeding disorder 12  mondo:0011588",
"platelet-type bleeding disorder 15  mondo:0014078",
"platelet-type bleeding disorder 16  mondo:0008552",
"platelet-type bleeding disorder 17  mondo:0008553",
"platelet-type bleeding disorder 18  mondo:0014386",
"platelet-type bleeding disorder 19  mondo:0014518",
"platelet-type bleeding disorder 20  mondo:0014830",
"platelet-type bleeding disorder 8  mondo:0012354",
"platelet-type von willebrand disease  mondo:0008332",
"platyspondylic dysplasia, torrance type  mondo:0007895",
"platyspondylic skeletal dysplasia, torrance type",
"pleuropulmonary blastoma",
"pmm2-congenital disorder of glycosylation  mondo:0008907",
"pneumothorax, primary spontaneous",
"pnpla6-related spastic paraplegia with or without ataxia  mondo:0100149",
"poikiloderma with neutropenia",
"poikiloderma, hereditary fibrosing, with tendon contractures, myopathy, and pulmonary fibrosis",
"poirier bienvenu neurodevelopmental syndrome",
"poirier-bienvenu neurodevelopmental syndrome  mondo:0032889",
"pold1-related polyposis and colorectal cancer syndrome  mondo:0100351",
"pole-related polyposis and colorectal cancer syndrome  mondo:0100287",
"polr3a-related disorder  mondo:0700276",
"polycystic kidney disease  mondo:0020642",
"polycystic kidney disease 1",
"polycystic kidney disease 2",
"polycystic kidney disease 3",
"polycystic kidney disease 3 with or without polycystic liver disease  mondo:0010916",
"polycystic kidney disease 4, with or without hepatic disease",
"polycystic kidney disease 5",
"polycystic kidney disease 6 with or without polycystic liver disease",
"polycystic lipomembranous osteodysplasia with sclerosing leukoencephalopathy 1",
"polycystic lipomembranous osteodysplasia with sclerosing leukoencephalopathy 2",
"polycystic liver disease 1",
"polycystic liver disease 1  mondo:0008265",
"polycystic liver disease 2",
"polycystic liver disease 2  mondo:0014860",
"polycystic liver disease 3 with or without kidney cysts",
"polycystic liver disease 3 with or without kidney cysts  mondo:0054743",
"polycystic liver disease 4 with or without kidney cysts",
"polycythemia vera, somatic",
"polydactyly, postaxial, type a10",
"polydactyly, postaxial, type a6",
"polydactyly, postaxial, type a7",
"polydactyly, postaxial, type a8",
"polydactyly, postaxial, type a9",
"polydactyly, postaxial, types a1 and b",
"polydactyly, preaxial i",
"polydactyly, preaxial type ii",
"polydactyly, preaxial, type iv",
"polyendocrine polyneuropathy syndrome",
"polyglucosan body disease, adult form",
"polyglucosan body myopathy 1 with or without immunodeficiency",
"polyglucosan body myopathy 2",
"polyglucosan body myopathy type 2  mondo:0014526",
"polyhydramnios, megalencephaly, and symptomatic epilepsy",
"polymicrogyria with optic nerve hypoplasia  mondo:0013172",
"polymicrogyria with or without vascular type eds",
"polymicrogyria, bilateral frontoparietal",
"polymicrogyria, bilateral perisylvian",
"polymicrogyria, bilateral temporooccipital",
"polymicrogyria, perisylvian, with cerebellar hypoplasia and arthrogryposis",
"polyneuropathy, hearing loss, ataxia, retinitis pigmentosa, and cataract",
"polyposis syndrome, hereditary mixed, 2",
"polyposis, juvenile intestinal",
"pontocerebellar hypoplasia type 1a",
"pontocerebellar hypoplasia type 2a",
"pontocerebellar hypoplasia type 2b",
"pontocerebellar hypoplasia type 2c",
"pontocerebellar hypoplasia type 2d",
"pontocerebellar hypoplasia type 4",
"pontocerebellar hypoplasia type 5",
"pontocerebellar hypoplasia, hypotonia, and respiratory insufficiency syndrome, neonatal lethal",
"pontocerebellar hypoplasia, type 10",
"pontocerebellar hypoplasia, type 11",
"pontocerebellar hypoplasia, type 12",
"pontocerebellar hypoplasia, type 13",
"pontocerebellar hypoplasia, type 1b",
"pontocerebellar hypoplasia, type 1c",
"pontocerebellar hypoplasia, type 1d",
"pontocerebellar hypoplasia, type 2e",
"pontocerebellar hypoplasia, type 2f",
"pontocerebellar hypoplasia, type 3",
"pontocerebellar hypoplasia, type 6",
"pontocerebellar hypoplasia, type 7",
"pontocerebellar hypoplasia, type 8",
"pontocerebellar hypoplasia, type 9",
"popliteal pterygium syndrome 1",
"popliteal pterygium syndrome, bartsocas papas type",
"poretti boltshauser syndrome",
"porokeratosis 1, multiple types",
"porokeratosis 3, multiple types",
"porokeratosis 7, multiple types",
"porokeratosis 8, disseminated superficial actinic type",
"porokeratosis 9, multiple types",
"porphyria cutanea tarda",
"porphyria cutanea tarda, susceptibility to",
"porphyria due to ala dehydratase deficiency  mondo:0013000",
"porphyria variegata",
"porphyria variegata, susceptibility to",
"porphyria, acute hepatic",
"porphyria, acute intermittent",
"porphyria, acute intermittent, nonerythroid variant",
"porphyria, congenital erythropoietic",
"porphyria, hepatoerythropoietic",
"portal hypertension, noncirrhotic",
"prader willi syndrome",
"precocious puberty, central, 1",
"precocious puberty, central, 2",
"precocious puberty, male",
"preeclampsia, susceptibility to",
"preeclampsia/eclampsia 4",
"preeclampsia/eclampsia 5",
"pregnancy loss, recurrent, 4",
"pregnancy loss, recurrent, susceptibility to, 1",
"pregnancy loss, recurrent, susceptibility to, 2",
"pregnancy loss, recurrent, susceptibility to, 3",
"preimplantation embryonic lethality",
"preimplantation embryonic lethality 2",
"premature aging syndrome, penttinen type",
"premature chromatid separation trait",
"premature ovarian failure 1",
"premature ovarian failure 10",
"premature ovarian failure 11",
"premature ovarian failure 12",
"premature ovarian failure 13",
"premature ovarian failure 14",
"premature ovarian failure 15",
"premature ovarian failure 16",
"premature ovarian failure 17",
"premature ovarian failure 18",
"premature ovarian failure 19",
"premature ovarian failure 2a",
"premature ovarian failure 2b",
"premature ovarian failure 3",
"premature ovarian failure 4",
"premature ovarian failure 5",
"premature ovarian failure 6",
"premature ovarian failure 7",
"premature ovarian failure 8",
"premature ovarian failure 9",
"preterm premature rupture of the membranes, susceptibility to",
"primary aldosteronism, seizures, and neurologic abnormalities",
"primary angle-closure glaucoma  mondo:0001868",
"primary ciliary dyskinesia  mondo:0016575",
"primary ciliary dyskinesia 1  mondo:0009484",
"primary ciliary dyskinesia 10  mondo:0012918",
"primary ciliary dyskinesia 11  mondo:0012978",
"primary ciliary dyskinesia 12  mondo:0012979",
"primary ciliary dyskinesia 13  mondo:0013174",
"primary ciliary dyskinesia 14  mondo:0013434",
"primary ciliary dyskinesia 15  mondo:0013435",
"primary ciliary dyskinesia 16  mondo:0013525",
"primary ciliary dyskinesia 17  mondo:0013854",
"primary ciliary dyskinesia 18  mondo:0013940",
"primary ciliary dyskinesia 19  mondo:0013979",
"primary ciliary dyskinesia 2  mondo:0011718",
"primary ciliary dyskinesia 20  mondo:0014030",
"primary ciliary dyskinesia 22  mondo:0014192",
"primary ciliary dyskinesia 23  mondo:0014193",
"primary ciliary dyskinesia 24  mondo:0014202",
"primary ciliary dyskinesia 25  mondo:0014203",
"primary ciliary dyskinesia 26  mondo:0014211",
"primary ciliary dyskinesia 27  mondo:0014215",
"primary ciliary dyskinesia 28  mondo:0014216",
"primary ciliary dyskinesia 29  mondo:0014378",
"primary ciliary dyskinesia 3  mondo:0012085",
"primary ciliary dyskinesia 30  mondo:0014465",
"primary ciliary dyskinesia 32  mondo:0014657",
"primary ciliary dyskinesia 35  mondo:0014910",
"primary ciliary dyskinesia 5  mondo:0012088",
"primary ciliary dyskinesia 6  mondo:0012571",
"primary ciliary dyskinesia 7  mondo:0012748",
"primary ciliary dyskinesia 9  mondo:0012906",
"primary congenital glaucoma  mondo:0000365",
"primary hyperoxaluria type 3  mondo:0013327",
"primary immunodeficiency with natural-killer cell deficiency and adrenal insufficiency  mondo:0012383",
"primary lateral sclerosis, juvenile",
"primrose syndrome",
"primrose syndrome  mondo:0009798",
"prkag2-related cardiomyopathy  mondo:0800484",
"progesterone resistance",
"progressive encephalopathy with leukodystrophy due to decr deficiency  mondo:0014464",
"progressive external ophthalmoplegia with mitochondrial dna deletions, autosomal dominant 2",
"progressive external ophthalmoplegia with mitochondrial dna deletions, autosomal dominant 3",
"progressive external ophthalmoplegia with mitochondrial dna deletions, autosomal dominant 4",
"progressive external ophthalmoplegia with mitochondrial dna deletions, autosomal dominant 5",
"progressive external ophthalmoplegia with mitochondrial dna deletions, autosomal dominant 6",
"progressive external ophthalmoplegia with mitochondrial dna deletions, autosomal recessive 2",
"progressive external ophthalmoplegia with mitochondrial dna deletions, autosomal recessive 3",
"progressive external ophthalmoplegia with mitochondrial dna deletions, autosomal recessive 4",
"progressive external ophthalmoplegia with mitochondrial dna deletions, autosomal recessive 5",
"progressive external ophthalmoplegia, autosomal dominant 1",
"progressive external ophthalmoplegia, autosomal recessive 1",
"progressive familial heart block, type ib",
"progressive familial intrahepatic cholestasis type 3  mondo:0011214",
"progressive muscular dystrophy  mondo:0016106",
"progressive myoclonus epilepsy  mondo:0020074",
"progressive pseudorheumatoid arthropathy of childhood  mondo:0008827",
"progressive pseudorheumatoid dysplasia",
"proguanil poor metabolizer",
"prolidase deficiency",
"proliferative vasculopathy and hydranencephaly hydrocephaly syndrome",
"properdin deficiency, x linked",
"propionic acidemia  mondo:0011628",
"propionicacidemia",
"prostate cancer",
"prostate cancer 1",
"prostate cancer, familial, susceptibility to",
"prostate cancer, hereditary, 12",
"prostate cancer, hereditary, 13",
"prostate cancer, hereditary, 2, susceptibility to",
"prostate cancer, hereditary, 9",
"prostate cancer, somatic",
"prostate cancer, susceptibility to",
"prostate cancer/brain cancer susceptibility, somatic",
"proteasome associated autoinflammatory syndrome 1 and digenic forms",
"proteasome associated autoinflammatory syndrome 2",
"proteasome associated autoinflammatory syndrome 3 and digenic forms",
"proteasome associated autoinflammatory syndrome 3, digenic",
"proteasome associated autoinflammatory syndrome 4",
"proteasome associated autoinflammatory syndrome 5",
"protein z deficiency",
"proteinuria, chronic benign",
"proteinuria, low molecular weight, with hypercalciuric nephrocalcinosis",
"proteus syndrome, somatic",
"protoporphyria, erythropoietic, 1",
"protoporphyria, erythropoietic, 1  mondo:0008319",
"protoporphyria, erythropoietic, 2",
"protoporphyria, erythropoietic, x linked",
"proud syndrome",
"proximal myopathy and ophthalmoplegia",
"prpf31-related retinopathy  mondo:0800395",
"prps1 deficiency disorder  mondo:0100061",
"prune belly syndrome",
"pseudo torch syndrome 1",
"pseudo torch syndrome 2",
"pseudo torch syndrome 3",
"pseudoachondroplasia",
"pseudoachondroplasia  mondo:0008322",
"pseudofolliculitis barbae, susceptibility to",
"pseudohermaphroditism, male, with gynecomastia",
"pseudohyperaldosteronism type 2  mondo:0011517",
"pseudohyperkalemia, familial, 2, due to red cell leak",
"pseudohypoaldosteronism type 2e  mondo:0013782",
"pseudohypoaldosteronism type i, autosomal dominant",
"pseudohypoaldosteronism, type i",
"pseudohypoaldosteronism, type iib",
"pseudohypoaldosteronism, type iic",
"pseudohypoaldosteronism, type iid",
"pseudohypoaldosteronism, type iie",
"pseudohypoparathyroidism ia",
"pseudohypoparathyroidism ib",
"pseudohypoparathyroidism ic",
"pseudohypoparathyroidism, type ib",
"pseudomonas aeruginosa, susceptibility to chronic infection by, in cystic fibrosis",
"pseudopseudohypoparathyroidism",
"pseudovaginal perineoscrotal hypospadias",
"pseudoxanthoma elasticum",
"pseudoxanthoma elasticum like disorder with multiple coagulation factor deficiency",
"pseudoxanthoma elasticum, forme fruste",
"pseudoxanthoma elasticum, modifier of severity of",
"psoriasis 14, pustular",
"psoriasis 15, pustular, susceptibility to",
"psoriasis 2",
"psoriasis susceptibility 1",
"psoriasis susceptibility 13",
"psoriasis, protection against",
"psoriatic arthritis, susceptibility to",
"psychomotor retardation, epilepsy, and craniofacial dysmorphism",
"pten hamartoma tumor syndrome  mondo:0017623",
"pterin-4 alpha-carbinolamine dehydratase 1 deficiency  mondo:0009908",
"ptosis, congenital",
"pulmonary alveolar microlithiasis",
"pulmonary arterial hypertension  mondo:0015924",
"pulmonary disease, chronic obstructive, susceptibility to",
"pulmonary fibrosis and/or bone marrow failure, telomere related, 1",
"pulmonary fibrosis and/or bone marrow failure, telomere related, 3",
"pulmonary fibrosis and/or bone marrow failure, telomere related, 4",
"pulmonary fibrosis and/or bone marrow failure, telomere related, 5",
"pulmonary fibrosis and/or bone marrow failure, telomere-related, 4  mondo:0014612",
"pulmonary fibrosis and/or bone marrow failure, telomere-related, 5  mondo:0032865",
"pulmonary fibrosis, idiopathic",
"pulmonary fibrosis, idiopathic, susceptibility to",
"pulmonary hypertension, familial primary, 1, with or without hht",
"pulmonary hypertension, neonatal, susceptibility to",
"pulmonary hypertension, primary, 2",
"pulmonary hypertension, primary, 3",
"pulmonary hypertension, primary, 4",
"pulmonary hypertension, primary, fenfluramine or dexfenfluramine associated",
"pulmonary veno-occlusive disease and/or pulmonary capillary haemangiomatosis  mondo:0018554",
"pulmonary venoocclusive disease 1",
"pulmonary venoocclusive disease 2",
"purpura, posttransfusion",
"pycnodysostosis",
"pycnodysostosis  mondo:0009940",
"pyle disease",
"pyogenic sterile arthritis, pyoderma gangrenosum, and acne",
"pyridoxal phosphate-responsive seizures  mondo:0012407",
"pyridoxamine 5 phosphate oxidase deficiency",
"pyridoxine-dependent epilepsy  mondo:0009945",
"pyropoikilocytosis",
"pyruvate carboxylase deficiency",
"pyruvate dehydrogenase e1 alpha deficiency",
"pyruvate dehydrogenase e1 beta deficiency",
"pyruvate dehydrogenase e2 deficiency",
"pyruvate dehydrogenase e3 deficiency  mondo:0009529",
"pyruvate dehydrogenase phosphatase deficiency",
"pyruvate kinase deficiency",
"pyruvate kinase deficiency of red cells  mondo:0009950",
"qualitative or quantitative defects of alpha-dystroglycan  mondo:0018282",
"qualitative platelet defect  mondo:0001197",
"quebec platelet disorder",
"quebec platelet disorder  mondo:0011136",
"question mark ears, isolated",
"rab23-related carpenter syndrome  mondo:0008710",
"rab28-related retinopathy  mondo:0100448",
"rabson mendenhall syndrome",
"rad51c-related cancer predisposition  mondo:0700273",
"rad51d-related cancer predisposition  mondo:0700274",
"radio-tartaglia syndrome  mondo:0859143",
"radioulnar synostosis with amegakaryocytic thrombocytopenia 1",
"radioulnar synostosis with amegakaryocytic thrombocytopenia 1  mondo:0024558",
"radioulnar synostosis with amegakaryocytic thrombocytopenia 2",
"radioulnar synostosis, nonsyndromic",
"rafiq syndrome",
"rahman syndrome",
"raine syndrome",
"rajab interstitial lung disease with brain calcifications 1",
"rajab interstitial lung disease with brain calcifications 2",
"rapadilino syndrome",
"rapid progression to aids from hiv1 infection",
"rapp hodgkin syndrome",
"ras associated autoimmune leukoproliferative disorder",
"ras associated autoimmune lymphoproliferative syndrome type iv, somatic",
"rasopathy  mondo:0021060",
"raynaud claes syndrome",
"rcbtb1-related retinopathy  mondo:0014955",
"rd3-related retinopathy  mondo:0700235",
"rdh12-related recessive retinopathy  mondo:0800099",
"rdh5-related retinopathy  mondo:0100443",
"recessive dystrophic epidermolysis bullosa  mondo:0009179",
"recombinase activating gene 1 deficiency  mondo:0000572",
"recombinase activating gene 2 deficiency  mondo:0000573",
"recombination rate qtl 1",
"recurrent infections associated with rare immunoglobulin isotypes deficiency  mondo:0013576",
"reducing body myopathy, x linked 1a, severe, infantile or early childhood onset",
"reducing body myopathy, x linked 1b, with late childhood or adult onset",
"refsum disease",
"regressive spondylometaphyseal dysplasia  mondo:0018663",
"renal carcinoma, chromophobe, somatic",
"renal cell carcinoma",
"renal cell carcinoma, clear cell, somatic",
"renal cell carcinoma, papillary",
"renal cell carcinoma, papillary, 1",
"renal cell carcinoma, papillary, 1, familial and somatic",
"renal cell carcinoma, somatic",
"renal cysts and diabetes syndrome",
"renal cysts and diabetes syndrome  mondo:0007669",
"renal dysplasia, cystic, susceptibility to",
"renal glucosuria",
"renal hepatic pancreatic dysplasia 1",
"renal hepatic pancreatic dysplasia 2",
"renal hypodysplasia/aplasia 1",
"renal hypodysplasia/aplasia 2",
"renal hypodysplasia/aplasia 3",
"renal hypomagnesemia 2  mondo:0007937",
"renal tubular acidosis, distal, 2, with progressive sensorineural hearing loss  mondo:0009968",
"renal tubular acidosis, proximal, with ocular abnormalities",
"renal tubular dysgenesis",
"renal tubular dysgenesis of genetic origin  mondo:0009970",
"renal-hepatic-pancreatic dysplasia 2  mondo:0014174",
"renpenning syndrome",
"renpenning syndrome  mondo:0010653",
"resistance to malaria due to g6pd deficiency",
"respiratory papillomatosis, juvenile recurrent, congenital",
"restrictive dermopathy, lethal",
"reticular dysgenesis",
"reticular dysgenesis  mondo:0009973",
"reticulate acropigmentation of kitamura",
"retinal arterial macroaneurysm with supravalvular pulmonic stenosis",
"retinal arteries, tortuosity of",
"retinal cone dystrophy 3",
"retinal cone dystrophy 3b",
"retinal cone dystrophy 4",
"retinal degeneration, autosomal recessive, clumped pigment type",
"retinal degeneration, late onset, autosomal dominant",
"retinal disease in usher syndrome type iia, modifier of",
"retinal dystrophy and iris coloboma with or without cataract",
"retinal dystrophy and obesity",
"retinal dystrophy with inner retinal dysfunction and ganglion cell abnormalities",
"retinal dystrophy with leukodystrophy",
"retinal dystrophy with macular staphyloma",
"retinal dystrophy with or without extraocular anomalies",
"retinal dystrophy, early onset severe",
"retinal dystrophy, early onset, with or without pituitary dysfunction",
"retinal dystrophy, iris coloboma, and comedogenic acne syndrome",
"retinal dystrophy, juvenile cataracts, and short stature syndrome",
"retinal dystrophy-ataxia-pituitary hormone abnormality-hypogonadism syndrome  mondo:0100155",
"retinitis pigmentosa 1",
"retinitis pigmentosa 10",
"retinitis pigmentosa 11",
"retinitis pigmentosa 12",
"retinitis pigmentosa 13",
"retinitis pigmentosa 14",
"retinitis pigmentosa 18",
"retinitis pigmentosa 19",
"retinitis pigmentosa 2",
"retinitis pigmentosa 20",
"retinitis pigmentosa 23",
"retinitis pigmentosa 25",
"retinitis pigmentosa 26",
"retinitis pigmentosa 27",
"retinitis pigmentosa 28",
"retinitis pigmentosa 3",
"retinitis pigmentosa 30",
"retinitis pigmentosa 31",
"retinitis pigmentosa 32",
"retinitis pigmentosa 33",
"retinitis pigmentosa 35",
"retinitis pigmentosa 36",
"retinitis pigmentosa 37",
"retinitis pigmentosa 38",
"retinitis pigmentosa 39",
"retinitis pigmentosa 4, autosomal dominant or recessive",
"retinitis pigmentosa 40",
"retinitis pigmentosa 41",
"retinitis pigmentosa 42",
"retinitis pigmentosa 43",
"retinitis pigmentosa 44",
"retinitis pigmentosa 45",
"retinitis pigmentosa 46",
"retinitis pigmentosa 47",
"retinitis pigmentosa 48",
"retinitis pigmentosa 49",
"retinitis pigmentosa 50",
"retinitis pigmentosa 51",
"retinitis pigmentosa 54",
"retinitis pigmentosa 55",
"retinitis pigmentosa 56",
"retinitis pigmentosa 57",
"retinitis pigmentosa 58",
"retinitis pigmentosa 59",
"retinitis pigmentosa 60",
"retinitis pigmentosa 61",
"retinitis pigmentosa 62",
"retinitis pigmentosa 65",
"retinitis pigmentosa 66",
"retinitis pigmentosa 67",
"retinitis pigmentosa 68",
"retinitis pigmentosa 69",
"retinitis pigmentosa 7 and digenic form",
"retinitis pigmentosa 7, digenic form",
"retinitis pigmentosa 70",
"retinitis pigmentosa 71",
"retinitis pigmentosa 72",
"retinitis pigmentosa 73",
"retinitis pigmentosa 74",
"retinitis pigmentosa 75",
"retinitis pigmentosa 76",
"retinitis pigmentosa 77",
"retinitis pigmentosa 78",
"retinitis pigmentosa 79",
"retinitis pigmentosa 80",
"retinitis pigmentosa 81",
"retinitis pigmentosa 83",
"retinitis pigmentosa 84",
"retinitis pigmentosa 85",
"retinitis pigmentosa 86",
"retinitis pigmentosa 87 with choroidal involvement",
"retinitis pigmentosa 88",
"retinitis pigmentosa 89",
"retinitis pigmentosa 9",
"retinitis pigmentosa 90",
"retinitis pigmentosa 94, variable age at onset  mondo:0800328",
"retinitis pigmentosa and erythrocytic microcytosis",
"retinitis pigmentosa with or without situs inversus",
"retinitis pigmentosa with or without situs inversus  mondo:0014186",
"retinitis pigmentosa with or without skeletal anomalies",
"retinitis pigmentosa, concentric",
"retinitis pigmentosa, juvenile",
"retinitis pigmentosa, juvenile, autosomal recessive",
"retinitis pigmentosa, x linked, and sinorespiratory infections, with or without deafness",
"retinitis punctata albescens",
"retinoblastoma",
"retinoblastoma  mondo:0008380",
"retinoblastoma, trilateral",
"retinopathy of prematurity",
"retinoschisis",
"rett syndrome",
"rett syndrome  mondo:0010726",
"rett syndrome, atypical",
"rett syndrome, congenital variant",
"rett syndrome, preserved speech variant",
"revesz syndrome",
"reynolds syndrome",
"rft1-congenital disorder of glycosylation  mondo:0012783",
"rh negative blood type",
"rh null disease, amorph type",
"rhabdoid tumor predisposition syndrome 1",
"rhabdoid tumor predisposition syndrome 1  mondo:0012252",
"rhabdoid tumor predisposition syndrome 2",
"rhabdoid tumor predisposition syndrome 2  mondo:0013224",
"rhabdoid tumors, somatic",
"rhabdomyosarcoma 2, alveolar",
"rhabdomyosarcoma, alveolar",
"rhabdomyosarcoma, embryonal, 2",
"rhabdomyosarcoma, somatic",
"rheumatoid arthritis, progression of",
"rheumatoid arthritis, susceptibility to",
"rheumatoid arthritis, systemic juvenile",
"rheumatoid arthritis, systemic juvenile, susceptibility to",
"rhizomelic chondrodysplasia punctata, type 1",
"rhizomelic chondrodysplasia punctata, type 2",
"rhizomelic chondrodysplasia punctata, type 3",
"rhizomelic chondrodysplasia punctata, type 5",
"rhizomelic limb shortening with dysmorphic features",
"rhyns syndrome",
"riboflavin deficiency",
"ribose 5 phosphate isomerase deficiency",
"rickets due to defect in vitamin d 25 hydroxylation deficiency",
"rickets, vitamin d resistant, type iia",
"riddle syndrome",
"riddle syndrome  mondo:0012764",
"right atrial isomerism ivemark",
"rigidity and multifocal seizure syndrome, lethal neonatal",
"rin2 syndrome  mondo:0013115",
"ring dermoid of cornea",
"rippling muscle disease 2",
"ritscher schinzel syndrome 1",
"ritscher schinzel syndrome 2",
"ritscher schinzel syndrome 3",
"ritscher-schinzel syndrome 1  mondo:0009073",
"ritscher-schinzel syndrome 2  mondo:0010499",
"rlbp1-related retinopathy  mondo:0100444",
"rnaseh2a-related type 1 interferonopathy  mondo:0700259",
"rnaseh2c-related type 1 interferonopathy  mondo:0700258",
"rnu4atac spectrum disorder  mondo:0100558",
"roberts sc phocomelia syndrome",
"roberts-sc phocomelia syndrome  mondo:0100253",
"robin sequence with cleft mandible and limb anomalies",
"robinow sorauf syndrome",
"robinow syndrome, autosomal dominant 1",
"robinow syndrome, autosomal dominant 2",
"robinow syndrome, autosomal dominant 3",
"robinow syndrome, autosomal recessive",
"robinow syndrome, autosomal recessive 2",
"roifman syndrome",
"rolandic epilepsy, mental retardation, and speech dyspraxia",
"rosah syndrome",
"rothmund thomson syndrome, type 1",
"rothmund thomson syndrome, type 2",
"rothmund-thomson syndrome  mondo:0010002",
"rothmund-thomson syndrome type 1  mondo:0016368",
"roussy levy syndrome",
"rp1-related dominant retinopathy  mondo:0800400",
"rp1-related recessive retinopathy  mondo:0800399",
"rp2-related retinopathy  mondo:0100442",
"rpe65-related dominant retinopathy  mondo:0100452",
"rpe65-related recessive retinopathy  mondo:0100368",
"rpgr-related retinopathy  mondo:0100437",
"rubinstein taybi syndrome 1",
"rubinstein taybi syndrome 2",
"rubinstein-taybi syndrome  mondo:0019188",
"rubinstein-taybi syndrome due to ep300 haploinsufficiency  mondo:0013364",
"ruijs aalfs syndrome",
"ryr1-related myopathy  mondo:0100150",
"sacral agenesis with vertebral anomalies",
"saddan",
"saethre chotzen syndrome",
"saethre chotzen syndrome with or without eyelid anomalies",
"saethre-chotzen syndrome  mondo:0007042",
"salih myopathy",
"salla disease",
"salt and pepper developmental regression syndrome",
"samhd1-related type 1 interferonopathy  mondo:0700260",
"sandestig stefanova syndrome",
"sandhoff disease  mondo:0010006",
"sandhoff disease, infantile, juvenile, and adult forms",
"sarcoidosis, susceptibility to, 1",
"sarcoidosis, susceptibility to, 2",
"sarcoma, synovial",
"sarcosinemia",
"sarcosinemia  mondo:0010008",
"sars, progression of",
"satb2 associated disorder  mondo:0100147",
"saul wilson syndrome",
"sbbyss syndrome",
"scalp ear nipple syndrome",
"scaphocephaly and axenfeld rieger anomaly",
"scaphocephaly, maxillary retrusion, and mental retardation",
"scapuloperoneal myopathy, x linked dominant",
"scapuloperoneal spinal muscular atrophy",
"scapuloperoneal syndrome, myopathic type",
"scapuloperoneal syndrome, neurogenic, kaeser type",
"schaaf yang syndrome",
"schaaf-yang syndrome  mondo:0014243",
"schimke immuno-osseous dysplasia  mondo:0009458",
"schimke immunoosseous dysplasia",
"schimmelpenning feuerstein mims syndrome, somatic mosaic",
"schindler disease, type i",
"schindler disease, type iii",
"schinzel giedion midface retraction syndrome",
"schinzel-giedion syndrome  mondo:0010010",
"schizencephaly",
"schizophrenia",
"schizophrenia 15",
"schizophrenia 19, susceptibility to",
"schizophrenia 9, susceptibility to",
"schizophrenia susceptibility 18",
"schizophrenia, susceptibility to",
"schizophrenia, susceptibility to, 17",
"schizophrenia, susceptibility to, 4",
"schmid metaphyseal chondrodysplasia  mondo:0007983",
"schneckenbecken dysplasia",
"schopf schulz passarge syndrome",
"schuurs hoeijmakers syndrome",
"schuurs-hoeijmakers syndrome  mondo:0014006",
"schwannomatosis 1, susceptibility to",
"schwannomatosis 2, susceptibility to",
"schwannomatosis, somatic",
"schwartz jampel syndrome, type 1",
"schwartz-jampel syndrome type 1  mondo:0100435",
"scid, autosomal recessive, t negative/b positive type",
"sclerosing cholangitis, neonatal",
"sclerosteosis 1",
"sclerosteosis 2",
"scn4a-related myopathy, autosomal recessive  mondo:0100121",
"scott syndrome",
"scott syndrome  mondo:0009885",
"scurvy",
"sea blue histiocyte disease",
"seasonal affective disorder, susceptibility to",
"sebaceous tumors, somatic",
"seborrhea like dermatitis with psoriasiform elements",
"sec61a1 deficiency  mondo:0100337",
"sec61b-related polycystic liver disease  mondo:0550003",
"seckel syndrome 1",
"seckel syndrome 10",
"seckel syndrome 2",
"seckel syndrome 5",
"seckel syndrome 6",
"seckel syndrome 7",
"seckel syndrome 8",
"seckel syndrome 9",
"sed congenita",
"sed, maroteaux type",
"sedoheptulokinase deficiency",
"segawa syndrome, recessive",
"seizures, benign familial infantile, 2",
"seizures, benign familial infantile, 3",
"seizures, benign familial infantile, 5",
"seizures, benign neonatal, 1",
"seizures, benign neonatal, 2",
"seizures, cortical blindness, microcephaly syndrome",
"seizures, early onset, with neurodegeneration and brain calcification",
"seizures, early-onset, with neurodegeneration and brain calcifications  mondo:0030033",
"seizures, scoliosis, and macrocephaly syndrome",
"selenon-related myopathy  mondo:0100100",
"self-limited familial neonatal epilepsy  mondo:0100023",
"sengers syndrome",
"senior loken syndrome 1",
"senior loken syndrome 4",
"senior loken syndrome 5",
"senior loken syndrome 6",
"senior loken syndrome 7",
"senior loken syndrome 8",
"senior loken syndrome 9",
"sensorineural deafness with mild renal dysfunction",
"sepsis, susceptibility to",
"septic shock, susceptibility to",
"septooptic dysplasia",
"serkal syndrome",
"sesame syndrome",
"sessile serrated polyposis cancer syndrome",
"sessile serrated polyposis cancer syndrome  mondo:0014919",
"setd2-related microcephaly-severe intellectual disability-multiple congenital anomalies syndrome  mondo:0035706",
"setd2-related neurodevelopmental disorder without or with macrocephaly/overgrowth  mondo:0800477",
"severe achondroplasia-developmental delay-acanthosis nigricans syndrome  mondo:0014658",
"severe combined immunodeficiency due to ada deficiency",
"severe combined immunodeficiency due to card11 deficiency  mondo:0014081",
"severe combined immunodeficiency due to carmil2 deficiency  mondo:0029134",
"severe combined immunodeficiency due to coro1a deficiency  mondo:0014168",
"severe combined immunodeficiency due to ctps1 deficiency  mondo:0014391",
"severe combined immunodeficiency due to dclre1c deficiency  mondo:0011225",
"severe combined immunodeficiency due to dna-pkcs deficiency  mondo:0014423",
"severe combined immunodeficiency due to ikk2 deficiency  mondo:0014267",
"severe combined immunodeficiency due to lat deficiency  mondo:0044721",
"severe combined immunodeficiency due to lck deficiency  mondo:0014334",
"severe combined immunodeficiency with microcephaly, growth retardation, and sensitivity to ionizing radiation",
"severe combined immunodeficiency, athabascan type",
"severe combined immunodeficiency, autosomal recessive, t cell-negative, b cell-negative, nk cell-negative, due to adenosine deaminase deficiency  mondo:0007064",
"severe combined immunodeficiency, b cell negative",
"severe combined immunodeficiency, t cell negative, b cell/natural killer cell positive",
"severe combined immunodeficiency, t cell negative, b cell/natural killer cell positive type",
"severe combined immunodeficiency, x linked",
"severe intellectual disability-poor language-strabismus-grimacing face-long fingers syndrome  mondo:0014034",
"severe intellectual disability-progressive spastic diplegia syndrome  mondo:0014035",
"severe motor and intellectual disabilities-sensorineural deafness-dystonia syndrome  mondo:0010334",
"sezary syndrome, somatic",
"sf3b4-related acrofacial dysostosis  mondo:0800483",
"shaheen syndrome",
"shashi pena syndrome",
"short chain acyl-coa dehydrogenase deficiency  mondo:0008722",
"short qt syndrome  mondo:0000453",
"short qt syndrome 1",
"short qt syndrome 2",
"short qt syndrome 3",
"short rib thoracic dysplasia 10 with or without polydactyly",
"short rib thoracic dysplasia 11 with or without polydactyly",
"short rib thoracic dysplasia 13 with or without polydactyly",
"short rib thoracic dysplasia 14 with polydactyly",
"short rib thoracic dysplasia 15 with polydactyly",
"short rib thoracic dysplasia 16 with or without polydactyly",
"short rib thoracic dysplasia 17 with or without polydactyly",
"short rib thoracic dysplasia 18 with polydactyly",
"short rib thoracic dysplasia 19 with or without polydactyly",
"short rib thoracic dysplasia 2 with or without polydactyly",
"short rib thoracic dysplasia 20 with polydactyly",
"short rib thoracic dysplasia 3 with or without polydactyly",
"short rib thoracic dysplasia 4 with or without polydactyly",
"short rib thoracic dysplasia 5 with or without polydactyly",
"short rib thoracic dysplasia 6 with or without polydactyly",
"short rib thoracic dysplasia 7 with or without polydactyly",
"short rib thoracic dysplasia 8 with or without polydactyly",
"short rib thoracic dysplasia 9 with or without polydactyly",
"short sleep, familial natural, 1",
"short stature and advanced bone age, with or without early onset osteoarthritis and/or osteochondritis dissecans",
"short stature and microcephaly with genital anomalies",
"short stature with microcephaly and distinctive facies",
"short stature with nonspecific skeletal abnormalities",
"short stature, amelogenesis imperfecta, and skeletal dysplasia with scoliosis",
"short stature, auditory canal atresia, mandibular hypoplasia, skeletal abnormalities",
"short stature, brachydactyly, intellectual developmental disability, and seizures",
"short stature, dauber argente type",
"short stature, developmental delay, and congenital heart defects",
"short stature, facial dysmorphism, and skeletal anomalies with or without cardiac anomalies",
"short stature, facial dysmorphism, and skeletal anomalies with or without cardiac anomalies 1",
"short stature, hearing loss, retinitis pigmentosa, and distinctive facies",
"short stature, idiopathic familial",
"short stature, microcephaly, and endocrine dysfunction",
"short stature, oligodontia, dysmorphic facies, and motor delay",
"short stature, onychodysplasia, facial dysmorphism, and hypotrichosis",
"short stature, optic nerve atrophy, and pelger huet anomaly",
"short stature, rhizomelic, with microcephaly, micrognathia, and developmental delay",
"short syndrome",
"short-rib thoracic dysplasia 7 with or without polydactyly  mondo:0013569",
"short-rib thoracic dysplasia 8 with or without polydactyly  mondo:0014214",
"shprintzen goldberg syndrome",
"shprintzen-goldberg syndrome  mondo:0008426",
"shukla vernon syndrome",
"shukla-vernon syndrome  mondo:0026727",
"shwachman diamond syndrome",
"shwachman diamond syndrome 2",
"shwachman-diamond syndrome  mondo:0009833",
"sialic acid storage disorder, infantile",
"sialidosis  mondo:0017734",
"sialidosis, type i",
"sialidosis, type ii",
"sialuria",
"sick sinus syndrome 1",
"sick sinus syndrome 2",
"sick sinus syndrome 3",
"sickle cell anemia",
"sickle cell disease and related diseases  obsolete termmondo:0017146",
"siddiqi syndrome",
"siddiqi syndrome  mondo:0032842",
"sideroblastic anemia with b cell immunodeficiency, periodic fevers, and developmental delay",
"sifrim hitz weiss syndrome",
"silver russell syndrome 3",
"silver russell syndrome 4",
"silver russell syndrome 5",
"silver spastic paraplegia syndrome",
"silver-russell syndrome 3  mondo:0014663",
"silverman-handmaker type dyssegmental dysplasia  mondo:0009140",
"simpson golabi behmel syndrome, type 1",
"simpson golabi behmel syndrome, type 2",
"simpson-golabi-behmel syndrome  mondo:0010731",
"sin3a-related intellectual disability syndrome  mondo:0044699",
"single median maxillary central incisor",
"singleton merten syndrome 1",
"sinoatrial node dysfunction and deafness",
"sinoatrial node dysfunction and deafness  mondo:0013960",
"sitosterolemia  mondo:0008863",
"sitosterolemia 1",
"sitosterolemia 2",
"sjogren larsson syndrome",
"skeletal defects, genital hypoplasia, and mental retardation",
"skeletal dysplasia, mild, with joint laxity and advanced bone age",
"skeletal muscle glycogen content and metabolism qtl",
"skin fragility woolly hair syndrome",
"skin/hair/eye pigmentation 1, blond/brown hair",
"skin/hair/eye pigmentation 1, blue/nonblue eyes",
"skin/hair/eye pigmentation 10, blond/brown hair",
"skin/hair/eye pigmentation 2, blond hair/fair skin",
"skin/hair/eye pigmentation 2, red hair/fair skin",
"skin/hair/eye pigmentation 3, blue/green eyes",
"skin/hair/eye pigmentation 3, light/dark/freckling skin",
"skin/hair/eye pigmentation 4, fair/dark skin",
"skin/hair/eye pigmentation 5, black/nonblack hair",
"skin/hair/eye pigmentation 5, dark/fair skin",
"skin/hair/eye pigmentation 5, dark/light eyes",
"skin/hair/eye pigmentation 6, blond/brown hair",
"skin/hair/eye pigmentation 6, blue/green eyes",
"skin/hair/eye pigmentation 7, blond/brown hair",
"skin/hair/eye pigmentation 9, brown/nonbrown eyes",
"skin/hair/eye pigmentation 9, dark/light hair",
"skin/hair/eye pigmentation, variation in, 11 melanesian blond hair",
"skin/hair/eye pigmentation, variation in, 8",
"skraban deardorff syndrome",
"skraban-deardorff syndrome  mondo:0054636",
"slc6a3-related dopamine transporter deficiency syndrome  mondo:0700117",
"sleep-related hypermotor epilepsy  mondo:0000030",
"slowed nerve conduction velocity, ad",
"small cell cancer of the lung, somatic",
"small fiber neuropathy",
"smarcc1-associated developmental dysgenesis syndrome  mondo:0700123",
"smed strudwick type",
"smith kingsmore syndrome",
"smith lemli opitz syndrome",
"smith magenis syndrome",
"smith mccort dysplasia",
"smith mccort dysplasia 2",
"smith-lemli-opitz syndrome  mondo:0010035",
"smith-magenis syndrome  mondo:0008434",
"sneddon syndrome",
"snijders blok campeau syndrome",
"snijders blok fisher syndrome",
"snijders blok-campeau syndrome  mondo:0032600",
"snowflake vitreoretinal degeneration",
"snrnp200-related dominant retinopathy  mondo:0800098",
"sodium serum level qtl 1",
"sorbitol dehydrogenase deficiency with peripheral neuropathy",
"sorsby fundus dystrophy",
"sorsby fundus dystrophy  mondo:0007640",
"sotos syndrome  mondo:0019349",
"sotos syndrome 1",
"sotos syndrome 2",
"sotos syndrome 3",
"sox3-related x-linked pituitary hormone deficiency with or without intellectual developmental disorder  mondo:0800474",
"spastic ataxia 1, autosomal dominant",
"spastic ataxia 2, autosomal recessive",
"spastic ataxia 3, autosomal recessive",
"spastic ataxia 4, autosomal recessive",
"spastic ataxia 5, autosomal recessive",
"spastic ataxia 8, autosomal recessive, with hypomyelinating leukodystrophy",
"spastic ataxia 9, autosomal recessive",
"spastic ataxia, charlevoix saguenay type",
"spastic paralysis, infantile onset ascending",
"spastic paraplegia 10, autosomal dominant",
"spastic paraplegia 11, autosomal recessive",
"spastic paraplegia 12, autosomal dominant",
"spastic paraplegia 13, autosomal dominant",
"spastic paraplegia 15, autosomal recessive",
"spastic paraplegia 18, autosomal recessive",
"spastic paraplegia 2, x linked",
"spastic paraplegia 23",
"spastic paraplegia 26, autosomal recessive",
"spastic paraplegia 28, autosomal recessive",
"spastic paraplegia 30, autosomal dominant",
"spastic paraplegia 30, autosomal recessive",
"spastic paraplegia 31, autosomal dominant",
"spastic paraplegia 33, autosomal dominant",
"spastic paraplegia 35, autosomal recessive",
"spastic paraplegia 39, autosomal recessive",
"spastic paraplegia 3a, autosomal dominant",
"spastic paraplegia 4, autosomal dominant",
"spastic paraplegia 42, autosomal dominant",
"spastic paraplegia 43, autosomal recessive",
"spastic paraplegia 44, autosomal recessive",
"spastic paraplegia 45, autosomal recessive",
"spastic paraplegia 46, autosomal recessive",
"spastic paraplegia 47, autosomal recessive",
"spastic paraplegia 48, autosomal recessive",
"spastic paraplegia 49, autosomal recessive",
"spastic paraplegia 50, autosomal recessive",
"spastic paraplegia 51, autosomal recessive",
"spastic paraplegia 52, autosomal recessive",
"spastic paraplegia 53, autosomal recessive",
"spastic paraplegia 54, autosomal recessive",
"spastic paraplegia 55, autosomal recessive",
"spastic paraplegia 56, autosomal recessive",
"spastic paraplegia 57, autosomal recessive",
"spastic paraplegia 5a, autosomal recessive",
"spastic paraplegia 6, autosomal dominant",
"spastic paraplegia 61, autosomal recessive",
"spastic paraplegia 62",
"spastic paraplegia 63",
"spastic paraplegia 64, autosomal recessive",
"spastic paraplegia 7, autosomal recessive",
"spastic paraplegia 72, autosomal dominant",
"spastic paraplegia 72, autosomal recessive",
"spastic paraplegia 73, autosomal dominant",
"spastic paraplegia 74, autosomal recessive",
"spastic paraplegia 75, autosomal recessive",
"spastic paraplegia 76, autosomal recessive",
"spastic paraplegia 77, autosomal recessive",
"spastic paraplegia 78, autosomal recessive",
"spastic paraplegia 79, autosomal recessive",
"spastic paraplegia 8, autosomal dominant",
"spastic paraplegia 80, autosomal dominant",
"spastic paraplegia 81, autosomal recessive",
"spastic paraplegia 82, autosomal recessive",
"spastic paraplegia 83, autosomal recessive",
"spastic paraplegia 87, autosomal recessive",
"spastic paraplegia 9a, autosomal dominant",
"spastic paraplegia 9b, autosomal recessive",
"spastic paraplegia and psychomotor retardation with or without seizures",
"spastic paraplegia, intellectual disability, nystagmus, and obesity",
"spastic paraplegia, intellectual disability, nystagmus, and obesity  mondo:0015007",
"spastic paraplegia, optic atrophy, and neuropathy",
"spastic tetraplegia and axial hypotonia, progressive",
"spastic tetraplegia, thin corpus callosum, and progressive microcephaly",
"spastic tetraplegia-thin corpus callosum-progressive postnatal microcephaly syndrome  mondo:0014725",
"spasticity, childhood onset, with hyperglycinemia",
"specific granule deficiency",
"specific granule deficiency 2",
"specific language disorder  mondo:0016226",
"specific language impairment 5",
"speech language disorder 1",
"spermatocytic seminoma, somatic",
"spermatogenic failure",
"spermatogenic failure 1",
"spermatogenic failure 10",
"spermatogenic failure 11",
"spermatogenic failure 12",
"spermatogenic failure 13",
"spermatogenic failure 14",
"spermatogenic failure 15",
"spermatogenic failure 16",
"spermatogenic failure 17",
"spermatogenic failure 18",
"spermatogenic failure 18  mondo:0054615",
"spermatogenic failure 19",
"spermatogenic failure 19  mondo:0054723",
"spermatogenic failure 20",
"spermatogenic failure 21",
"spermatogenic failure 22",
"spermatogenic failure 23",
"spermatogenic failure 24",
"spermatogenic failure 25",
"spermatogenic failure 26",
"spermatogenic failure 27",
"spermatogenic failure 27  mondo:0054731",
"spermatogenic failure 28",
"spermatogenic failure 29",
"spermatogenic failure 3",
"spermatogenic failure 30",
"spermatogenic failure 31",
"spermatogenic failure 32",
"spermatogenic failure 33",
"spermatogenic failure 34",
"spermatogenic failure 35",
"spermatogenic failure 36",
"spermatogenic failure 37",
"spermatogenic failure 38",
"spermatogenic failure 38  mondo:0032748",
"spermatogenic failure 39",
"spermatogenic failure 39  mondo:0032845",
"spermatogenic failure 4",
"spermatogenic failure 40",
"spermatogenic failure 41",
"spermatogenic failure 42",
"spermatogenic failure 43",
"spermatogenic failure 44",
"spermatogenic failure 45",
"spermatogenic failure 46",
"spermatogenic failure 46  mondo:0033673",
"spermatogenic failure 47",
"spermatogenic failure 48",
"spermatogenic failure 49",
"spermatogenic failure 5",
"spermatogenic failure 51",
"spermatogenic failure 52",
"spermatogenic failure 53",
"spermatogenic failure 54",
"spermatogenic failure 57",
"spermatogenic failure 6",
"spermatogenic failure 63",
"spermatogenic failure 68",
"spermatogenic failure 7",
"spermatogenic failure 78",
"spermatogenic failure 8",
"spermatogenic failure 84",
"spermatogenic failure 9",
"spermatogenic failure 90",
"spermatogenic failure 92",
"spermatogenic failure, susceptibility to",
"spermatogenic failure, x linked, 2",
"spermatogenic failure, x linked, 3",
"spermatogenic failure, x linked, 7",
"spermatogenic failure, x-linked, 3  mondo:0025354",
"spermatogenic failure, y linked, 2",
"spherocytosis, type 1",
"spherocytosis, type 2",
"spherocytosis, type 3",
"spherocytosis, type 4",
"spherocytosis, type 5",
"spina bifida, susceptibility to",
"spinal and bulbar muscular atrophy of kennedy",
"spinal muscular atrophy 1",
"spinal muscular atrophy 2",
"spinal muscular atrophy 3",
"spinal muscular atrophy 4",
"spinal muscular atrophy with congenital bone fractures 1",
"spinal muscular atrophy with congenital bone fractures 2",
"spinal muscular atrophy with progressive myoclonic epilepsy",
"spinal muscular atrophy, distal, autosomal recessive, 2",
"spinal muscular atrophy, distal, autosomal recessive, 4",
"spinal muscular atrophy, distal, autosomal recessive, 5",
"spinal muscular atrophy, distal, x linked 3",
"spinal muscular atrophy, infantile, james type",
"spinal muscular atrophy, jokela type",
"spinal muscular atrophy, late onset, finkel type",
"spinal muscular atrophy, lower extremity predominant 1, ad",
"spinal muscular atrophy, lower extremity predominant, 2a, autosomal dominant",
"spinal muscular atrophy, lower extremity predominant, 2b, autosomal dominant",
"spinal muscular atrophy, type iii, modifier of",
"spinal muscular atrophy, x linked 2, infantile",
"spinocerebellar ataxia 1",
"spinocerebellar ataxia 10",
"spinocerebellar ataxia 11",
"spinocerebellar ataxia 12",
"spinocerebellar ataxia 13",
"spinocerebellar ataxia 14",
"spinocerebellar ataxia 15",
"spinocerebellar ataxia 17",
"spinocerebellar ataxia 19",
"spinocerebellar ataxia 2",
"spinocerebellar ataxia 21",
"spinocerebellar ataxia 23",
"spinocerebellar ataxia 26",
"spinocerebellar ataxia 27",
"spinocerebellar ataxia 28",
"spinocerebellar ataxia 29, congenital nonprogressive",
"spinocerebellar ataxia 31",
"spinocerebellar ataxia 34",
"spinocerebellar ataxia 35",
"spinocerebellar ataxia 36",
"spinocerebellar ataxia 37",
"spinocerebellar ataxia 38",
"spinocerebellar ataxia 40",
"spinocerebellar ataxia 41",
"spinocerebellar ataxia 42",
"spinocerebellar ataxia 42, early onset, severe, with neurodevelopmental deficits",
"spinocerebellar ataxia 43",
"spinocerebellar ataxia 44",
"spinocerebellar ataxia 45",
"spinocerebellar ataxia 46",
"spinocerebellar ataxia 47",
"spinocerebellar ataxia 48",
"spinocerebellar ataxia 5",
"spinocerebellar ataxia 6",
"spinocerebellar ataxia 7",
"spinocerebellar ataxia 8",
"spinocerebellar ataxia type 2  mondo:0008458",
"spinocerebellar ataxia type 29  mondo:0007298",
"spinocerebellar ataxia, autosomal recessive 10",
"spinocerebellar ataxia, autosomal recessive 11",
"spinocerebellar ataxia, autosomal recessive 12",
"spinocerebellar ataxia, autosomal recessive 13",
"spinocerebellar ataxia, autosomal recessive 14",
"spinocerebellar ataxia, autosomal recessive 15",
"spinocerebellar ataxia, autosomal recessive 16",
"spinocerebellar ataxia, autosomal recessive 17",
"spinocerebellar ataxia, autosomal recessive 18",
"spinocerebellar ataxia, autosomal recessive 2",
"spinocerebellar ataxia, autosomal recessive 20",
"spinocerebellar ataxia, autosomal recessive 21",
"spinocerebellar ataxia, autosomal recessive 22",
"spinocerebellar ataxia, autosomal recessive 23",
"spinocerebellar ataxia, autosomal recessive 24",
"spinocerebellar ataxia, autosomal recessive 25",
"spinocerebellar ataxia, autosomal recessive 25  mondo:0033115",
"spinocerebellar ataxia, autosomal recessive 26",
"spinocerebellar ataxia, autosomal recessive 27",
"spinocerebellar ataxia, autosomal recessive 28",
"spinocerebellar ataxia, autosomal recessive 31  mondo:0030323",
"spinocerebellar ataxia, autosomal recessive 4",
"spinocerebellar ataxia, autosomal recessive 7",
"spinocerebellar ataxia, autosomal recessive 8",
"spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 1",
"spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 2",
"spinocerebellar ataxia, autosomal recessive, with axonal neuropathy 3",
"spinocerebellar ataxia, x linked 1",
"spitz nevus or nevus spilus, somatic",
"split foot malformation with mesoaxial polydactyly",
"split hand/foot malformation 1",
"split hand/foot malformation 1 with sensorineural hearing loss",
"split hand/foot malformation 4",
"split hand/foot malformation 6",
"spondylo megaepiphyseal metaphyseal dysplasia",
"spondyloarthropathy, susceptibility to, 1",
"spondylocarpotarsal synostosis syndrome",
"spondylocostal dysostosis 1, autosomal recessive",
"spondylocostal dysostosis 2, autosomal recessive",
"spondylocostal dysostosis 3, autosomal recessive",
"spondylocostal dysostosis 4, autosomal recessive",
"spondylocostal dysostosis 5",
"spondylocostal dysostosis 6",
"spondyloenchondrodysplasia with immune dysregulation",
"spondyloepimetaphyseal dysplasia",
"spondyloepimetaphyseal dysplasia with joint laxity, type 1, with or without fractures",
"spondyloepimetaphyseal dysplasia with joint laxity, type 2",
"spondyloepimetaphyseal dysplasia with joint laxity, type 3",
"spondyloepimetaphyseal dysplasia, aggrecan type",
"spondyloepimetaphyseal dysplasia, borochowitz cormier daire type",
"spondyloepimetaphyseal dysplasia, camera genevieve type",
"spondyloepimetaphyseal dysplasia, di rocco type",
"spondyloepimetaphyseal dysplasia, faden alkuraya type",
"spondyloepimetaphyseal dysplasia, krakow type",
"spondyloepimetaphyseal dysplasia, missouri type",
"spondyloepimetaphyseal dysplasia, shohat type",
"spondyloepimetaphyseal dysplasia, sponastrime type",
"spondyloepimetaphyseal dysplasia, x linked",
"spondyloepimetaphyseal dysplasia, x linked, with hypomyelinating leukodystrophy",
"spondyloepimetaphyseal dysplasia-short limb-abnormal calcification syndrome  mondo:0010077",
"spondyloepiphyseal dysplasia congenita  mondo:0008471",
"spondyloepiphyseal dysplasia tarda",
"spondyloepiphyseal dysplasia with congenital joint dislocations",
"spondyloepiphyseal dysplasia with metatarsal shortening  mondo:0012206",
"spondyloepiphyseal dysplasia, kimberley type",
"spondyloepiphyseal dysplasia, kondo fu type",
"spondyloepiphyseal dysplasia, kondo-fu type  mondo:0032721",
"spondyloepiphyseal dysplasia, nishimura type",
"spondyloepiphyseal dysplasia, sensorineural hearing loss, intellectual developmental disorder, and leber congenital amaurosis",
"spondyloepiphyseal dysplasia, stanescu type",
"spondyloepiphyseal dysplasia, stanescu type  mondo:0014701",
"spondylometaepiphyseal dysplasia, short limb hand type",
"spondylometaphyseal dysplasia  mondo:0016763",
"spondylometaphyseal dysplasia with cone rod dystrophy",
"spondylometaphyseal dysplasia with corneal dystrophy",
"spondylometaphyseal dysplasia, 'corner fracture' type  mondo:0008479",
"spondylometaphyseal dysplasia, axial",
"spondylometaphyseal dysplasia, corner fracture type",
"spondylometaphyseal dysplasia, kozlowski type",
"spondylometaphyseal dysplasia, megarbane dagher melike type",
"spondylometaphyseal dysplasia, sedaghatian type",
"spondylometaphyseal dysplasia-cone-rod dystrophy syndrome  mondo:0012160",
"spondyloocular syndrome",
"spondyloperipheral dysplasia",
"spondyloperipheral dysplasia  mondo:0010078",
"spongiform encephalopathy with neuropsychiatric features",
"sprinting performance",
"squalene synthase deficiency",
"squamous cell carcinoma, burn scar related, somatic",
"squamous cell carcinoma, head and neck",
"squamous cell carcinoma, head and neck, somatic",
"srd5a3-congenital disorder of glycosylation  mondo:0012885",
"stankiewicz isidor syndrome",
"stankiewicz-isidor syndrome  mondo:0054591",
"stapes ankylosis with broad thumbs and toes",
"star syndrome",
"stargardt disease 1",
"stargardt disease 3",
"stargardt disease 3  mondo:0010819",
"stargardt disease 4",
"stat3-related early-onset multisystem autoimmune disease  mondo:0014414",
"steatocystoma multiplex",
"steel syndrome",
"sterol carrier protein 2 deficiency  mondo:0013391",
"stevens johnson syndrome, susceptibility to",
"stickler sydrome, type i, nonsyndromic ocular",
"stickler syndrome  mondo:0019354",
"stickler syndrome type 1  mondo:0007160",
"stickler syndrome, type i",
"stickler syndrome, type ii",
"stickler syndrome, type iv",
"stickler syndrome, type v",
"stiff skin syndrome",
"sting associated vasculopathy, infantile onset",
"stocco dos santos x linked mental retardation syndrome",
"stomatin deficient cryohydrocytosis with neurologic defects",
"stormorken syndrome",
"striatal degeneration, autosomal dominant",
"striatonigral degeneration, childhood onset",
"striatonigral degeneration, infantile",
"stroke, hemorrhagic",
"stroke, ischemic, susceptibility to",
"stroke, susceptibility to",
"stromme syndrome",
"structural brain anomalies with impaired intellectual development and craniosynostosis",
"structural congenital heart disease, multiple types - gata4  mondo:0100009",
"structural heart defects and renal anomalies syndrome",
"sturge weber syndrome, somatic, mosaic",
"stuttering, familial persistent, 1",
"stuve wiedemann syndrome/schwartz jampel type 2 syndrome",
"stüve-wiedemann syndrome  obsolete termmondo:0011108",
"subcortical laminal heterotopia, x linked",
"subcortical laminar heterotopia",
"sublingual nitroglycerin, susceptibility to poor response to",
"succinic semialdehyde dehydrogenase deficiency",
"succinic semialdehyde dehydrogenase deficiency  mondo:0010083",
"succinyl coa:3 oxoacid coa transferase deficiency",
"sucrase isomaltase deficiency, congenital",
"sudden cardiac failure, alcohol induced",
"sudden cardiac failure, infantile",
"sudden infant death syndrome, susceptibility to",
"sudden infant death with dysgenesis of the testes syndrome",
"suleiman el hattab syndrome",
"sulfide:quinone oxidoreductase deficiency",
"sulfite oxidase deficiency",
"sulfite oxidase deficiency due to molybdenum cofactor deficiency type a  mondo:0009643",
"sulfite oxidase deficiency due to molybdenum cofactor deficiency type b  mondo:0009644",
"sulfite oxidase deficiency due to molybdenum cofactor deficiency type c  mondo:0014212",
"superoxide dismutase, elevated extracellular",
"supranuclear palsy, progressive",
"supranuclear palsy, progressive atypical",
"supravalvar aortic stenosis",
"surfactant metabolism dysfunction, pulmonary, 1",
"surfactant metabolism dysfunction, pulmonary, 1  mondo:0009929",
"surfactant metabolism dysfunction, pulmonary, 2",
"surfactant metabolism dysfunction, pulmonary, 3",
"surfactant metabolism dysfunction, pulmonary, 4",
"surfactant metabolism dysfunction, pulmonary, 5",
"susceptibility to respiratory infections associated with cd8alpha chain mutation  mondo:0012161",
"sveinsson chorioretinal atrophy",
"sweat chloride elevation without cf",
"sweeney cox syndrome",
"sweeney-cox syndrome  mondo:0060592",
"symmetric circumferential skin creases, congenital, 1",
"symmetric circumferential skin creases, congenital, 2",
"symphalangism, proximal, 1a",
"symphalangism, proximal, 1b",
"syndactyly, mesoaxial synostotic, with phalangeal reduction",
"syndactyly, type iii",
"syndactyly, type iv",
"syndactyly, type v",
"syndromic complex neurodevelopmental disorder  mondo:0800439",
"syndromic constitutional thrombocytopenia  mondo:0018795",
"syndromic intellectual disability  mondo:0000508",
"syndromic x-linked intellectual disability nascimento type  mondo:0010461",
"syndromic x-linked intellectual disability raymond type  mondo:0010427",
"syndromic x-linked intellectual disability siderius type  mondo:0010286",
"syndromic x-linked intellectual disability snyder type  mondo:0010664",
"synovitis, chronic, susceptibility to",
"synpolydactyly 1",
"synpolydactyly, 3/34, associated with metacarpal and metatarsal synostoses",
"systemic lupus erythematosus  mondo:0007915",
"systemic lupus erythematosus 16",
"systemic lupus erythematosus susceptibility to",
"systemic lupus erythematosus, resistance to",
"systemic lupus erythematosus, susceptibility to",
"systemic lupus erythematosus, susceptibility to, 1",
"systemic lupus erythematosus, susceptibility to, 10",
"systemic lupus erythematosus, susceptibility to, 11",
"systemic lupus erythematosus, susceptibility to, 2",
"systemic lupus erythematosus, susceptibility to, 9",
"systemic primary carnitine deficiency disease  mondo:0008919",
"t cell acute lymphoblastic leukemia",
"t cell acute lymphoblastic leukemia, somatic",
"t cell immunodeficiency, congenital alopecia, and nail dystrophy",
"t cell immunodeficiency, recurrent infections, autoimmunity, and cardiac malformations",
"t cell lymphoma, subcutaneous panniculitis like",
"t cell lymphopenia, infantile, with or without nail dystrophy, autosomal dominant",
"t cell prolymphocytic leukemia, somatic",
"t-b+ severe combined immunodeficiency due to gamma chain deficiency  mondo:0010315",
"t-b+ severe combined immunodeficiency due to jak3 deficiency  mondo:0010938",
"t-cell immunodeficiency, congenital alopecia, and nail dystrophy  mondo:0011132",
"takenouchi kosaki syndrome",
"tangier disease",
"tarp syndrome",
"tarsal carpal coalition syndrome",
"tatton brown rahman syndrome",
"tatton-brown-rahman overgrowth syndrome  mondo:0014382",
"tay sachs disease",
"tay-sachs disease  mondo:0010100",
"tay-sachs disease ab variant  mondo:0010099",
"tcf12-related craniosynostosis  mondo:0014128",
"tcr-alpha-beta-positive t-cell deficiency  mondo:0014160",
"teebi hypertelorism syndrome 2  mondo:0030674",
"tek-related primary glaucoma  mondo:0800182",
"telangiectasia, hereditary hemorrhagic, type 1",
"telangiectasia, hereditary hemorrhagic, type 1  mondo:0008535",
"telangiectasia, hereditary hemorrhagic, type 2",
"telangiectasia, hereditary hemorrhagic, type 2  mondo:0010880",
"telangiectasia, hereditary hemorrhagic, type 5",
"telangiectasia, hereditary hemorrhagic, type 5  mondo:0014217",
"telo2-related intellectual disability-neurodevelopmental disorder  mondo:0014848",
"temple baraitser syndrome",
"temtamy preaxial brachydactyly syndrome",
"temtamy syndrome",
"tenorio syndrome",
"terminal osseous dysplasia",
"tessadori-van haaften neurodevelopmental syndrome 3  mondo:0030993",
"testicular anomalies with or without congenital heart disease",
"testicular tumor, somatic",
"tetra amelia syndrome 1",
"tetraamelia syndrome 2",
"tetralogy of fallot",
"tfrc-related combined immunodeficiency  mondo:0014760",
"thalassemia beta, dominant inclusion body",
"thalassemia due to hb lepore",
"thalassemia, alpha",
"thalassemia, beta",
"thalassemia, delta",
"thalassemias, alpha",
"thanatophoric dysplasia type 1  mondo:0008546",
"thanatophoric dysplasia type 2  mondo:0008547",
"thanatophoric dysplasia, type i",
"thanatophoric dysplasia, type ii",
"thauvin robinet faivre syndrome",
"thiamine metabolism dysfunction syndrome 2 biotin  or thiamine responsive encephalopathy type 2",
"thiamine metabolism dysfunction syndrome 4 progressive polyneuropathy type",
"thiamine metabolism dysfunction syndrome 5 episodic encephalopathy type",
"thiamine responsive megaloblastic anemia syndrome",
"thiopurines, poor metabolism of, 1",
"thiopurines, poor metabolism of, 2",
"thoc6-related developmental delay-microcephaly-facial dysmorphism syndrome  mondo:0013362",
"thrombocythemia 1",
"thrombocythemia 1  mondo:0008554",
"thrombocythemia 2",
"thrombocythemia 2  mondo:0011173",
"thrombocythemia 3",
"thrombocythemia, somatic",
"thrombocytopenia 2",
"thrombocytopenia 2  mondo:0008555",
"thrombocytopenia 3",
"thrombocytopenia 3  mondo:0010120",
"thrombocytopenia 4",
"thrombocytopenia 4  mondo:0012775",
"thrombocytopenia 5",
"thrombocytopenia 5  mondo:0014536",
"thrombocytopenia 6",
"thrombocytopenia 6  mondo:0014837",
"thrombocytopenia 7  mondo:0030867",
"thrombocytopenia absent radius syndrome",
"thrombocytopenia with beta thalassemia, x linked",
"thrombocytopenia, anemia, and myelofibrosis",
"thrombocytopenia, anemia, and myelofibrosis  mondo:0044316",
"thrombocytopenia, autosomal dominant, 7",
"thrombocytopenia, congenital amegakaryocytic",
"thrombocytopenia, neonatal alloimmune",
"thrombocytopenia, neonatal alloimmune, bak antigen related",
"thrombocytopenia, x linked",
"thrombocytopenia, x linked, intermittent",
"thrombocytopenia, x linked, with or without dyserythropoietic anemia",
"thrombocytopenia-absent radius syndrome  mondo:0010121",
"thromboembolism, susceptibility to",
"thrombomodulin-related bleeding disorder  mondo:0013775",
"thrombophilia due to activated protein c resistance",
"thrombophilia due to activated protein c resistance  mondo:0008560",
"thrombophilia due to antithrombin iii deficiency",
"thrombophilia due to heparin cofactor ii deficiency",
"thrombophilia due to hrg deficiency",
"thrombophilia due to protein c deficiency, autosomal dominant",
"thrombophilia due to protein c deficiency, autosomal recessive",
"thrombophilia due to protein s deficiency, autosomal dominant",
"thrombophilia due to protein s deficiency, autosomal recessive",
"thrombophilia due to thrombin defect",
"thrombophilia due to thrombin defect  mondo:0008559",
"thrombophilia due to thrombomodulin defect",
"thrombophilia, familial, due to decreased release of plat",
"thrombophilia, familial, due to decreased release of tissue plasminogen activator  mondo:0012872",
"thrombophilia, susceptibility to, due to factor v leiden",
"thrombophilia, x linked, due to factor ix defect",
"thrombophilia, x-linked, due to factor 9 defect  mondo:0010432",
"thrombosis, hyperhomocysteinemic",
"thrombotic thrombocytopenic purpura, hereditary",
"thyroid adenoma, hyperfunctioning, somatic",
"thyroid cancer, nonmedullary, 1",
"thyroid cancer, nonmedullary, 2",
"thyroid cancer, nonmedullary, 4",
"thyroid cancer, nonmedullary, 5",
"thyroid carcinoma with thyrotoxicosis",
"thyroid carcinoma, follicular",
"thyroid carcinoma, follicular, somatic",
"thyroid carcinoma, hurthle cell",
"thyroid dyshormonogenesis 1",
"thyroid dyshormonogenesis 2a",
"thyroid dyshormonogenesis 3",
"thyroid dyshormonogenesis 4",
"thyroid dyshormonogenesis 5",
"thyroid dyshormonogenesis 6",
"thyroid hormone metabolism, abnormal",
"thyroid hormone resistance",
"thyroid hormone resistance, autosomal recessive",
"thyroid hormone resistance, selective pituitary",
"thyrotoxic periodic paralysis, susceptibility to, 1",
"thyrotoxic periodic paralysis, susceptibility to, 2",
"thyrotropin releasing hormone deficiency",
"thyroxine binding globulin qtl",
"tibial muscular dystrophy  mondo:0010870",
"tibial muscular dystrophy, tardive",
"tietz albinism deafness syndrome",
"timothy syndrome",
"timothy syndrome  mondo:0010979",
"tn polyagglutination syndrome, somatic",
"toenail dystrophy, isolated",
"tolbutamide poor metabolizer",
"tolchin le caignec syndrome",
"tonne kalscheuer syndrome",
"tooth agenesis, selective, 1  mondo:0007129",
"tooth agenesis, selective, 1, with or without orofacial cleft",
"tooth agenesis, selective, 3",
"tooth agenesis, selective, 4",
"tooth agenesis, selective, 7",
"tooth agenesis, selective, 8",
"tooth agenesis, selective, 9",
"tooth agenesis, selective, x linked 1",
"tourette syndrome",
"townes brocks branchiootorenal like syndrome",
"townes brocks syndrome 1",
"townes brocks syndrome 2",
"toxic epidermal necrolysis, susceptibility to",
"tpm2-related myopathy  mondo:0100196",
"tpm3-related myopathy  mondo:0100108",
"tpm4-related platelet disorder  mondo:0100487",
"traboulsi syndrome",
"traf3 haploinsufficiency  mondo:0100513",
"transaldolase deficiency",
"transcobalamin ii deficiency",
"transcription of plasminogen activator inhibitor, modulator of",
"transferrin serum level qtl2",
"transient bullous of the newborn",
"transposition of the great arteries, dextro looped 1",
"treacher collins syndrome 1",
"treacher collins syndrome 2",
"treacher collins syndrome 3",
"treacher collins syndrome 3  mondo:0009558",
"treacher collins syndrome 4",
"treacher-collins syndrome  mondo:0002457",
"trehalase deficiency",
"tremor, hereditary essential, 6",
"trex1-related type 1 interferonopathy  mondo:0700256",
"trichodontoosseous syndrome",
"trichoepithelioma, multiple familial, 1",
"trichohepatoenteric syndrome 1  mondo:0024541",
"trichohepatoenteric syndrome 2  mondo:0013818",
"trichohepatoneurodevelopmental syndrome",
"trichomegaly",
"trichorhinophalangeal syndrome, type i",
"trichorhinophalangeal syndrome, type iii",
"trichothiodystrophy 1, photosensitive",
"trichothiodystrophy 2, photosensitive",
"trichothiodystrophy 3, photosensitive",
"trichothiodystrophy 4, nonphotosensitive",
"trichothiodystrophy 5, nonphotosensitive",
"trichothiodystrophy 6, nonphotosensitive",
"trichothiodystrophy 7, nonphotosensitive",
"trichotillomania",
"trifunctional protein deficiency",
"trigonocephaly 1",
"trigonocephaly 2",
"trimethylaminuria",
"trimethylaminuria  mondo:0011182",
"triokinase and fmn cyclase deficiency syndrome",
"trip11-related skeletal dysplasia  mondo:1040009",
"triphalangeal thumb polysyndactyly syndrome",
"triphalangeal thumb, type i",
"trismus pseudocamptodactyly syndrome",
"tropical calcific pancreatitis",
"troyer syndrome",
"troyer syndrome  mondo:0010156",
"trpm1-related retinopathy  mondo:0800402",
"trpv4-related bone disorder  mondo:0018240",
"tsc2 angiomyolipomas, renal, modifier of",
"tspan12-related exudative vitreoretinopathy  mondo:0700231",
"ttn-related myopathy  mondo:0100175",
"tubb3-related tubulinopathy  mondo:0100154",
"tubb4a-related neurologic disorder  mondo:0800470",
"tuberculosis infection, protection against",
"tuberculosis, protection against",
"tuberculosis, susceptibility to",
"tuberous sclerosis  mondo:0001734",
"tuberous sclerosis 1",
"tuberous sclerosis 2",
"tubular aggregate myopathy  mondo:0008051",
"tubulinopathy  mondo:0100153",
"tubulointerstitial kidney disease, autosomal dominant, 1",
"tubulointerstitial kidney disease, autosomal dominant, 2",
"tubulointerstitial kidney disease, autosomal dominant, 2  mondo:0020726",
"tubulointerstitial kidney disease, autosomal dominant, 4",
"tubulointerstitial kidney disease, autosomal dominant, 5",
"tumor predisposition syndrome",
"tumor predisposition syndrome 2  mondo:0859267",
"tumoral calcinosis, familial, normophosphatemic",
"tumoral calcinosis, hyperphosphatemic, familial, 1",
"tumoral calcinosis, hyperphosphatemic, familial, 1  mondo:0100252",
"tumoral calcinosis, hyperphosphatemic, familial, 2",
"tumoral calcinosis, hyperphosphatemic, familial, 3",
"turnpenny fry syndrome",
"turnpenny-fry syndrome  mondo:0032707",
"twist1-related craniosynostosis  mondo:0007399",
"tylosis with esophageal cancer",
"type 1 diabetes mellitus",
"type 2 diabetes mellitus",
"type 2 diabetes mellitus, susceptibility to",
"tyrosine hydroxylase deficiency  mondo:0100064",
"tyrosinemia type i  mondo:0010161",
"tyrosinemia type ii  mondo:0010160",
"tyrosinemia type iii  mondo:0010162",
"tyrosinemia, type i",
"tyrosinemia, type ii",
"tyrosinemia, type iii",
"ullrich congenital muscular dystrophy 1",
"ullrich congenital muscular dystrophy 2",
"ulna and fibula, absence of, with severe limb deficiency",
"ulnar mammary syndrome",
"uncombable hair syndrome",
"uncombable hair syndrome 2",
"uncombable hair syndrome 3",
"undetermined early-onset epileptic encephalopathy  mondo:0018614",
"unipolar depression, susceptibility to",
"unverricht-lundborg syndrome  mondo:0009698",
"urate oxidase deficiency",
"urbach wiethe disease",
"uric acid concentration, serum, qtl 2",
"uric acid concentration, serum, qtl1",
"uric acid concentration, serum, qtl4",
"uridine cytidineuria",
"urocanase deficiency",
"urocanic aciduria  mondo:0010167",
"urod-related inherited porphyria  mondo:0100498",
"urofacial syndrome 1",
"urofacial syndrome 2",
"uruguay faciocardiomusculoskeletal syndrome",
"usher syndrome type 1  mondo:0010168",
"usher syndrome type 2  mondo:0016484",
"usher syndrome type 2d  mondo:0012662",
"usher syndrome type 3  mondo:0016485",
"usher syndrome type 3b",
"usher syndrome, type 1b",
"usher syndrome, type 1c",
"usher syndrome, type 1d",
"usher syndrome, type 1d/f digenic",
"usher syndrome, type 1f",
"usher syndrome, type 1g",
"usher syndrome, type 1m",
"usher syndrome, type 2a",
"usher syndrome, type 2c",
"usher syndrome, type 2c, gpr98/pdzd7 digenic",
"usher syndrome, type 2d",
"usher syndrome, type 3a",
"usher syndrome, type iic, gpr98/pdzd7 digenic",
"usher syndrome, type ij",
"usher syndrome, type iv",
"uv induced skin damage",
"uv sensitive syndrome 1",
"uv sensitive syndrome 2",
"uv sensitive syndrome 3",
"vacterl association, x linked",
"van buchem disease, type 2",
"van den ende gupta syndrome",
"van der woude syndrome",
"van der woude syndrome 2",
"van esch odriscoll syndrome",
"van maldergem syndrome  mondo:0017813",
"van maldergem syndrome 1",
"van maldergem syndrome 2",
"variegate porphyria  mondo:0008297",
"vascular disease, susceptibility to",
"vascular malformation, primary intraosseous",
"vasculitis, autoinflammation, immunodeficiency, and hematologic defects syndrome",
"vasculopathy, retinal, with cerebral leukoencephalopathy and systemic manifestations",
"velocardiofacial syndrome",
"venous malformations, multiple cutaneous and mucosal",
"venous thromboembolism, susceptibility to",
"venous thrombosis, protection against",
"ventricular fibrillation, familial, 1",
"ventricular fibrillation, paroxysmal familial, 2",
"ventricular septal defect 1",
"ventricular septal defect 2",
"ventricular septal defect 3",
"ventricular tachycardia, catecholaminergic polymorphic 6",
"ventricular tachycardia, catecholaminergic polymorphic, 1",
"ventricular tachycardia, catecholaminergic polymorphic, 2",
"ventricular tachycardia, catecholaminergic polymorphic, 3",
"ventricular tachycardia, catecholaminergic polymorphic, 4",
"ventricular tachycardia, catecholaminergic polymorphic, 5, with or without muscle weakness",
"ventricular tachycardia, idiopathic",
"ventriculomegaly and arthrogryposis  mondo:0859184",
"ventriculomegaly with cystic kidney disease",
"verheij syndrome",
"vertebral anomalies and variable endocrine and t cell dysfunction",
"vertebral hypersegmentation and orofacial anomalies",
"vertebral, cardiac, renal, and limb defects syndrome 1",
"vertebral, cardiac, renal, and limb defects syndrome 1  mondo:0060554",
"vertebral, cardiac, renal, and limb defects syndrome 2",
"vertebral, cardiac, renal, and limb defects syndrome 2  mondo:0060555",
"vertebral, cardiac, renal, and limb defects syndrome 3",
"vertebral, cardiac, tracheoesophageal, renal, and limb defects",
"vertical talus, congenital",
"ververi brady syndrome",
"very long chain acyl-coa dehydrogenase deficiency  mondo:0008723",
"vesicoureteral reflux 2",
"vesicoureteral reflux 3",
"vesicoureteral reflux 8",
"vexas syndrome, somatic",
"vibratory urticaria",
"vici syndrome",
"vici syndrome  mondo:0009452",
"visceral heterotaxy  mondo:0018677",
"visceral myopathy",
"vissers bodmer syndrome",
"visual impairment and progressive phthisis bulbi",
"vitamin b12 plasma level qtl1",
"vitamin d dependent rickets, type 3",
"vitamin d dependent rickets, type i",
"vitamin k dependent clotting factors, combined deficiency of, 1",
"vitamin k dependent clotting factors, combined deficiency of, 2",
"vitamin k-dependent clotting factors, combined deficiency of, type 1  mondo:0010187",
"vitamin k-dependent clotting factors, combined deficiency of, type 2  mondo:0011837",
"vitelliform macular dystrophy 4  mondo:0014508",
"vitiligo associated multiple autoimmune disease susceptibility 1",
"vitreoretinochoroidopathy",
"vitreoretinopathy with phalangeal epiphyseal dysplasia",
"vitreoretinopathy, neovascular inflammatory",
"vlcad deficiency",
"vohwinkel syndrome",
"vohwinkel syndrome with ichthyosis",
"von hippel lindau syndrome",
"von hippel lindau syndrome, modifier of",
"von hippel-lindau disease  mondo:0008667",
"von willebrand disease type 2b  mondo:0015629",
"von willebrand disease, platelet type",
"von willebrand disease, type 1",
"von willebrand disease, type 3",
"von willebrand disease, types 2a, 2b, 2m, and 2n",
"vulto van silfout de vries syndrome",
"waardenburg syndrome  mondo:0018094",
"waardenburg syndrome type 2  mondo:0019517",
"waardenburg syndrome type 4a  mondo:0010192",
"waardenburg syndrome type 4b  mondo:0013201",
"waardenburg syndrome type 4c  mondo:0013202",
"waardenburg syndrome, type 1",
"waardenburg syndrome, type 2a",
"waardenburg syndrome, type 2d",
"waardenburg syndrome, type 2e, with or without neurologic involvement",
"waardenburg syndrome, type 3",
"waardenburg syndrome, type 4a",
"waardenburg syndrome, type 4b",
"waardenburg syndrome, type 4c",
"waardenburg syndrome/albinism, digenic",
"waardenburg syndrome/ocular albinism, digenic",
"wagner disease  mondo:0007740",
"wagner syndrome 1",
"waisman syndrome",
"warburg cinotti syndrome",
"warburg micro syndrome  mondo:0016649",
"warburg micro syndrome 1",
"warburg micro syndrome 2",
"warburg micro syndrome 3",
"warburg micro syndrome 4",
"warburg-cinotti syndrome  mondo:0032579",
"warfarin resistance",
"warfarin sensitivity",
"warsaw breakage syndrome",
"watson syndrome",
"weaver syndrome",
"weaver syndrome  mondo:0010193",
"webb dattani syndrome",
"weill marchesani 4 syndrome, recessive",
"weill marchesani syndrome 1, recessive",
"weill marchesani syndrome 2, dominant",
"weill marchesani syndrome 3, recessive",
"weiss kruszka syndrome",
"weiss-kruszka syndrome  mondo:0032836",
"welander distal myopathy",
"werner syndrome",
"werner syndrome  mondo:0010196",
"west nile virus, susceptibility to",
"weyers acrofacial dysostosis",
"whim syndrome",
"whim syndrome  mondo:0023880",
"white blood cell count qtl",
"white sponge nevus 1",
"white sponge nevus 2",
"white sutton syndrome",
"wieacker wolff syndrome",
"wieacker wolff syndrome, female restricted",
"wiedemann rautenstrauch syndrome",
"wiedemann steiner syndrome",
"wiedemann-steiner syndrome  mondo:0011518",
"wilms tumor",
"wilms tumor 1  mondo:0008679",
"wilms tumor 6, susceptibility to",
"wilms tumor susceptibility 5",
"wilms tumor, somatic",
"wilms tumor, type 1",
"wilson disease",
"wilson disease  mondo:0010200",
"wilson turner syndrome",
"winchester syndrome",
"wiskott aldrich syndrome",
"wiskott aldrich syndrome 2",
"wiskott-aldrich syndrome  mondo:0010518",
"wiskott-aldrich syndrome 2  mondo:0013779",
"witteveen kolk syndrome",
"wolcott rallison syndrome",
"wolff parkinson white syndrome",
"wolfram like syndrome, autosomal dominant",
"wolfram syndrome  mondo:0018105",
"wolfram syndrome 1",
"wolfram syndrome 2",
"wolfram-like syndrome  mondo:0013673",
"wolman disease",
"woodhouse sakati syndrome",
"woodhouse-sakati syndrome  mondo:0009419",
"woolly hair, autosomal dominant",
"woolly hair, autosomal recessive 1, with or without hypotrichosis",
"woolly hair, autosomal recessive 2 with or without hypotrichosis",
"woolly hair, autosomal recessive 3",
"wrinkly skin syndrome",
"x inactivation, familial skewed",
"x-linked chondrodysplasia punctata 1  mondo:0010555",
"x-linked complex neurodevelopmental disorder  mondo:0100148",
"x-linked distal spinal muscular atrophy type 3  mondo:0010338",
"x-linked erythropoietic protoporphyria  mondo:0010420",
"x-linked hereditary sensory and autonomic neuropathy with hearing loss  mondo:0010378",
"x-linked intellectual disability  mondo:0100284",
"x-linked intellectual disability, cabezas type  mondo:0010306",
"x-linked intellectual disability-cerebellar hypoplasia syndrome  mondo:0010337",
"x-linked myotubular myopathy  mondo:0010683",
"x-linked opitz g/bbb syndrome  mondo:0010222",
"x-linked retinoschisis  mondo:0010725",
"x-linked severe congenital neutropenia  mondo:0010294",
"x-linked syndromic intellectual disability  mondo:0020119",
"xanthinuria type ii  mondo:0011346",
"xanthinuria, type i",
"xanthinuria, type ii",
"xeroderma pigmentosum group a  mondo:0010210",
"xeroderma pigmentosum group b  mondo:0012531",
"xeroderma pigmentosum group c  mondo:0010211",
"xeroderma pigmentosum group d  mondo:0010212",
"xeroderma pigmentosum group e  mondo:0010213",
"xeroderma pigmentosum group f  mondo:0010215",
"xeroderma pigmentosum group g  mondo:0010216",
"xeroderma pigmentosum variant type  mondo:0010214",
"xeroderma pigmentosum, group a",
"xeroderma pigmentosum, group b",
"xeroderma pigmentosum, group c",
"xeroderma pigmentosum, group d",
"xeroderma pigmentosum, group e, ddb negative subtype",
"xeroderma pigmentosum, group f",
"xeroderma pigmentosum, group g",
"xeroderma pigmentosum, group g/cockayne syndrome",
"xeroderma pigmentosum, type f/cockayne syndrome",
"xeroderma pigmentosum, variant type",
"xfe progeroid syndrome",
"xia gibbs syndrome",
"yao syndrome",
"you hoover fong syndrome",
"yunis varon syndrome",
"zimmermann laband syndrome 1",
"zimmermann laband syndrome 2",
"zimmermann laband syndrome 3",
"zinc deficiency, transient neonatal",
"zttk syndrome",
"zttk syndrome  mondo:0014936",]